import { ResponseContext, RequestContext, HttpFile, HttpInfo } from '../http/http';
import { Configuration, ConfigurationOptions, mergeConfiguration } from '../configuration'
import type { Middleware } from '../middleware';
import { Observable, of, from } from '../rxjsStub';
import {mergeMap, map} from  '../rxjsStub';
import { AddContactsInCvDto } from '../models/AddContactsInCvDto';
import { AdminCreateOrderDto } from '../models/AdminCreateOrderDto';
import { AdminLoginRequestDTO } from '../models/AdminLoginRequestDTO';
import { AdminLoginResponseDTO } from '../models/AdminLoginResponseDTO';
import { AdminOrderTransactionsPaginationDTO } from '../models/AdminOrderTransactionsPaginationDTO';
import { ArticleCategory } from '../models/ArticleCategory';
import { Asset } from '../models/Asset';
import { AssignPromoCodeQueryDto } from '../models/AssignPromoCodeQueryDto';
import { AuthProfileSessionCurrentDTO } from '../models/AuthProfileSessionCurrentDTO';
import { AuthProfileSessionDTO } from '../models/AuthProfileSessionDTO';
import { AuthProfileSessionPushDTO } from '../models/AuthProfileSessionPushDTO';
import { AuthProfileTokenDTO } from '../models/AuthProfileTokenDTO';
import { AuthResponseDTO } from '../models/AuthResponseDTO';
import { AuthVerificationCodeDTO } from '../models/AuthVerificationCodeDTO';
import { AuthVerificationResponseDTO } from '../models/AuthVerificationResponseDTO';
import { AuthVerificationVerifyDTO } from '../models/AuthVerificationVerifyDTO';
import { BackgroundCategory } from '../models/BackgroundCategory';
import { BannerFindManyControllerFindMany0200Response } from '../models/BannerFindManyControllerFindMany0200Response';
import { BannerItemContentDTO } from '../models/BannerItemContentDTO';
import { BannerItemContentSourceDTO } from '../models/BannerItemContentSourceDTO';
import { BannerItemCreateDTO } from '../models/BannerItemCreateDTO';
import { BannerItemDTO } from '../models/BannerItemDTO';
import { BannerItemProfileDTO } from '../models/BannerItemProfileDTO';
import { BannerItemUpdateDTO } from '../models/BannerItemUpdateDTO';
import { BannerPaginationResponseDTO } from '../models/BannerPaginationResponseDTO';
import { BannerResponseDTO } from '../models/BannerResponseDTO';
import { CallbackResponseDto } from '../models/CallbackResponseDto';
import { CharacterItem } from '../models/CharacterItem';
import { CharacterItemCategory } from '../models/CharacterItemCategory';
import { Course } from '../models/Course';
import { CreateDepositPassimPayRequestDto } from '../models/CreateDepositPassimPayRequestDto';
import { CreateManyAdminDto } from '../models/CreateManyAdminDto';
import { CreateManyApplicationDto } from '../models/CreateManyApplicationDto';
import { CreateManyArticleCategoryDto } from '../models/CreateManyArticleCategoryDto';
import { CreateManyAssetDto } from '../models/CreateManyAssetDto';
import { CreateManyBackgroundCategoryDto } from '../models/CreateManyBackgroundCategoryDto';
import { CreateManyBackgroundDto } from '../models/CreateManyBackgroundDto';
import { CreateManyCVDto } from '../models/CreateManyCVDto';
import { CreateManyCharacterDto } from '../models/CreateManyCharacterDto';
import { CreateManyCharacterItemCategoryDto } from '../models/CreateManyCharacterItemCategoryDto';
import { CreateManyCharacterItemDto } from '../models/CreateManyCharacterItemDto';
import { CreateManyChatDto } from '../models/CreateManyChatDto';
import { CreateManyChatMessageDto } from '../models/CreateManyChatMessageDto';
import { CreateManyChatMessageUrlDto } from '../models/CreateManyChatMessageUrlDto';
import { CreateManyCommunityDto } from '../models/CreateManyCommunityDto';
import { CreateManyCoverLetterDto } from '../models/CreateManyCoverLetterDto';
import { CreateManyFavouriteFolderDto } from '../models/CreateManyFavouriteFolderDto';
import { CreateManyFeedbackDto } from '../models/CreateManyFeedbackDto';
import { CreateManyGeoDto } from '../models/CreateManyGeoDto';
import { CreateManyGeonameDto } from '../models/CreateManyGeonameDto';
import { CreateManyPageHTMLBlockDto } from '../models/CreateManyPageHTMLBlockDto';
import { CreateManyPersonalPageDto } from '../models/CreateManyPersonalPageDto';
import { CreateManyProfileDto } from '../models/CreateManyProfileDto';
import { CreateManyProposalDto } from '../models/CreateManyProposalDto';
import { CreateManyServiceCategoryDto } from '../models/CreateManyServiceCategoryDto';
import { CreateManySkillDto } from '../models/CreateManySkillDto';
import { CreateManySourceDto } from '../models/CreateManySourceDto';
import { CreateManyStopWordDto } from '../models/CreateManyStopWordDto';
import { CreateManyVacancyDto } from '../models/CreateManyVacancyDto';
import { CreateManyVerticalDto } from '../models/CreateManyVerticalDto';
import { CreateOrderQueryDto } from '../models/CreateOrderQueryDto';
import { CreatePageJsonBlockDto } from '../models/CreatePageJsonBlockDto';
import { CreatePageJsonBlockTranslationDto } from '../models/CreatePageJsonBlockTranslationDto';
import { CreatePassimPayDepositResponseDto } from '../models/CreatePassimPayDepositResponseDto';
import { CreatePassimPayTestDepositResponseDto } from '../models/CreatePassimPayTestDepositResponseDto';
import { CreateProductDTO } from '../models/CreateProductDTO';
import { CreatePromoCodeQueryDto } from '../models/CreatePromoCodeQueryDto';
import { CreateTestDepositPassimPayOptionRequestDto } from '../models/CreateTestDepositPassimPayOptionRequestDto';
import { CreateTestDepositPassimPayRequestDto } from '../models/CreateTestDepositPassimPayRequestDto';
import { GetDepositLinkResponseDto } from '../models/GetDepositLinkResponseDto';
import { GetManyAdminResponseDto } from '../models/GetManyAdminResponseDto';
import { GetManyApplicationResponseDto } from '../models/GetManyApplicationResponseDto';
import { GetManyArticleCategoryResponseDto } from '../models/GetManyArticleCategoryResponseDto';
import { GetManyArticleResponseDto } from '../models/GetManyArticleResponseDto';
import { GetManyAssetResponseDto } from '../models/GetManyAssetResponseDto';
import { GetManyBackgroundCategoryResponseDto } from '../models/GetManyBackgroundCategoryResponseDto';
import { GetManyBackgroundResponseDto } from '../models/GetManyBackgroundResponseDto';
import { GetManyBaseAdminControllerAdmin200Response } from '../models/GetManyBaseAdminControllerAdmin200Response';
import { GetManyBaseApplicationAdminControllerApplication200Response } from '../models/GetManyBaseApplicationAdminControllerApplication200Response';
import { GetManyBaseArticleCategoryAdminControllerArticleCategory200Response } from '../models/GetManyBaseArticleCategoryAdminControllerArticleCategory200Response';
import { GetManyBaseArticleKnowledgeAdminControllerArticle200Response } from '../models/GetManyBaseArticleKnowledgeAdminControllerArticle200Response';
import { GetManyBaseAssetAdminControllerAsset200Response } from '../models/GetManyBaseAssetAdminControllerAsset200Response';
import { GetManyBaseBackgroundAdminControllerBackground200Response } from '../models/GetManyBaseBackgroundAdminControllerBackground200Response';
import { GetManyBaseBackgroundCategoryAdminControllerBackgroundCategory200Response } from '../models/GetManyBaseBackgroundCategoryAdminControllerBackgroundCategory200Response';
import { GetManyBaseCVAdminControllerCV200Response } from '../models/GetManyBaseCVAdminControllerCV200Response';
import { GetManyBaseCharacterAdminControllerCharacter200Response } from '../models/GetManyBaseCharacterAdminControllerCharacter200Response';
import { GetManyBaseCharacterItemAdminControllerCharacterItem200Response } from '../models/GetManyBaseCharacterItemAdminControllerCharacterItem200Response';
import { GetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory200Response } from '../models/GetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory200Response';
import { GetManyBaseChatAdminControllerChat200Response } from '../models/GetManyBaseChatAdminControllerChat200Response';
import { GetManyBaseChatMessageAdminControllerChatMessage200Response } from '../models/GetManyBaseChatMessageAdminControllerChatMessage200Response';
import { GetManyBaseChatMessageUrlControllerChatMessageUrl200Response } from '../models/GetManyBaseChatMessageUrlControllerChatMessageUrl200Response';
import { GetManyBaseCommunityAdminControllerCommunity200Response } from '../models/GetManyBaseCommunityAdminControllerCommunity200Response';
import { GetManyBaseCourseAuthorAdminControllerCourseAuthor200Response } from '../models/GetManyBaseCourseAuthorAdminControllerCourseAuthor200Response';
import { GetManyBaseCourseBlockAdminControllerCourseBlock200Response } from '../models/GetManyBaseCourseBlockAdminControllerCourseBlock200Response';
import { GetManyBaseCourseBlockStepAdminControllerCourseBlockStep200Response } from '../models/GetManyBaseCourseBlockStepAdminControllerCourseBlockStep200Response';
import { GetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer200Response } from '../models/GetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer200Response';
import { GetManyBaseCourseModuleAdminControllerCourseModule200Response } from '../models/GetManyBaseCourseModuleAdminControllerCourseModule200Response';
import { GetManyBaseCoverLetterAdminControllerCoverLetter200Response } from '../models/GetManyBaseCoverLetterAdminControllerCoverLetter200Response';
import { GetManyBaseFavouriteFolderAdminControllerFavouriteFolder200Response } from '../models/GetManyBaseFavouriteFolderAdminControllerFavouriteFolder200Response';
import { GetManyBaseFeedbackAdminControllerFeedback200Response } from '../models/GetManyBaseFeedbackAdminControllerFeedback200Response';
import { GetManyBaseGeoAdminControllerGeo200Response } from '../models/GetManyBaseGeoAdminControllerGeo200Response';
import { GetManyBaseLocationAdminControllerGeoname200Response } from '../models/GetManyBaseLocationAdminControllerGeoname200Response';
import { GetManyBaseManagerAdminControllerProfile200Response } from '../models/GetManyBaseManagerAdminControllerProfile200Response';
import { GetManyBasePageAdminControllerPageHTMLBlock200Response } from '../models/GetManyBasePageAdminControllerPageHTMLBlock200Response';
import { GetManyBasePaymentAdminControllerPaymentTransaction200Response } from '../models/GetManyBasePaymentAdminControllerPaymentTransaction200Response';
import { GetManyBasePersonalPageAdminControllerPersonalPage200Response } from '../models/GetManyBasePersonalPageAdminControllerPersonalPage200Response';
import { GetManyBaseProposalAdminControllerProposal200Response } from '../models/GetManyBaseProposalAdminControllerProposal200Response';
import { GetManyBaseServiceCategoryAdminControllerServiceCategory200Response } from '../models/GetManyBaseServiceCategoryAdminControllerServiceCategory200Response';
import { GetManyBaseSkillAdminControllerSkill200Response } from '../models/GetManyBaseSkillAdminControllerSkill200Response';
import { GetManyBaseSourceAdminControllerSource200Response } from '../models/GetManyBaseSourceAdminControllerSource200Response';
import { GetManyBaseStopWordAdminControllerStopWord200Response } from '../models/GetManyBaseStopWordAdminControllerStopWord200Response';
import { GetManyBaseStoryAdminControllerStory200Response } from '../models/GetManyBaseStoryAdminControllerStory200Response';
import { GetManyBaseStoryBlockAdminControllerStoryBlock200Response } from '../models/GetManyBaseStoryBlockAdminControllerStoryBlock200Response';
import { GetManyBaseVerticalAdminControllerVertical200Response } from '../models/GetManyBaseVerticalAdminControllerVertical200Response';
import { GetManyCVResponseDto } from '../models/GetManyCVResponseDto';
import { GetManyCharacterItemCategoryResponseDto } from '../models/GetManyCharacterItemCategoryResponseDto';
import { GetManyCharacterItemResponseDto } from '../models/GetManyCharacterItemResponseDto';
import { GetManyCharacterResponseDto } from '../models/GetManyCharacterResponseDto';
import { GetManyChatFolderResponseDto } from '../models/GetManyChatFolderResponseDto';
import { GetManyChatMessageResponseDto } from '../models/GetManyChatMessageResponseDto';
import { GetManyChatMessageUrlResponseDto } from '../models/GetManyChatMessageUrlResponseDto';
import { GetManyChatResponseDto } from '../models/GetManyChatResponseDto';
import { GetManyCommunityResponseDto } from '../models/GetManyCommunityResponseDto';
import { GetManyCourseAuthorResponseDto } from '../models/GetManyCourseAuthorResponseDto';
import { GetManyCourseBlockResponseDto } from '../models/GetManyCourseBlockResponseDto';
import { GetManyCourseBlockStepAnswerResponseDto } from '../models/GetManyCourseBlockStepAnswerResponseDto';
import { GetManyCourseBlockStepResponseDto } from '../models/GetManyCourseBlockStepResponseDto';
import { GetManyCourseModuleResponseDto } from '../models/GetManyCourseModuleResponseDto';
import { GetManyCourseResponseDto } from '../models/GetManyCourseResponseDto';
import { GetManyCoverLetterResponseDto } from '../models/GetManyCoverLetterResponseDto';
import { GetManyFavouriteFolderResponseDto } from '../models/GetManyFavouriteFolderResponseDto';
import { GetManyFeedbackResponseDto } from '../models/GetManyFeedbackResponseDto';
import { GetManyGeoResponseDto } from '../models/GetManyGeoResponseDto';
import { GetManyGeonameResponseDto } from '../models/GetManyGeonameResponseDto';
import { GetManyPageHTMLBlockResponseDto } from '../models/GetManyPageHTMLBlockResponseDto';
import { GetManyPaymentTransactionResponseDto } from '../models/GetManyPaymentTransactionResponseDto';
import { GetManyPersonalPageResponseDto } from '../models/GetManyPersonalPageResponseDto';
import { GetManyProfileResponseDto } from '../models/GetManyProfileResponseDto';
import { GetManyProposalResponseDto } from '../models/GetManyProposalResponseDto';
import { GetManyServiceCategoryResponseDto } from '../models/GetManyServiceCategoryResponseDto';
import { GetManySkillResponseDto } from '../models/GetManySkillResponseDto';
import { GetManySourceResponseDto } from '../models/GetManySourceResponseDto';
import { GetManyStopWordResponseDto } from '../models/GetManyStopWordResponseDto';
import { GetManyStoryBlockResponseDto } from '../models/GetManyStoryBlockResponseDto';
import { GetManyStoryResponseDto } from '../models/GetManyStoryResponseDto';
import { GetManyVacancyResponseDto } from '../models/GetManyVacancyResponseDto';
import { GetManyVerticalResponseDto } from '../models/GetManyVerticalResponseDto';
import { GetPaymentMethodsRequestDto } from '../models/GetPaymentMethodsRequestDto';
import { GetPaymentMethodsResponseDto } from '../models/GetPaymentMethodsResponseDto';
import { GetTransactionTotalAmountRequestDto } from '../models/GetTransactionTotalAmountRequestDto';
import { GetTransactionTotalAmountResponseDto } from '../models/GetTransactionTotalAmountResponseDto';
import { GiftPromotionAvailabilityDTO } from '../models/GiftPromotionAvailabilityDTO';
import { HealthControllerCheck0200Response } from '../models/HealthControllerCheck0200Response';
import { HealthControllerCheck0200ResponseInfoValue } from '../models/HealthControllerCheck0200ResponseInfoValue';
import { HealthControllerCheck0503Response } from '../models/HealthControllerCheck0503Response';
import { InfluenceCategoryControllerPaginate0200Response } from '../models/InfluenceCategoryControllerPaginate0200Response';
import { InfluenceCategoryDTO } from '../models/InfluenceCategoryDTO';
import { InfluenceDirectionControllerPaginate0200Response } from '../models/InfluenceDirectionControllerPaginate0200Response';
import { InfluenceDirectionDTO } from '../models/InfluenceDirectionDTO';
import { InfluencePlatformControllerPaginate0200Response } from '../models/InfluencePlatformControllerPaginate0200Response';
import { InfluencePlatformDTO } from '../models/InfluencePlatformDTO';
import { InfluenceResumeChannelCategoryDTO } from '../models/InfluenceResumeChannelCategoryDTO';
import { InfluenceResumeChannelDTO } from '../models/InfluenceResumeChannelDTO';
import { InfluenceResumeChannelDestroyDTO } from '../models/InfluenceResumeChannelDestroyDTO';
import { InfluenceResumeChannelMutableDTO } from '../models/InfluenceResumeChannelMutableDTO';
import { InfluenceResumeChannelPlatformDTO } from '../models/InfluenceResumeChannelPlatformDTO';
import { InfluenceResumeChannelPriceDTO } from '../models/InfluenceResumeChannelPriceDTO';
import { InfluenceResumeChannelPriceDestroyDTO } from '../models/InfluenceResumeChannelPriceDestroyDTO';
import { InfluenceResumeChannelPriceMutableDTO } from '../models/InfluenceResumeChannelPriceMutableDTO';
import { InfluenceResumeContactsDTO } from '../models/InfluenceResumeContactsDTO';
import { InfluenceResumeDTO } from '../models/InfluenceResumeDTO';
import { InfluenceResumePaginateControllerPaginate0200Response } from '../models/InfluenceResumePaginateControllerPaginate0200Response';
import { InfluenceResumeStatisticDTO } from '../models/InfluenceResumeStatisticDTO';
import { ManagerCreateDTO } from '../models/ManagerCreateDTO';
import { ManagerResponseDTO } from '../models/ManagerResponseDTO';
import { ManagerUpdateDTO } from '../models/ManagerUpdateDTO';
import { NotificationCustomContentDTO } from '../models/NotificationCustomContentDTO';
import { NotificationProfileCategoryDTO } from '../models/NotificationProfileCategoryDTO';
import { NotificationProfileCategorySettingsDTO } from '../models/NotificationProfileCategorySettingsDTO';
import { NotificationProfileDTO } from '../models/NotificationProfileDTO';
import { NotificationProfileProviderDTO } from '../models/NotificationProfileProviderDTO';
import { NotificationProfileProviderGenerateDTO } from '../models/NotificationProfileProviderGenerateDTO';
import { NotificationProfileProviderSettingsDTO } from '../models/NotificationProfileProviderSettingsDTO';
import { NotificationProfileProviderUnLinkDTO } from '../models/NotificationProfileProviderUnLinkDTO';
import { NotificationProfileReadDTO } from '../models/NotificationProfileReadDTO';
import { NotificationProfileRootDTO } from '../models/NotificationProfileRootDTO';
import { OrderEntity } from '../models/OrderEntity';
import { OrderTransactionEntity } from '../models/OrderTransactionEntity';
import { PageHTMLBlock } from '../models/PageHTMLBlock';
import { PageJsonBlock } from '../models/PageJsonBlock';
import { PageJsonBlockTranslation } from '../models/PageJsonBlockTranslation';
import { PaginationResponseDTO } from '../models/PaginationResponseDTO';
import { PaymentMethodDto } from '../models/PaymentMethodDto';
import { PaymentSystemDto } from '../models/PaymentSystemDto';
import { ProductEntity } from '../models/ProductEntity';
import { ProductEntityContents } from '../models/ProductEntityContents';
import { ProductLocalizationDTO } from '../models/ProductLocalizationDTO';
import { ProductLocalizationFeatureDTO } from '../models/ProductLocalizationFeatureDTO';
import { ProductProfileContentDTO } from '../models/ProductProfileContentDTO';
import { ProductVacancyContentDTO } from '../models/ProductVacancyContentDTO';
import { ProfileAdminFindManyControllerFindMany0200Response } from '../models/ProfileAdminFindManyControllerFindMany0200Response';
import { ProfileCityDTO } from '../models/ProfileCityDTO';
import { ProfileCountryDTO } from '../models/ProfileCountryDTO';
import { ProfileItemDTO } from '../models/ProfileItemDTO';
import { ProfileResponseDTO } from '../models/ProfileResponseDTO';
import { ProfileStatsDTO } from '../models/ProfileStatsDTO';
import { ProfileStatsDTONewCVsCount } from '../models/ProfileStatsDTONewCVsCount';
import { ProfileStatsDTONewVacanciesCount } from '../models/ProfileStatsDTONewVacanciesCount';
import { ProfileStatsDTOResponsesCount } from '../models/ProfileStatsDTOResponsesCount';
import { ProfileStatsDTOViewsCount } from '../models/ProfileStatsDTOViewsCount';
import { ProfileUpdateDTO } from '../models/ProfileUpdateDTO';
import { PromoCodeListQueryPaginationDTO } from '../models/PromoCodeListQueryPaginationDTO';
import { PromoCodeListResponseDto } from '../models/PromoCodeListResponseDto';
import { PromoCodeResponseDto } from '../models/PromoCodeResponseDto';
import { QueryFilterDTO } from '../models/QueryFilterDTO';
import { QuerySortDTO } from '../models/QuerySortDTO';
import { ServiceCategory } from '../models/ServiceCategory';
import { UpdatePageJsonBlockDto } from '../models/UpdatePageJsonBlockDto';
import { UpdateProductDTO } from '../models/UpdateProductDTO';
import { UpdatePromoCodeQueryDto } from '../models/UpdatePromoCodeQueryDto';
import { UtilsProfileCompletedDTO } from '../models/UtilsProfileCompletedDTO';
import { VacancyBodyDTO } from '../models/VacancyBodyDTO';
import { VacancyPaginationDTO } from '../models/VacancyPaginationDTO';
import { VacancyQueryManyDTO } from '../models/VacancyQueryManyDTO';
import { VacancyQueryStatsDTO } from '../models/VacancyQueryStatsDTO';

import { ADMINAdminUsersApiRequestFactory, ADMINAdminUsersApiResponseProcessor} from "../apis/ADMINAdminUsersApi";
export class ObservableADMINAdminUsersApi {
    private requestFactory: ADMINAdminUsersApiRequestFactory;
    private responseProcessor: ADMINAdminUsersApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINAdminUsersApiRequestFactory,
        responseProcessor?: ADMINAdminUsersApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINAdminUsersApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINAdminUsersApiResponseProcessor();
    }

    /**
     * Create multiple Admins
     * @param createManyAdminDto
     */
    public createManyBaseAdminControllerAdminWithHttpInfo(createManyAdminDto: CreateManyAdminDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseAdminControllerAdmin(createManyAdminDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseAdminControllerAdminWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Admins
     * @param createManyAdminDto
     */
    public createManyBaseAdminControllerAdmin(createManyAdminDto: CreateManyAdminDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseAdminControllerAdminWithHttpInfo(createManyAdminDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Admin
     * @param body
     */
    public createOneBaseAdminControllerAdminWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseAdminControllerAdmin(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseAdminControllerAdminWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Admin
     * @param body
     */
    public createOneBaseAdminControllerAdmin(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseAdminControllerAdminWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Admin
     * @param id
     */
    public deleteOneBaseAdminControllerAdminWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseAdminControllerAdmin(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseAdminControllerAdminWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Admin
     * @param id
     */
    public deleteOneBaseAdminControllerAdmin(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseAdminControllerAdminWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Admins
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseAdminControllerAdminWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseAdminControllerAdmin200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseAdminControllerAdmin(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseAdminControllerAdminWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Admins
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseAdminControllerAdmin(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseAdminControllerAdmin200Response> {
        return this.getManyBaseAdminControllerAdminWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseAdminControllerAdmin200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Admin
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseAdminControllerAdminWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseAdminControllerAdmin(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseAdminControllerAdminWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Admin
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseAdminControllerAdmin(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseAdminControllerAdminWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Admin
     * @param id
     * @param body
     */
    public replaceOneBaseAdminControllerAdminWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseAdminControllerAdmin(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseAdminControllerAdminWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Admin
     * @param id
     * @param body
     */
    public replaceOneBaseAdminControllerAdmin(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseAdminControllerAdminWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Admin
     * @param id
     * @param body
     */
    public updateOneBaseAdminControllerAdminWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseAdminControllerAdmin(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseAdminControllerAdminWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Admin
     * @param id
     * @param body
     */
    public updateOneBaseAdminControllerAdmin(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseAdminControllerAdminWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINApplicationItemsApiRequestFactory, ADMINApplicationItemsApiResponseProcessor} from "../apis/ADMINApplicationItemsApi";
export class ObservableADMINApplicationItemsApi {
    private requestFactory: ADMINApplicationItemsApiRequestFactory;
    private responseProcessor: ADMINApplicationItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINApplicationItemsApiRequestFactory,
        responseProcessor?: ADMINApplicationItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINApplicationItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINApplicationItemsApiResponseProcessor();
    }

    /**
     * Create multiple Applications
     * @param createManyApplicationDto
     */
    public createManyBaseApplicationAdminControllerApplicationWithHttpInfo(createManyApplicationDto: CreateManyApplicationDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseApplicationAdminControllerApplication(createManyApplicationDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseApplicationAdminControllerApplicationWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Applications
     * @param createManyApplicationDto
     */
    public createManyBaseApplicationAdminControllerApplication(createManyApplicationDto: CreateManyApplicationDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseApplicationAdminControllerApplicationWithHttpInfo(createManyApplicationDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Application
     * @param body
     */
    public createOneBaseApplicationAdminControllerApplicationWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseApplicationAdminControllerApplication(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseApplicationAdminControllerApplicationWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Application
     * @param body
     */
    public createOneBaseApplicationAdminControllerApplication(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseApplicationAdminControllerApplicationWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Application
     * @param id
     */
    public deleteOneBaseApplicationAdminControllerApplicationWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseApplicationAdminControllerApplication(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseApplicationAdminControllerApplicationWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Application
     * @param id
     */
    public deleteOneBaseApplicationAdminControllerApplication(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseApplicationAdminControllerApplicationWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Applications
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseApplicationAdminControllerApplicationWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseApplicationAdminControllerApplication200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseApplicationAdminControllerApplication(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseApplicationAdminControllerApplicationWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Applications
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseApplicationAdminControllerApplication(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseApplicationAdminControllerApplication200Response> {
        return this.getManyBaseApplicationAdminControllerApplicationWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseApplicationAdminControllerApplication200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Application
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseApplicationAdminControllerApplicationWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseApplicationAdminControllerApplication(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseApplicationAdminControllerApplicationWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Application
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseApplicationAdminControllerApplication(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseApplicationAdminControllerApplicationWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Application
     * @param id
     * @param body
     */
    public replaceOneBaseApplicationAdminControllerApplicationWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseApplicationAdminControllerApplication(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseApplicationAdminControllerApplicationWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Application
     * @param id
     * @param body
     */
    public replaceOneBaseApplicationAdminControllerApplication(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseApplicationAdminControllerApplicationWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Application
     * @param id
     * @param body
     */
    public updateOneBaseApplicationAdminControllerApplicationWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseApplicationAdminControllerApplication(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseApplicationAdminControllerApplicationWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Application
     * @param id
     * @param body
     */
    public updateOneBaseApplicationAdminControllerApplication(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseApplicationAdminControllerApplicationWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINArticleCategoriesApiRequestFactory, ADMINArticleCategoriesApiResponseProcessor} from "../apis/ADMINArticleCategoriesApi";
export class ObservableADMINArticleCategoriesApi {
    private requestFactory: ADMINArticleCategoriesApiRequestFactory;
    private responseProcessor: ADMINArticleCategoriesApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINArticleCategoriesApiRequestFactory,
        responseProcessor?: ADMINArticleCategoriesApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINArticleCategoriesApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINArticleCategoriesApiResponseProcessor();
    }

    /**
     * Create multiple ArticleCategories
     * @param createManyArticleCategoryDto
     */
    public createManyBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(createManyArticleCategoryDto: CreateManyArticleCategoryDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<ArticleCategory>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseArticleCategoryAdminControllerArticleCategory(createManyArticleCategoryDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple ArticleCategories
     * @param createManyArticleCategoryDto
     */
    public createManyBaseArticleCategoryAdminControllerArticleCategory(createManyArticleCategoryDto: CreateManyArticleCategoryDto, _options?: ConfigurationOptions): Observable<Array<ArticleCategory>> {
        return this.createManyBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(createManyArticleCategoryDto, _options).pipe(map((apiResponse: HttpInfo<Array<ArticleCategory>>) => apiResponse.data));
    }

    /**
     * Create a single ArticleCategory
     * @param articleCategory
     */
    public createOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseArticleCategoryAdminControllerArticleCategory(articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single ArticleCategory
     * @param articleCategory
     */
    public createOneBaseArticleCategoryAdminControllerArticleCategory(articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.createOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Delete a single ArticleCategory
     * @param id
     */
    public deleteOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseArticleCategoryAdminControllerArticleCategory(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single ArticleCategory
     * @param id
     */
    public deleteOneBaseArticleCategoryAdminControllerArticleCategory(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseArticleCategoryAdminControllerArticleCategory(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleCategoryAdminControllerArticleCategory(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response> {
        return this.getManyBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single ArticleCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseArticleCategoryAdminControllerArticleCategory(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single ArticleCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleCategoryAdminControllerArticleCategory(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.getOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Replace a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public replaceOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseArticleCategoryAdminControllerArticleCategory(id, articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public replaceOneBaseArticleCategoryAdminControllerArticleCategory(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.replaceOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(id, articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Update a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public updateOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseArticleCategoryAdminControllerArticleCategory(id, articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public updateOneBaseArticleCategoryAdminControllerArticleCategory(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.updateOneBaseArticleCategoryAdminControllerArticleCategoryWithHttpInfo(id, articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

}

import { ADMINArticleCategoryKnowledgeApiRequestFactory, ADMINArticleCategoryKnowledgeApiResponseProcessor} from "../apis/ADMINArticleCategoryKnowledgeApi";
export class ObservableADMINArticleCategoryKnowledgeApi {
    private requestFactory: ADMINArticleCategoryKnowledgeApiRequestFactory;
    private responseProcessor: ADMINArticleCategoryKnowledgeApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINArticleCategoryKnowledgeApiRequestFactory,
        responseProcessor?: ADMINArticleCategoryKnowledgeApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINArticleCategoryKnowledgeApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINArticleCategoryKnowledgeApiResponseProcessor();
    }

    /**
     * Create multiple ArticleCategories
     * @param createManyArticleCategoryDto
     */
    public createManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(createManyArticleCategoryDto: CreateManyArticleCategoryDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<ArticleCategory>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory(createManyArticleCategoryDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple ArticleCategories
     * @param createManyArticleCategoryDto
     */
    public createManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory(createManyArticleCategoryDto: CreateManyArticleCategoryDto, _options?: ConfigurationOptions): Observable<Array<ArticleCategory>> {
        return this.createManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(createManyArticleCategoryDto, _options).pipe(map((apiResponse: HttpInfo<Array<ArticleCategory>>) => apiResponse.data));
    }

    /**
     * Create a single ArticleCategory
     * @param articleCategory
     */
    public createOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single ArticleCategory
     * @param articleCategory
     */
    public createOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.createOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Delete a single ArticleCategory
     * @param id
     */
    public deleteOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single ArticleCategory
     * @param id
     */
    public deleteOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleCategoryKnowledgeAdminControllerArticleCategory(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response> {
        return this.getManyBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single ArticleCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single ArticleCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.getOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Replace a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public replaceOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(id, articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public replaceOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.replaceOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(id, articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Update a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public updateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(id, articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public updateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategory(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.updateOneBaseArticleCategoryKnowledgeAdminControllerArticleCategoryWithHttpInfo(id, articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

}

import { ADMINArticleCategoryNewsApiRequestFactory, ADMINArticleCategoryNewsApiResponseProcessor} from "../apis/ADMINArticleCategoryNewsApi";
export class ObservableADMINArticleCategoryNewsApi {
    private requestFactory: ADMINArticleCategoryNewsApiRequestFactory;
    private responseProcessor: ADMINArticleCategoryNewsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINArticleCategoryNewsApiRequestFactory,
        responseProcessor?: ADMINArticleCategoryNewsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINArticleCategoryNewsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINArticleCategoryNewsApiResponseProcessor();
    }

    /**
     * Create multiple ArticleCategories
     * @param createManyArticleCategoryDto
     */
    public createManyBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(createManyArticleCategoryDto: CreateManyArticleCategoryDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<ArticleCategory>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseArticleCategoryNewsAdminControllerArticleCategory(createManyArticleCategoryDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple ArticleCategories
     * @param createManyArticleCategoryDto
     */
    public createManyBaseArticleCategoryNewsAdminControllerArticleCategory(createManyArticleCategoryDto: CreateManyArticleCategoryDto, _options?: ConfigurationOptions): Observable<Array<ArticleCategory>> {
        return this.createManyBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(createManyArticleCategoryDto, _options).pipe(map((apiResponse: HttpInfo<Array<ArticleCategory>>) => apiResponse.data));
    }

    /**
     * Create a single ArticleCategory
     * @param articleCategory
     */
    public createOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseArticleCategoryNewsAdminControllerArticleCategory(articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single ArticleCategory
     * @param articleCategory
     */
    public createOneBaseArticleCategoryNewsAdminControllerArticleCategory(articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.createOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Delete a single ArticleCategory
     * @param id
     */
    public deleteOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseArticleCategoryNewsAdminControllerArticleCategory(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single ArticleCategory
     * @param id
     */
    public deleteOneBaseArticleCategoryNewsAdminControllerArticleCategory(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseArticleCategoryNewsAdminControllerArticleCategory(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleCategoryNewsAdminControllerArticleCategory(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response> {
        return this.getManyBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single ArticleCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseArticleCategoryNewsAdminControllerArticleCategory(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single ArticleCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleCategoryNewsAdminControllerArticleCategory(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.getOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Replace a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public replaceOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseArticleCategoryNewsAdminControllerArticleCategory(id, articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public replaceOneBaseArticleCategoryNewsAdminControllerArticleCategory(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.replaceOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(id, articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Update a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public updateOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseArticleCategoryNewsAdminControllerArticleCategory(id, articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public updateOneBaseArticleCategoryNewsAdminControllerArticleCategory(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.updateOneBaseArticleCategoryNewsAdminControllerArticleCategoryWithHttpInfo(id, articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

}

import { ADMINArticleItemsApiRequestFactory, ADMINArticleItemsApiResponseProcessor} from "../apis/ADMINArticleItemsApi";
export class ObservableADMINArticleItemsApi {
    private requestFactory: ADMINArticleItemsApiRequestFactory;
    private responseProcessor: ADMINArticleItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINArticleItemsApiRequestFactory,
        responseProcessor?: ADMINArticleItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINArticleItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINArticleItemsApiResponseProcessor();
    }

    /**
     * Retrieve multiple Articles
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleAdminControllerArticleWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseArticleAdminControllerArticle(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseArticleAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Articles
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleAdminControllerArticle(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseArticleKnowledgeAdminControllerArticle200Response> {
        return this.getManyBaseArticleAdminControllerArticleWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Article
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleAdminControllerArticleWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseArticleAdminControllerArticle(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseArticleAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Article
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleAdminControllerArticle(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseArticleAdminControllerArticleWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINArticleKnowledgeApiRequestFactory, ADMINArticleKnowledgeApiResponseProcessor} from "../apis/ADMINArticleKnowledgeApi";
export class ObservableADMINArticleKnowledgeApi {
    private requestFactory: ADMINArticleKnowledgeApiRequestFactory;
    private responseProcessor: ADMINArticleKnowledgeApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINArticleKnowledgeApiRequestFactory,
        responseProcessor?: ADMINArticleKnowledgeApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINArticleKnowledgeApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINArticleKnowledgeApiResponseProcessor();
    }

    /**
     * Create a single Article
     * @param body
     */
    public createOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseArticleKnowledgeAdminControllerArticle(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Article
     * @param body
     */
    public createOneBaseArticleKnowledgeAdminControllerArticle(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Article
     * @param id
     */
    public deleteOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseArticleKnowledgeAdminControllerArticle(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Article
     * @param id
     */
    public deleteOneBaseArticleKnowledgeAdminControllerArticle(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Articles
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseArticleKnowledgeAdminControllerArticle(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Articles
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleKnowledgeAdminControllerArticle(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseArticleKnowledgeAdminControllerArticle200Response> {
        return this.getManyBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Article
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseArticleKnowledgeAdminControllerArticle(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Article
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleKnowledgeAdminControllerArticle(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Article
     * @param id
     * @param body
     */
    public replaceOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseArticleKnowledgeAdminControllerArticle(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Article
     * @param id
     * @param body
     */
    public replaceOneBaseArticleKnowledgeAdminControllerArticle(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Article
     * @param id
     * @param body
     */
    public updateOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseArticleKnowledgeAdminControllerArticle(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Article
     * @param id
     * @param body
     */
    public updateOneBaseArticleKnowledgeAdminControllerArticle(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseArticleKnowledgeAdminControllerArticleWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINArticleNewsApiRequestFactory, ADMINArticleNewsApiResponseProcessor} from "../apis/ADMINArticleNewsApi";
export class ObservableADMINArticleNewsApi {
    private requestFactory: ADMINArticleNewsApiRequestFactory;
    private responseProcessor: ADMINArticleNewsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINArticleNewsApiRequestFactory,
        responseProcessor?: ADMINArticleNewsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINArticleNewsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINArticleNewsApiResponseProcessor();
    }

    /**
     * Create a single Article
     * @param body
     */
    public createOneBaseArticleNewsAdminControllerArticleWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseArticleNewsAdminControllerArticle(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseArticleNewsAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Article
     * @param body
     */
    public createOneBaseArticleNewsAdminControllerArticle(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseArticleNewsAdminControllerArticleWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Article
     * @param id
     */
    public deleteOneBaseArticleNewsAdminControllerArticleWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseArticleNewsAdminControllerArticle(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseArticleNewsAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Article
     * @param id
     */
    public deleteOneBaseArticleNewsAdminControllerArticle(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseArticleNewsAdminControllerArticleWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Articles
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleNewsAdminControllerArticleWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseArticleNewsAdminControllerArticle(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseArticleNewsAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Articles
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleNewsAdminControllerArticle(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseArticleKnowledgeAdminControllerArticle200Response> {
        return this.getManyBaseArticleNewsAdminControllerArticleWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Article
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleNewsAdminControllerArticleWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseArticleNewsAdminControllerArticle(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseArticleNewsAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Article
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleNewsAdminControllerArticle(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseArticleNewsAdminControllerArticleWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Article
     * @param id
     * @param body
     */
    public replaceOneBaseArticleNewsAdminControllerArticleWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseArticleNewsAdminControllerArticle(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseArticleNewsAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Article
     * @param id
     * @param body
     */
    public replaceOneBaseArticleNewsAdminControllerArticle(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseArticleNewsAdminControllerArticleWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Article
     * @param id
     * @param body
     */
    public updateOneBaseArticleNewsAdminControllerArticleWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseArticleNewsAdminControllerArticle(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseArticleNewsAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Article
     * @param id
     * @param body
     */
    public updateOneBaseArticleNewsAdminControllerArticle(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseArticleNewsAdminControllerArticleWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINAssetItemsApiRequestFactory, ADMINAssetItemsApiResponseProcessor} from "../apis/ADMINAssetItemsApi";
export class ObservableADMINAssetItemsApi {
    private requestFactory: ADMINAssetItemsApiRequestFactory;
    private responseProcessor: ADMINAssetItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINAssetItemsApiRequestFactory,
        responseProcessor?: ADMINAssetItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINAssetItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINAssetItemsApiResponseProcessor();
    }

    /**
     * Create multiple Assets
     * @param createManyAssetDto
     */
    public createManyBaseAssetAdminControllerAssetWithHttpInfo(createManyAssetDto: CreateManyAssetDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<Asset>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseAssetAdminControllerAsset(createManyAssetDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseAssetAdminControllerAssetWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Assets
     * @param createManyAssetDto
     */
    public createManyBaseAssetAdminControllerAsset(createManyAssetDto: CreateManyAssetDto, _options?: ConfigurationOptions): Observable<Array<Asset>> {
        return this.createManyBaseAssetAdminControllerAssetWithHttpInfo(createManyAssetDto, _options).pipe(map((apiResponse: HttpInfo<Array<Asset>>) => apiResponse.data));
    }

    /**
     * Create a single Asset
     * @param asset
     */
    public createOneBaseAssetAdminControllerAssetWithHttpInfo(asset: Asset, _options?: ConfigurationOptions): Observable<HttpInfo<Asset>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseAssetAdminControllerAsset(asset, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseAssetAdminControllerAssetWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Asset
     * @param asset
     */
    public createOneBaseAssetAdminControllerAsset(asset: Asset, _options?: ConfigurationOptions): Observable<Asset> {
        return this.createOneBaseAssetAdminControllerAssetWithHttpInfo(asset, _options).pipe(map((apiResponse: HttpInfo<Asset>) => apiResponse.data));
    }

    /**
     * Delete a single Asset
     * @param id
     */
    public deleteOneBaseAssetAdminControllerAssetWithHttpInfo(id: string, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseAssetAdminControllerAsset(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseAssetAdminControllerAssetWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Asset
     * @param id
     */
    public deleteOneBaseAssetAdminControllerAsset(id: string, _options?: ConfigurationOptions): Observable<any> {
        return this.deleteOneBaseAssetAdminControllerAssetWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Assets
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseAssetAdminControllerAssetWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseAssetAdminControllerAsset200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseAssetAdminControllerAsset(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseAssetAdminControllerAssetWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Assets
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseAssetAdminControllerAsset(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseAssetAdminControllerAsset200Response> {
        return this.getManyBaseAssetAdminControllerAssetWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseAssetAdminControllerAsset200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Asset
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseAssetAdminControllerAssetWithHttpInfo(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<Asset>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseAssetAdminControllerAsset(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseAssetAdminControllerAssetWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Asset
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseAssetAdminControllerAsset(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<Asset> {
        return this.getOneBaseAssetAdminControllerAssetWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<Asset>) => apiResponse.data));
    }

    /**
     */
    public refresh0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.refresh0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.refresh0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public refresh0(_options?: ConfigurationOptions): Observable<void> {
        return this.refresh0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Replace a single Asset
     * @param id
     * @param asset
     */
    public replaceOneBaseAssetAdminControllerAssetWithHttpInfo(id: string, asset: Asset, _options?: ConfigurationOptions): Observable<HttpInfo<Asset>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseAssetAdminControllerAsset(id, asset, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseAssetAdminControllerAssetWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Asset
     * @param id
     * @param asset
     */
    public replaceOneBaseAssetAdminControllerAsset(id: string, asset: Asset, _options?: ConfigurationOptions): Observable<Asset> {
        return this.replaceOneBaseAssetAdminControllerAssetWithHttpInfo(id, asset, _options).pipe(map((apiResponse: HttpInfo<Asset>) => apiResponse.data));
    }

    /**
     * Update a single Asset
     * @param id
     * @param asset
     */
    public updateOneBaseAssetAdminControllerAssetWithHttpInfo(id: string, asset: Asset, _options?: ConfigurationOptions): Observable<HttpInfo<Asset>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseAssetAdminControllerAsset(id, asset, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseAssetAdminControllerAssetWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Asset
     * @param id
     * @param asset
     */
    public updateOneBaseAssetAdminControllerAsset(id: string, asset: Asset, _options?: ConfigurationOptions): Observable<Asset> {
        return this.updateOneBaseAssetAdminControllerAssetWithHttpInfo(id, asset, _options).pipe(map((apiResponse: HttpInfo<Asset>) => apiResponse.data));
    }

    /**
     * @param [file] File to upload
     */
    public upload0WithHttpInfo(file?: HttpFile, _options?: ConfigurationOptions): Observable<HttpInfo<Asset>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.upload0(file, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.upload0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param [file] File to upload
     */
    public upload0(file?: HttpFile, _options?: ConfigurationOptions): Observable<Asset> {
        return this.upload0WithHttpInfo(file, _options).pipe(map((apiResponse: HttpInfo<Asset>) => apiResponse.data));
    }

}

import { ADMINBackgroundCategoriesApiRequestFactory, ADMINBackgroundCategoriesApiResponseProcessor} from "../apis/ADMINBackgroundCategoriesApi";
export class ObservableADMINBackgroundCategoriesApi {
    private requestFactory: ADMINBackgroundCategoriesApiRequestFactory;
    private responseProcessor: ADMINBackgroundCategoriesApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINBackgroundCategoriesApiRequestFactory,
        responseProcessor?: ADMINBackgroundCategoriesApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINBackgroundCategoriesApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINBackgroundCategoriesApiResponseProcessor();
    }

    /**
     * Create multiple BackgroundCategories
     * @param createManyBackgroundCategoryDto
     */
    public createManyBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(createManyBackgroundCategoryDto: CreateManyBackgroundCategoryDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<BackgroundCategory>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseBackgroundCategoryAdminControllerBackgroundCategory(createManyBackgroundCategoryDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple BackgroundCategories
     * @param createManyBackgroundCategoryDto
     */
    public createManyBaseBackgroundCategoryAdminControllerBackgroundCategory(createManyBackgroundCategoryDto: CreateManyBackgroundCategoryDto, _options?: ConfigurationOptions): Observable<Array<BackgroundCategory>> {
        return this.createManyBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(createManyBackgroundCategoryDto, _options).pipe(map((apiResponse: HttpInfo<Array<BackgroundCategory>>) => apiResponse.data));
    }

    /**
     * Create a single BackgroundCategory
     * @param backgroundCategory
     */
    public createOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(backgroundCategory: BackgroundCategory, _options?: ConfigurationOptions): Observable<HttpInfo<BackgroundCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseBackgroundCategoryAdminControllerBackgroundCategory(backgroundCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single BackgroundCategory
     * @param backgroundCategory
     */
    public createOneBaseBackgroundCategoryAdminControllerBackgroundCategory(backgroundCategory: BackgroundCategory, _options?: ConfigurationOptions): Observable<BackgroundCategory> {
        return this.createOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(backgroundCategory, _options).pipe(map((apiResponse: HttpInfo<BackgroundCategory>) => apiResponse.data));
    }

    /**
     * Delete a single BackgroundCategory
     * @param id
     */
    public deleteOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseBackgroundCategoryAdminControllerBackgroundCategory(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single BackgroundCategory
     * @param id
     */
    public deleteOneBaseBackgroundCategoryAdminControllerBackgroundCategory(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple BackgroundCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseBackgroundCategoryAdminControllerBackgroundCategory200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseBackgroundCategoryAdminControllerBackgroundCategory(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple BackgroundCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseBackgroundCategoryAdminControllerBackgroundCategory(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseBackgroundCategoryAdminControllerBackgroundCategory200Response> {
        return this.getManyBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseBackgroundCategoryAdminControllerBackgroundCategory200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single BackgroundCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<BackgroundCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseBackgroundCategoryAdminControllerBackgroundCategory(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single BackgroundCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseBackgroundCategoryAdminControllerBackgroundCategory(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<BackgroundCategory> {
        return this.getOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<BackgroundCategory>) => apiResponse.data));
    }

    /**
     * Replace a single BackgroundCategory
     * @param id
     * @param backgroundCategory
     */
    public replaceOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(id: number, backgroundCategory: BackgroundCategory, _options?: ConfigurationOptions): Observable<HttpInfo<BackgroundCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseBackgroundCategoryAdminControllerBackgroundCategory(id, backgroundCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single BackgroundCategory
     * @param id
     * @param backgroundCategory
     */
    public replaceOneBaseBackgroundCategoryAdminControllerBackgroundCategory(id: number, backgroundCategory: BackgroundCategory, _options?: ConfigurationOptions): Observable<BackgroundCategory> {
        return this.replaceOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(id, backgroundCategory, _options).pipe(map((apiResponse: HttpInfo<BackgroundCategory>) => apiResponse.data));
    }

    /**
     * Update a single BackgroundCategory
     * @param id
     * @param backgroundCategory
     */
    public updateOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(id: number, backgroundCategory: BackgroundCategory, _options?: ConfigurationOptions): Observable<HttpInfo<BackgroundCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseBackgroundCategoryAdminControllerBackgroundCategory(id, backgroundCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single BackgroundCategory
     * @param id
     * @param backgroundCategory
     */
    public updateOneBaseBackgroundCategoryAdminControllerBackgroundCategory(id: number, backgroundCategory: BackgroundCategory, _options?: ConfigurationOptions): Observable<BackgroundCategory> {
        return this.updateOneBaseBackgroundCategoryAdminControllerBackgroundCategoryWithHttpInfo(id, backgroundCategory, _options).pipe(map((apiResponse: HttpInfo<BackgroundCategory>) => apiResponse.data));
    }

}

import { ADMINBackgroundItemsApiRequestFactory, ADMINBackgroundItemsApiResponseProcessor} from "../apis/ADMINBackgroundItemsApi";
export class ObservableADMINBackgroundItemsApi {
    private requestFactory: ADMINBackgroundItemsApiRequestFactory;
    private responseProcessor: ADMINBackgroundItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINBackgroundItemsApiRequestFactory,
        responseProcessor?: ADMINBackgroundItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINBackgroundItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINBackgroundItemsApiResponseProcessor();
    }

    /**
     * Create multiple Backgrounds
     * @param createManyBackgroundDto
     */
    public createManyBaseBackgroundAdminControllerBackgroundWithHttpInfo(createManyBackgroundDto: CreateManyBackgroundDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseBackgroundAdminControllerBackground(createManyBackgroundDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseBackgroundAdminControllerBackgroundWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Backgrounds
     * @param createManyBackgroundDto
     */
    public createManyBaseBackgroundAdminControllerBackground(createManyBackgroundDto: CreateManyBackgroundDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseBackgroundAdminControllerBackgroundWithHttpInfo(createManyBackgroundDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Background
     * @param body
     */
    public createOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseBackgroundAdminControllerBackground(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Background
     * @param body
     */
    public createOneBaseBackgroundAdminControllerBackground(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Background
     * @param id
     */
    public deleteOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseBackgroundAdminControllerBackground(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Background
     * @param id
     */
    public deleteOneBaseBackgroundAdminControllerBackground(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Backgrounds
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseBackgroundAdminControllerBackgroundWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseBackgroundAdminControllerBackground200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseBackgroundAdminControllerBackground(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseBackgroundAdminControllerBackgroundWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Backgrounds
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseBackgroundAdminControllerBackground(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseBackgroundAdminControllerBackground200Response> {
        return this.getManyBaseBackgroundAdminControllerBackgroundWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseBackgroundAdminControllerBackground200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Background
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseBackgroundAdminControllerBackground(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Background
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseBackgroundAdminControllerBackground(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Background
     * @param id
     * @param body
     */
    public replaceOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseBackgroundAdminControllerBackground(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Background
     * @param id
     * @param body
     */
    public replaceOneBaseBackgroundAdminControllerBackground(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Background
     * @param id
     * @param body
     */
    public updateOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseBackgroundAdminControllerBackground(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Background
     * @param id
     * @param body
     */
    public updateOneBaseBackgroundAdminControllerBackground(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseBackgroundAdminControllerBackgroundWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINBannerItemsApiRequestFactory, ADMINBannerItemsApiResponseProcessor} from "../apis/ADMINBannerItemsApi";
export class ObservableADMINBannerItemsApi {
    private requestFactory: ADMINBannerItemsApiRequestFactory;
    private responseProcessor: ADMINBannerItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINBannerItemsApiRequestFactory,
        responseProcessor?: ADMINBannerItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINBannerItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINBannerItemsApiResponseProcessor();
    }

    /**
     * Creates new banner.
     * @param bannerItemCreateDTO
     */
    public create0WithHttpInfo(bannerItemCreateDTO: BannerItemCreateDTO, _options?: ConfigurationOptions): Observable<HttpInfo<BannerItemDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.create0(bannerItemCreateDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.create0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Creates new banner.
     * @param bannerItemCreateDTO
     */
    public create0(bannerItemCreateDTO: BannerItemCreateDTO, _options?: ConfigurationOptions): Observable<BannerItemDTO> {
        return this.create0WithHttpInfo(bannerItemCreateDTO, _options).pipe(map((apiResponse: HttpInfo<BannerItemDTO>) => apiResponse.data));
    }

    /**
     * Deletes banner.
     * @param bannerId Unique id of banner to find.
     */
    public destroy0WithHttpInfo(bannerId: number, _options?: ConfigurationOptions): Observable<HttpInfo<BannerItemDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.destroy0(bannerId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.destroy0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Deletes banner.
     * @param bannerId Unique id of banner to find.
     */
    public destroy0(bannerId: number, _options?: ConfigurationOptions): Observable<BannerItemDTO> {
        return this.destroy0WithHttpInfo(bannerId, _options).pipe(map((apiResponse: HttpInfo<BannerItemDTO>) => apiResponse.data));
    }

    /**
     * Returns a set of banners, according to the given limit, page number and search query.
     * @param page Page.
     * @param limit Amount of items to take.
     * @param [language] Specific language code for query.
     * @param [position] Banner position
     * @param [profileType] ProfileType
     * @param [search] Search string to filter items.
     */
    public findMany0WithHttpInfo(page: number, limit: number, language?: 'en' | 'ru' | 'uk', position?: 'HERO' | 'SIDEBAR' | 'TOP' | 'LIST', profileType?: 'employee' | 'hirer' | 'unknown', search?: string, _options?: ConfigurationOptions): Observable<HttpInfo<BannerFindManyControllerFindMany0200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findMany0(page, limit, language, position, profileType, search, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findMany0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns a set of banners, according to the given limit, page number and search query.
     * @param page Page.
     * @param limit Amount of items to take.
     * @param [language] Specific language code for query.
     * @param [position] Banner position
     * @param [profileType] ProfileType
     * @param [search] Search string to filter items.
     */
    public findMany0(page: number, limit: number, language?: 'en' | 'ru' | 'uk', position?: 'HERO' | 'SIDEBAR' | 'TOP' | 'LIST', profileType?: 'employee' | 'hirer' | 'unknown', search?: string, _options?: ConfigurationOptions): Observable<BannerFindManyControllerFindMany0200Response> {
        return this.findMany0WithHttpInfo(page, limit, language, position, profileType, search, _options).pipe(map((apiResponse: HttpInfo<BannerFindManyControllerFindMany0200Response>) => apiResponse.data));
    }

    /**
     * Returns banner, according to the given unique id query.
     * @param bannerId Unique id of banner to find.
     */
    public findOne0WithHttpInfo(bannerId: number, _options?: ConfigurationOptions): Observable<HttpInfo<BannerItemDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findOne0(bannerId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findOne0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns banner, according to the given unique id query.
     * @param bannerId Unique id of banner to find.
     */
    public findOne0(bannerId: number, _options?: ConfigurationOptions): Observable<BannerItemDTO> {
        return this.findOne0WithHttpInfo(bannerId, _options).pipe(map((apiResponse: HttpInfo<BannerItemDTO>) => apiResponse.data));
    }

    /**
     * Updates banner.
     * @param bannerId Unique id of banner to find.
     * @param bannerItemUpdateDTO
     */
    public update0WithHttpInfo(bannerId: number, bannerItemUpdateDTO: BannerItemUpdateDTO, _options?: ConfigurationOptions): Observable<HttpInfo<BannerItemDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.update0(bannerId, bannerItemUpdateDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.update0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Updates banner.
     * @param bannerId Unique id of banner to find.
     * @param bannerItemUpdateDTO
     */
    public update0(bannerId: number, bannerItemUpdateDTO: BannerItemUpdateDTO, _options?: ConfigurationOptions): Observable<BannerItemDTO> {
        return this.update0WithHttpInfo(bannerId, bannerItemUpdateDTO, _options).pipe(map((apiResponse: HttpInfo<BannerItemDTO>) => apiResponse.data));
    }

}

import { ADMINCVApprovedApiRequestFactory, ADMINCVApprovedApiResponseProcessor} from "../apis/ADMINCVApprovedApi";
export class ObservableADMINCVApprovedApi {
    private requestFactory: ADMINCVApprovedApiRequestFactory;
    private responseProcessor: ADMINCVApprovedApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCVApprovedApiRequestFactory,
        responseProcessor?: ADMINCVApprovedApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCVApprovedApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCVApprovedApiResponseProcessor();
    }

    /**
     * Create multiple CVS
     * @param createManyCVDto
     */
    public createManyBaseCvApprovedAdminControllerCVWithHttpInfo(createManyCVDto: CreateManyCVDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseCvApprovedAdminControllerCV(createManyCVDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseCvApprovedAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple CVS
     * @param createManyCVDto
     */
    public createManyBaseCvApprovedAdminControllerCV(createManyCVDto: CreateManyCVDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseCvApprovedAdminControllerCVWithHttpInfo(createManyCVDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single CV
     * @param body
     */
    public createOneBaseCvApprovedAdminControllerCVWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCvApprovedAdminControllerCV(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCvApprovedAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single CV
     * @param body
     */
    public createOneBaseCvApprovedAdminControllerCV(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCvApprovedAdminControllerCVWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single CV
     * @param id
     */
    public deleteOneBaseCvApprovedAdminControllerCVWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCvApprovedAdminControllerCV(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCvApprovedAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single CV
     * @param id
     */
    public deleteOneBaseCvApprovedAdminControllerCV(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCvApprovedAdminControllerCVWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple CVS
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCvApprovedAdminControllerCVWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCvApprovedAdminControllerCV(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCvApprovedAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CVS
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCvApprovedAdminControllerCV(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseCvApprovedAdminControllerCVWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single CV
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCvApprovedAdminControllerCVWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCvApprovedAdminControllerCV(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCvApprovedAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CV
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCvApprovedAdminControllerCV(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCvApprovedAdminControllerCVWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single CV
     * @param id
     * @param body
     */
    public replaceOneBaseCvApprovedAdminControllerCVWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCvApprovedAdminControllerCV(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCvApprovedAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single CV
     * @param id
     * @param body
     */
    public replaceOneBaseCvApprovedAdminControllerCV(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseCvApprovedAdminControllerCVWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single CV
     * @param id
     * @param body
     */
    public updateOneBaseCvApprovedAdminControllerCVWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCvApprovedAdminControllerCV(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCvApprovedAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single CV
     * @param id
     * @param body
     */
    public updateOneBaseCvApprovedAdminControllerCV(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCvApprovedAdminControllerCVWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINCVItemsApiRequestFactory, ADMINCVItemsApiResponseProcessor} from "../apis/ADMINCVItemsApi";
export class ObservableADMINCVItemsApi {
    private requestFactory: ADMINCVItemsApiRequestFactory;
    private responseProcessor: ADMINCVItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCVItemsApiRequestFactory,
        responseProcessor?: ADMINCVItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCVItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCVItemsApiResponseProcessor();
    }

    /**
     * Create multiple CVS
     * @param createManyCVDto
     */
    public createManyBaseCVAdminControllerCVWithHttpInfo(createManyCVDto: CreateManyCVDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseCVAdminControllerCV(createManyCVDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseCVAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple CVS
     * @param createManyCVDto
     */
    public createManyBaseCVAdminControllerCV(createManyCVDto: CreateManyCVDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseCVAdminControllerCVWithHttpInfo(createManyCVDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single CV
     * @param body
     */
    public createOneBaseCVAdminControllerCVWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCVAdminControllerCV(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCVAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single CV
     * @param body
     */
    public createOneBaseCVAdminControllerCV(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCVAdminControllerCVWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single CV
     * @param id
     */
    public deleteOneBaseCVAdminControllerCVWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCVAdminControllerCV(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCVAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single CV
     * @param id
     */
    public deleteOneBaseCVAdminControllerCV(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCVAdminControllerCVWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple CVS
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCVAdminControllerCVWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseCVAdminControllerCV200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCVAdminControllerCV(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCVAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CVS
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCVAdminControllerCV(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseCVAdminControllerCV200Response> {
        return this.getManyBaseCVAdminControllerCVWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseCVAdminControllerCV200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single CV
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCVAdminControllerCVWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCVAdminControllerCV(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCVAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CV
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCVAdminControllerCV(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCVAdminControllerCVWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single CV
     * @param id
     * @param body
     */
    public replaceOneBaseCVAdminControllerCVWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCVAdminControllerCV(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCVAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single CV
     * @param id
     * @param body
     */
    public replaceOneBaseCVAdminControllerCV(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseCVAdminControllerCVWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single CV
     * @param id
     * @param body
     */
    public updateOneBaseCVAdminControllerCVWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCVAdminControllerCV(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCVAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single CV
     * @param id
     * @param body
     */
    public updateOneBaseCVAdminControllerCV(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCVAdminControllerCVWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINCVModerationApiRequestFactory, ADMINCVModerationApiResponseProcessor} from "../apis/ADMINCVModerationApi";
export class ObservableADMINCVModerationApi {
    private requestFactory: ADMINCVModerationApiRequestFactory;
    private responseProcessor: ADMINCVModerationApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCVModerationApiRequestFactory,
        responseProcessor?: ADMINCVModerationApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCVModerationApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCVModerationApiResponseProcessor();
    }

    /**
     * Create multiple CVS
     * @param createManyCVDto
     */
    public createManyBaseCvModerationAdminControllerCVWithHttpInfo(createManyCVDto: CreateManyCVDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseCvModerationAdminControllerCV(createManyCVDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseCvModerationAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple CVS
     * @param createManyCVDto
     */
    public createManyBaseCvModerationAdminControllerCV(createManyCVDto: CreateManyCVDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseCvModerationAdminControllerCVWithHttpInfo(createManyCVDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single CV
     * @param body
     */
    public createOneBaseCvModerationAdminControllerCVWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCvModerationAdminControllerCV(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCvModerationAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single CV
     * @param body
     */
    public createOneBaseCvModerationAdminControllerCV(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCvModerationAdminControllerCVWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single CV
     * @param id
     */
    public deleteOneBaseCvModerationAdminControllerCVWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCvModerationAdminControllerCV(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCvModerationAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single CV
     * @param id
     */
    public deleteOneBaseCvModerationAdminControllerCV(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCvModerationAdminControllerCVWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple CVS
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCvModerationAdminControllerCVWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCvModerationAdminControllerCV(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCvModerationAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CVS
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCvModerationAdminControllerCV(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseCvModerationAdminControllerCVWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single CV
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCvModerationAdminControllerCVWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCvModerationAdminControllerCV(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCvModerationAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CV
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCvModerationAdminControllerCV(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCvModerationAdminControllerCVWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single CV
     * @param id
     * @param body
     */
    public replaceOneBaseCvModerationAdminControllerCVWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCvModerationAdminControllerCV(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCvModerationAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single CV
     * @param id
     * @param body
     */
    public replaceOneBaseCvModerationAdminControllerCV(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseCvModerationAdminControllerCVWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single CV
     * @param id
     * @param body
     */
    public updateOneBaseCvModerationAdminControllerCVWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCvModerationAdminControllerCV(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCvModerationAdminControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single CV
     * @param id
     * @param body
     */
    public updateOneBaseCvModerationAdminControllerCV(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCvModerationAdminControllerCVWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINCharacterItemCategoriesApiRequestFactory, ADMINCharacterItemCategoriesApiResponseProcessor} from "../apis/ADMINCharacterItemCategoriesApi";
export class ObservableADMINCharacterItemCategoriesApi {
    private requestFactory: ADMINCharacterItemCategoriesApiRequestFactory;
    private responseProcessor: ADMINCharacterItemCategoriesApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCharacterItemCategoriesApiRequestFactory,
        responseProcessor?: ADMINCharacterItemCategoriesApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCharacterItemCategoriesApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCharacterItemCategoriesApiResponseProcessor();
    }

    /**
     * Create multiple CharacterItemCategories
     * @param createManyCharacterItemCategoryDto
     */
    public createManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(createManyCharacterItemCategoryDto: CreateManyCharacterItemCategoryDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<CharacterItemCategory>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory(createManyCharacterItemCategoryDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple CharacterItemCategories
     * @param createManyCharacterItemCategoryDto
     */
    public createManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory(createManyCharacterItemCategoryDto: CreateManyCharacterItemCategoryDto, _options?: ConfigurationOptions): Observable<Array<CharacterItemCategory>> {
        return this.createManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(createManyCharacterItemCategoryDto, _options).pipe(map((apiResponse: HttpInfo<Array<CharacterItemCategory>>) => apiResponse.data));
    }

    /**
     * Create a single CharacterItemCategory
     * @param characterItemCategory
     */
    public createOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(characterItemCategory: CharacterItemCategory, _options?: ConfigurationOptions): Observable<HttpInfo<CharacterItemCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(characterItemCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single CharacterItemCategory
     * @param characterItemCategory
     */
    public createOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(characterItemCategory: CharacterItemCategory, _options?: ConfigurationOptions): Observable<CharacterItemCategory> {
        return this.createOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(characterItemCategory, _options).pipe(map((apiResponse: HttpInfo<CharacterItemCategory>) => apiResponse.data));
    }

    /**
     * Delete a single CharacterItemCategory
     * @param id
     */
    public deleteOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single CharacterItemCategory
     * @param id
     */
    public deleteOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple CharacterItemCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CharacterItemCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory200Response> {
        return this.getManyBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseCharacterItemCategoryAdminControllerCharacterItemCategory200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single CharacterItemCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<CharacterItemCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CharacterItemCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<CharacterItemCategory> {
        return this.getOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<CharacterItemCategory>) => apiResponse.data));
    }

    /**
     * Replace a single CharacterItemCategory
     * @param id
     * @param characterItemCategory
     */
    public replaceOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(id: number, characterItemCategory: CharacterItemCategory, _options?: ConfigurationOptions): Observable<HttpInfo<CharacterItemCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(id, characterItemCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single CharacterItemCategory
     * @param id
     * @param characterItemCategory
     */
    public replaceOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(id: number, characterItemCategory: CharacterItemCategory, _options?: ConfigurationOptions): Observable<CharacterItemCategory> {
        return this.replaceOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(id, characterItemCategory, _options).pipe(map((apiResponse: HttpInfo<CharacterItemCategory>) => apiResponse.data));
    }

    /**
     * Update a single CharacterItemCategory
     * @param id
     * @param characterItemCategory
     */
    public updateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(id: number, characterItemCategory: CharacterItemCategory, _options?: ConfigurationOptions): Observable<HttpInfo<CharacterItemCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(id, characterItemCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single CharacterItemCategory
     * @param id
     * @param characterItemCategory
     */
    public updateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategory(id: number, characterItemCategory: CharacterItemCategory, _options?: ConfigurationOptions): Observable<CharacterItemCategory> {
        return this.updateOneBaseCharacterItemCategoryAdminControllerCharacterItemCategoryWithHttpInfo(id, characterItemCategory, _options).pipe(map((apiResponse: HttpInfo<CharacterItemCategory>) => apiResponse.data));
    }

}

import { ADMINCharacterItemsApiRequestFactory, ADMINCharacterItemsApiResponseProcessor} from "../apis/ADMINCharacterItemsApi";
export class ObservableADMINCharacterItemsApi {
    private requestFactory: ADMINCharacterItemsApiRequestFactory;
    private responseProcessor: ADMINCharacterItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCharacterItemsApiRequestFactory,
        responseProcessor?: ADMINCharacterItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCharacterItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCharacterItemsApiResponseProcessor();
    }

    /**
     * Create multiple Characters
     * @param createManyCharacterDto
     */
    public createManyBaseCharacterAdminControllerCharacterWithHttpInfo(createManyCharacterDto: CreateManyCharacterDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseCharacterAdminControllerCharacter(createManyCharacterDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseCharacterAdminControllerCharacterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Characters
     * @param createManyCharacterDto
     */
    public createManyBaseCharacterAdminControllerCharacter(createManyCharacterDto: CreateManyCharacterDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseCharacterAdminControllerCharacterWithHttpInfo(createManyCharacterDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create multiple CharacterItems
     * @param createManyCharacterItemDto
     */
    public createManyBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(createManyCharacterItemDto: CreateManyCharacterItemDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<CharacterItem>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseCharacterItemAdminControllerCharacterItem(createManyCharacterItemDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple CharacterItems
     * @param createManyCharacterItemDto
     */
    public createManyBaseCharacterItemAdminControllerCharacterItem(createManyCharacterItemDto: CreateManyCharacterItemDto, _options?: ConfigurationOptions): Observable<Array<CharacterItem>> {
        return this.createManyBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(createManyCharacterItemDto, _options).pipe(map((apiResponse: HttpInfo<Array<CharacterItem>>) => apiResponse.data));
    }

    /**
     * Create a single Character
     * @param body
     */
    public createOneBaseCharacterAdminControllerCharacterWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCharacterAdminControllerCharacter(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCharacterAdminControllerCharacterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Character
     * @param body
     */
    public createOneBaseCharacterAdminControllerCharacter(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCharacterAdminControllerCharacterWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Create a single CharacterItem
     * @param characterItem
     */
    public createOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(characterItem: CharacterItem, _options?: ConfigurationOptions): Observable<HttpInfo<CharacterItem>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCharacterItemAdminControllerCharacterItem(characterItem, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single CharacterItem
     * @param characterItem
     */
    public createOneBaseCharacterItemAdminControllerCharacterItem(characterItem: CharacterItem, _options?: ConfigurationOptions): Observable<CharacterItem> {
        return this.createOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(characterItem, _options).pipe(map((apiResponse: HttpInfo<CharacterItem>) => apiResponse.data));
    }

    /**
     * Delete a single Character
     * @param id
     */
    public deleteOneBaseCharacterAdminControllerCharacterWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCharacterAdminControllerCharacter(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCharacterAdminControllerCharacterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Character
     * @param id
     */
    public deleteOneBaseCharacterAdminControllerCharacter(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCharacterAdminControllerCharacterWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Delete a single CharacterItem
     * @param id
     */
    public deleteOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCharacterItemAdminControllerCharacterItem(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single CharacterItem
     * @param id
     */
    public deleteOneBaseCharacterItemAdminControllerCharacterItem(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Characters
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCharacterAdminControllerCharacterWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseCharacterAdminControllerCharacter200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCharacterAdminControllerCharacter(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCharacterAdminControllerCharacterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Characters
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCharacterAdminControllerCharacter(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseCharacterAdminControllerCharacter200Response> {
        return this.getManyBaseCharacterAdminControllerCharacterWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseCharacterAdminControllerCharacter200Response>) => apiResponse.data));
    }

    /**
     * Retrieve multiple CharacterItems
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseCharacterItemAdminControllerCharacterItem200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCharacterItemAdminControllerCharacterItem(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CharacterItems
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCharacterItemAdminControllerCharacterItem(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseCharacterItemAdminControllerCharacterItem200Response> {
        return this.getManyBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseCharacterItemAdminControllerCharacterItem200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Character
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCharacterAdminControllerCharacterWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCharacterAdminControllerCharacter(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCharacterAdminControllerCharacterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Character
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCharacterAdminControllerCharacter(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCharacterAdminControllerCharacterWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single CharacterItem
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<CharacterItem>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCharacterItemAdminControllerCharacterItem(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CharacterItem
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCharacterItemAdminControllerCharacterItem(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<CharacterItem> {
        return this.getOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<CharacterItem>) => apiResponse.data));
    }

    /**
     * Replace a single Character
     * @param id
     * @param body
     */
    public replaceOneBaseCharacterAdminControllerCharacterWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCharacterAdminControllerCharacter(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCharacterAdminControllerCharacterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Character
     * @param id
     * @param body
     */
    public replaceOneBaseCharacterAdminControllerCharacter(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseCharacterAdminControllerCharacterWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single CharacterItem
     * @param id
     * @param characterItem
     */
    public replaceOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(id: number, characterItem: CharacterItem, _options?: ConfigurationOptions): Observable<HttpInfo<CharacterItem>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCharacterItemAdminControllerCharacterItem(id, characterItem, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single CharacterItem
     * @param id
     * @param characterItem
     */
    public replaceOneBaseCharacterItemAdminControllerCharacterItem(id: number, characterItem: CharacterItem, _options?: ConfigurationOptions): Observable<CharacterItem> {
        return this.replaceOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(id, characterItem, _options).pipe(map((apiResponse: HttpInfo<CharacterItem>) => apiResponse.data));
    }

    /**
     * Update a single Character
     * @param id
     * @param body
     */
    public updateOneBaseCharacterAdminControllerCharacterWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCharacterAdminControllerCharacter(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCharacterAdminControllerCharacterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Character
     * @param id
     * @param body
     */
    public updateOneBaseCharacterAdminControllerCharacter(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCharacterAdminControllerCharacterWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single CharacterItem
     * @param id
     * @param characterItem
     */
    public updateOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(id: number, characterItem: CharacterItem, _options?: ConfigurationOptions): Observable<HttpInfo<CharacterItem>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCharacterItemAdminControllerCharacterItem(id, characterItem, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single CharacterItem
     * @param id
     * @param characterItem
     */
    public updateOneBaseCharacterItemAdminControllerCharacterItem(id: number, characterItem: CharacterItem, _options?: ConfigurationOptions): Observable<CharacterItem> {
        return this.updateOneBaseCharacterItemAdminControllerCharacterItemWithHttpInfo(id, characterItem, _options).pipe(map((apiResponse: HttpInfo<CharacterItem>) => apiResponse.data));
    }

}

import { ADMINChatItemsApiRequestFactory, ADMINChatItemsApiResponseProcessor} from "../apis/ADMINChatItemsApi";
export class ObservableADMINChatItemsApi {
    private requestFactory: ADMINChatItemsApiRequestFactory;
    private responseProcessor: ADMINChatItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINChatItemsApiRequestFactory,
        responseProcessor?: ADMINChatItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINChatItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINChatItemsApiResponseProcessor();
    }

    /**
     * Create multiple Chats
     * @param createManyChatDto
     */
    public createManyBaseChatAdminControllerChatWithHttpInfo(createManyChatDto: CreateManyChatDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseChatAdminControllerChat(createManyChatDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseChatAdminControllerChatWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Chats
     * @param createManyChatDto
     */
    public createManyBaseChatAdminControllerChat(createManyChatDto: CreateManyChatDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseChatAdminControllerChatWithHttpInfo(createManyChatDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Chat
     * @param body
     */
    public createOneBaseChatAdminControllerChatWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseChatAdminControllerChat(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseChatAdminControllerChatWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Chat
     * @param body
     */
    public createOneBaseChatAdminControllerChat(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseChatAdminControllerChatWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Chat
     * @param id
     */
    public deleteOneBaseChatAdminControllerChatWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseChatAdminControllerChat(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseChatAdminControllerChatWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Chat
     * @param id
     */
    public deleteOneBaseChatAdminControllerChat(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.deleteOneBaseChatAdminControllerChatWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Chats
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseChatAdminControllerChatWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseChatAdminControllerChat200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseChatAdminControllerChat(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseChatAdminControllerChatWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Chats
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseChatAdminControllerChat(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseChatAdminControllerChat200Response> {
        return this.getManyBaseChatAdminControllerChatWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseChatAdminControllerChat200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Chat
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseChatAdminControllerChatWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseChatAdminControllerChat(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseChatAdminControllerChatWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Chat
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseChatAdminControllerChat(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseChatAdminControllerChatWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Chat
     * @param id
     * @param body
     */
    public replaceOneBaseChatAdminControllerChatWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseChatAdminControllerChat(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseChatAdminControllerChatWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Chat
     * @param id
     * @param body
     */
    public replaceOneBaseChatAdminControllerChat(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseChatAdminControllerChatWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Chat
     * @param id
     * @param body
     */
    public updateOneBaseChatAdminControllerChatWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseChatAdminControllerChat(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseChatAdminControllerChatWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Chat
     * @param id
     * @param body
     */
    public updateOneBaseChatAdminControllerChat(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseChatAdminControllerChatWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINChatMessagesApiRequestFactory, ADMINChatMessagesApiResponseProcessor} from "../apis/ADMINChatMessagesApi";
export class ObservableADMINChatMessagesApi {
    private requestFactory: ADMINChatMessagesApiRequestFactory;
    private responseProcessor: ADMINChatMessagesApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINChatMessagesApiRequestFactory,
        responseProcessor?: ADMINChatMessagesApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINChatMessagesApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINChatMessagesApiResponseProcessor();
    }

    /**
     * Create multiple ChatMessages
     * @param createManyChatMessageDto
     */
    public createManyBaseChatMessageAdminControllerChatMessageWithHttpInfo(createManyChatMessageDto: CreateManyChatMessageDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseChatMessageAdminControllerChatMessage(createManyChatMessageDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseChatMessageAdminControllerChatMessageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple ChatMessages
     * @param createManyChatMessageDto
     */
    public createManyBaseChatMessageAdminControllerChatMessage(createManyChatMessageDto: CreateManyChatMessageDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseChatMessageAdminControllerChatMessageWithHttpInfo(createManyChatMessageDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create multiple ChatMessageUrls
     * @param createManyChatMessageUrlDto
     */
    public createManyBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(createManyChatMessageUrlDto: CreateManyChatMessageUrlDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseChatMessageUrlAdminControllerChatMessageUrl(createManyChatMessageUrlDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple ChatMessageUrls
     * @param createManyChatMessageUrlDto
     */
    public createManyBaseChatMessageUrlAdminControllerChatMessageUrl(createManyChatMessageUrlDto: CreateManyChatMessageUrlDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(createManyChatMessageUrlDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single ChatMessage
     * @param body
     */
    public createOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseChatMessageAdminControllerChatMessage(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single ChatMessage
     * @param body
     */
    public createOneBaseChatMessageAdminControllerChatMessage(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Create a single ChatMessageUrl
     * @param body
     */
    public createOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseChatMessageUrlAdminControllerChatMessageUrl(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single ChatMessageUrl
     * @param body
     */
    public createOneBaseChatMessageUrlAdminControllerChatMessageUrl(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single ChatMessage
     * @param id
     */
    public deleteOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseChatMessageAdminControllerChatMessage(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single ChatMessage
     * @param id
     */
    public deleteOneBaseChatMessageAdminControllerChatMessage(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Delete a single ChatMessageUrl
     * @param id
     */
    public deleteOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseChatMessageUrlAdminControllerChatMessageUrl(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single ChatMessageUrl
     * @param id
     */
    public deleteOneBaseChatMessageUrlAdminControllerChatMessageUrl(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple ChatMessages
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseChatMessageAdminControllerChatMessageWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseChatMessageAdminControllerChatMessage200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseChatMessageAdminControllerChatMessage(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseChatMessageAdminControllerChatMessageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple ChatMessages
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseChatMessageAdminControllerChatMessage(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseChatMessageAdminControllerChatMessage200Response> {
        return this.getManyBaseChatMessageAdminControllerChatMessageWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseChatMessageAdminControllerChatMessage200Response>) => apiResponse.data));
    }

    /**
     * Retrieve multiple ChatMessageUrls
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseChatMessageUrlControllerChatMessageUrl200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseChatMessageUrlAdminControllerChatMessageUrl(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple ChatMessageUrls
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseChatMessageUrlAdminControllerChatMessageUrl(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseChatMessageUrlControllerChatMessageUrl200Response> {
        return this.getManyBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseChatMessageUrlControllerChatMessageUrl200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single ChatMessage
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseChatMessageAdminControllerChatMessage(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single ChatMessage
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseChatMessageAdminControllerChatMessage(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single ChatMessageUrl
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseChatMessageUrlAdminControllerChatMessageUrl(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single ChatMessageUrl
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseChatMessageUrlAdminControllerChatMessageUrl(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single ChatMessage
     * @param id
     * @param body
     */
    public replaceOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseChatMessageAdminControllerChatMessage(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single ChatMessage
     * @param id
     * @param body
     */
    public replaceOneBaseChatMessageAdminControllerChatMessage(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single ChatMessageUrl
     * @param id
     * @param body
     */
    public replaceOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseChatMessageUrlAdminControllerChatMessageUrl(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single ChatMessageUrl
     * @param id
     * @param body
     */
    public replaceOneBaseChatMessageUrlAdminControllerChatMessageUrl(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single ChatMessage
     * @param id
     * @param body
     */
    public updateOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseChatMessageAdminControllerChatMessage(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single ChatMessage
     * @param id
     * @param body
     */
    public updateOneBaseChatMessageAdminControllerChatMessage(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseChatMessageAdminControllerChatMessageWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single ChatMessageUrl
     * @param id
     * @param body
     */
    public updateOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseChatMessageUrlAdminControllerChatMessageUrl(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single ChatMessageUrl
     * @param id
     * @param body
     */
    public updateOneBaseChatMessageUrlAdminControllerChatMessageUrl(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseChatMessageUrlAdminControllerChatMessageUrlWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINCommunityItemsApiRequestFactory, ADMINCommunityItemsApiResponseProcessor} from "../apis/ADMINCommunityItemsApi";
export class ObservableADMINCommunityItemsApi {
    private requestFactory: ADMINCommunityItemsApiRequestFactory;
    private responseProcessor: ADMINCommunityItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCommunityItemsApiRequestFactory,
        responseProcessor?: ADMINCommunityItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCommunityItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCommunityItemsApiResponseProcessor();
    }

    /**
     * Create multiple Communities
     * @param createManyCommunityDto
     */
    public createManyBaseCommunityAdminControllerCommunityWithHttpInfo(createManyCommunityDto: CreateManyCommunityDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseCommunityAdminControllerCommunity(createManyCommunityDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseCommunityAdminControllerCommunityWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Communities
     * @param createManyCommunityDto
     */
    public createManyBaseCommunityAdminControllerCommunity(createManyCommunityDto: CreateManyCommunityDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseCommunityAdminControllerCommunityWithHttpInfo(createManyCommunityDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Community
     * @param body
     */
    public createOneBaseCommunityAdminControllerCommunityWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCommunityAdminControllerCommunity(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCommunityAdminControllerCommunityWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Community
     * @param body
     */
    public createOneBaseCommunityAdminControllerCommunity(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCommunityAdminControllerCommunityWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Community
     * @param id
     */
    public deleteOneBaseCommunityAdminControllerCommunityWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCommunityAdminControllerCommunity(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCommunityAdminControllerCommunityWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Community
     * @param id
     */
    public deleteOneBaseCommunityAdminControllerCommunity(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCommunityAdminControllerCommunityWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Communities
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCommunityAdminControllerCommunityWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseCommunityAdminControllerCommunity200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCommunityAdminControllerCommunity(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCommunityAdminControllerCommunityWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Communities
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCommunityAdminControllerCommunity(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseCommunityAdminControllerCommunity200Response> {
        return this.getManyBaseCommunityAdminControllerCommunityWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseCommunityAdminControllerCommunity200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Community
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCommunityAdminControllerCommunityWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCommunityAdminControllerCommunity(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCommunityAdminControllerCommunityWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Community
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCommunityAdminControllerCommunity(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCommunityAdminControllerCommunityWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Community
     * @param id
     * @param body
     */
    public replaceOneBaseCommunityAdminControllerCommunityWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCommunityAdminControllerCommunity(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCommunityAdminControllerCommunityWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Community
     * @param id
     * @param body
     */
    public replaceOneBaseCommunityAdminControllerCommunity(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseCommunityAdminControllerCommunityWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Community
     * @param id
     * @param body
     */
    public updateOneBaseCommunityAdminControllerCommunityWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCommunityAdminControllerCommunity(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCommunityAdminControllerCommunityWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Community
     * @param id
     * @param body
     */
    public updateOneBaseCommunityAdminControllerCommunity(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCommunityAdminControllerCommunityWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINCourseAuthorsApiRequestFactory, ADMINCourseAuthorsApiResponseProcessor} from "../apis/ADMINCourseAuthorsApi";
export class ObservableADMINCourseAuthorsApi {
    private requestFactory: ADMINCourseAuthorsApiRequestFactory;
    private responseProcessor: ADMINCourseAuthorsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCourseAuthorsApiRequestFactory,
        responseProcessor?: ADMINCourseAuthorsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCourseAuthorsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCourseAuthorsApiResponseProcessor();
    }

    /**
     * Create a single CourseAuthor
     * @param body
     */
    public createOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCourseAuthorAdminControllerCourseAuthor(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single CourseAuthor
     * @param body
     */
    public createOneBaseCourseAuthorAdminControllerCourseAuthor(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single CourseAuthor
     * @param id
     */
    public deleteOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCourseAuthorAdminControllerCourseAuthor(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single CourseAuthor
     * @param id
     */
    public deleteOneBaseCourseAuthorAdminControllerCourseAuthor(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple CourseAuthors
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseCourseAuthorAdminControllerCourseAuthor200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCourseAuthorAdminControllerCourseAuthor(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CourseAuthors
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseAuthorAdminControllerCourseAuthor(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseCourseAuthorAdminControllerCourseAuthor200Response> {
        return this.getManyBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseCourseAuthorAdminControllerCourseAuthor200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single CourseAuthor
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCourseAuthorAdminControllerCourseAuthor(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CourseAuthor
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseAuthorAdminControllerCourseAuthor(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single CourseAuthor
     * @param id
     * @param body
     */
    public replaceOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCourseAuthorAdminControllerCourseAuthor(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single CourseAuthor
     * @param id
     * @param body
     */
    public replaceOneBaseCourseAuthorAdminControllerCourseAuthor(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single CourseAuthor
     * @param id
     * @param body
     */
    public updateOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCourseAuthorAdminControllerCourseAuthor(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single CourseAuthor
     * @param id
     * @param body
     */
    public updateOneBaseCourseAuthorAdminControllerCourseAuthor(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCourseAuthorAdminControllerCourseAuthorWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINCourseBlockApiRequestFactory, ADMINCourseBlockApiResponseProcessor} from "../apis/ADMINCourseBlockApi";
export class ObservableADMINCourseBlockApi {
    private requestFactory: ADMINCourseBlockApiRequestFactory;
    private responseProcessor: ADMINCourseBlockApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCourseBlockApiRequestFactory,
        responseProcessor?: ADMINCourseBlockApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCourseBlockApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCourseBlockApiResponseProcessor();
    }

    /**
     * Create a single CourseBlock
     * @param body
     */
    public createOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCourseBlockAdminControllerCourseBlock(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single CourseBlock
     * @param body
     */
    public createOneBaseCourseBlockAdminControllerCourseBlock(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single CourseBlock
     * @param id
     */
    public deleteOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCourseBlockAdminControllerCourseBlock(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single CourseBlock
     * @param id
     */
    public deleteOneBaseCourseBlockAdminControllerCourseBlock(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple CourseBlocks
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseCourseBlockAdminControllerCourseBlock200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCourseBlockAdminControllerCourseBlock(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CourseBlocks
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseBlockAdminControllerCourseBlock(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseCourseBlockAdminControllerCourseBlock200Response> {
        return this.getManyBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseCourseBlockAdminControllerCourseBlock200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single CourseBlock
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCourseBlockAdminControllerCourseBlock(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CourseBlock
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseBlockAdminControllerCourseBlock(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single CourseBlock
     * @param id
     * @param body
     */
    public replaceOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCourseBlockAdminControllerCourseBlock(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single CourseBlock
     * @param id
     * @param body
     */
    public replaceOneBaseCourseBlockAdminControllerCourseBlock(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single CourseBlock
     * @param id
     * @param body
     */
    public updateOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCourseBlockAdminControllerCourseBlock(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single CourseBlock
     * @param id
     * @param body
     */
    public updateOneBaseCourseBlockAdminControllerCourseBlock(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCourseBlockAdminControllerCourseBlockWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINCourseBlockStepApiRequestFactory, ADMINCourseBlockStepApiResponseProcessor} from "../apis/ADMINCourseBlockStepApi";
export class ObservableADMINCourseBlockStepApi {
    private requestFactory: ADMINCourseBlockStepApiRequestFactory;
    private responseProcessor: ADMINCourseBlockStepApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCourseBlockStepApiRequestFactory,
        responseProcessor?: ADMINCourseBlockStepApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCourseBlockStepApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCourseBlockStepApiResponseProcessor();
    }

    /**
     * Create a single CourseBlockStep
     * @param body
     */
    public createOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCourseBlockStepAdminControllerCourseBlockStep(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single CourseBlockStep
     * @param body
     */
    public createOneBaseCourseBlockStepAdminControllerCourseBlockStep(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single CourseBlockStep
     * @param id
     */
    public deleteOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCourseBlockStepAdminControllerCourseBlockStep(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single CourseBlockStep
     * @param id
     */
    public deleteOneBaseCourseBlockStepAdminControllerCourseBlockStep(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple CourseBlockSteps
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseCourseBlockStepAdminControllerCourseBlockStep200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCourseBlockStepAdminControllerCourseBlockStep(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CourseBlockSteps
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseBlockStepAdminControllerCourseBlockStep(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseCourseBlockStepAdminControllerCourseBlockStep200Response> {
        return this.getManyBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseCourseBlockStepAdminControllerCourseBlockStep200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single CourseBlockStep
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCourseBlockStepAdminControllerCourseBlockStep(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CourseBlockStep
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseBlockStepAdminControllerCourseBlockStep(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single CourseBlockStep
     * @param id
     * @param body
     */
    public replaceOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCourseBlockStepAdminControllerCourseBlockStep(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single CourseBlockStep
     * @param id
     * @param body
     */
    public replaceOneBaseCourseBlockStepAdminControllerCourseBlockStep(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single CourseBlockStep
     * @param id
     * @param body
     */
    public updateOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCourseBlockStepAdminControllerCourseBlockStep(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single CourseBlockStep
     * @param id
     * @param body
     */
    public updateOneBaseCourseBlockStepAdminControllerCourseBlockStep(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCourseBlockStepAdminControllerCourseBlockStepWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINCourseBlockStepAnswerApiRequestFactory, ADMINCourseBlockStepAnswerApiResponseProcessor} from "../apis/ADMINCourseBlockStepAnswerApi";
export class ObservableADMINCourseBlockStepAnswerApi {
    private requestFactory: ADMINCourseBlockStepAnswerApiRequestFactory;
    private responseProcessor: ADMINCourseBlockStepAnswerApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCourseBlockStepAnswerApiRequestFactory,
        responseProcessor?: ADMINCourseBlockStepAnswerApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCourseBlockStepAnswerApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCourseBlockStepAnswerApiResponseProcessor();
    }

    /**
     * Create a single CourseBlockStepAnswer
     * @param body
     */
    public createOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single CourseBlockStepAnswer
     * @param body
     */
    public createOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single CourseBlockStepAnswer
     * @param id
     */
    public deleteOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single CourseBlockStepAnswer
     * @param id
     */
    public deleteOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple CourseBlockStepAnswers
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CourseBlockStepAnswers
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer200Response> {
        return this.getManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single CourseBlockStepAnswer
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CourseBlockStepAnswer
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single CourseBlockStepAnswer
     * @param id
     * @param body
     */
    public replaceOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single CourseBlockStepAnswer
     * @param id
     * @param body
     */
    public replaceOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single CourseBlockStepAnswer
     * @param id
     * @param body
     */
    public updateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single CourseBlockStepAnswer
     * @param id
     * @param body
     */
    public updateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswer(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCourseBlockStepAnswerAdminControllerCourseBlockStepAnswerWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINCourseCategoriesApiRequestFactory, ADMINCourseCategoriesApiResponseProcessor} from "../apis/ADMINCourseCategoriesApi";
export class ObservableADMINCourseCategoriesApi {
    private requestFactory: ADMINCourseCategoriesApiRequestFactory;
    private responseProcessor: ADMINCourseCategoriesApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCourseCategoriesApiRequestFactory,
        responseProcessor?: ADMINCourseCategoriesApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCourseCategoriesApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCourseCategoriesApiResponseProcessor();
    }

    /**
     * Create multiple ArticleCategories
     * @param createManyArticleCategoryDto
     */
    public createManyBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(createManyArticleCategoryDto: CreateManyArticleCategoryDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<ArticleCategory>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseArticleCategoryCourseAdminControllerArticleCategory(createManyArticleCategoryDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple ArticleCategories
     * @param createManyArticleCategoryDto
     */
    public createManyBaseArticleCategoryCourseAdminControllerArticleCategory(createManyArticleCategoryDto: CreateManyArticleCategoryDto, _options?: ConfigurationOptions): Observable<Array<ArticleCategory>> {
        return this.createManyBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(createManyArticleCategoryDto, _options).pipe(map((apiResponse: HttpInfo<Array<ArticleCategory>>) => apiResponse.data));
    }

    /**
     * Create a single ArticleCategory
     * @param articleCategory
     */
    public createOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseArticleCategoryCourseAdminControllerArticleCategory(articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single ArticleCategory
     * @param articleCategory
     */
    public createOneBaseArticleCategoryCourseAdminControllerArticleCategory(articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.createOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Delete a single ArticleCategory
     * @param id
     */
    public deleteOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseArticleCategoryCourseAdminControllerArticleCategory(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single ArticleCategory
     * @param id
     */
    public deleteOneBaseArticleCategoryCourseAdminControllerArticleCategory(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseArticleCategoryCourseAdminControllerArticleCategory(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleCategoryCourseAdminControllerArticleCategory(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response> {
        return this.getManyBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single ArticleCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseArticleCategoryCourseAdminControllerArticleCategory(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single ArticleCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleCategoryCourseAdminControllerArticleCategory(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.getOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Replace a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public replaceOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseArticleCategoryCourseAdminControllerArticleCategory(id, articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public replaceOneBaseArticleCategoryCourseAdminControllerArticleCategory(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.replaceOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(id, articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Update a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public updateOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseArticleCategoryCourseAdminControllerArticleCategory(id, articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public updateOneBaseArticleCategoryCourseAdminControllerArticleCategory(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.updateOneBaseArticleCategoryCourseAdminControllerArticleCategoryWithHttpInfo(id, articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

}

import { ADMINCourseCompilationCategoriesApiRequestFactory, ADMINCourseCompilationCategoriesApiResponseProcessor} from "../apis/ADMINCourseCompilationCategoriesApi";
export class ObservableADMINCourseCompilationCategoriesApi {
    private requestFactory: ADMINCourseCompilationCategoriesApiRequestFactory;
    private responseProcessor: ADMINCourseCompilationCategoriesApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCourseCompilationCategoriesApiRequestFactory,
        responseProcessor?: ADMINCourseCompilationCategoriesApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCourseCompilationCategoriesApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCourseCompilationCategoriesApiResponseProcessor();
    }

    /**
     * Create multiple ArticleCategories
     * @param createManyArticleCategoryDto
     */
    public createManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(createManyArticleCategoryDto: CreateManyArticleCategoryDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<ArticleCategory>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(createManyArticleCategoryDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple ArticleCategories
     * @param createManyArticleCategoryDto
     */
    public createManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(createManyArticleCategoryDto: CreateManyArticleCategoryDto, _options?: ConfigurationOptions): Observable<Array<ArticleCategory>> {
        return this.createManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(createManyArticleCategoryDto, _options).pipe(map((apiResponse: HttpInfo<Array<ArticleCategory>>) => apiResponse.data));
    }

    /**
     * Create a single ArticleCategory
     * @param articleCategory
     */
    public createOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single ArticleCategory
     * @param articleCategory
     */
    public createOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.createOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Delete a single ArticleCategory
     * @param id
     */
    public deleteOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single ArticleCategory
     * @param id
     */
    public deleteOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple ArticleCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response> {
        return this.getManyBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseArticleCategoryAdminControllerArticleCategory200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single ArticleCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single ArticleCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.getOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Replace a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public replaceOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(id, articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public replaceOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.replaceOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(id, articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     * Update a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public updateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(id, articleCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single ArticleCategory
     * @param id
     * @param articleCategory
     */
    public updateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategory(id: number, articleCategory: ArticleCategory, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.updateOneBaseArticleCategoryCourseCompilationAdminControllerArticleCategoryWithHttpInfo(id, articleCategory, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

}

import { ADMINCourseItemsApiRequestFactory, ADMINCourseItemsApiResponseProcessor} from "../apis/ADMINCourseItemsApi";
export class ObservableADMINCourseItemsApi {
    private requestFactory: ADMINCourseItemsApiRequestFactory;
    private responseProcessor: ADMINCourseItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCourseItemsApiRequestFactory,
        responseProcessor?: ADMINCourseItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCourseItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCourseItemsApiResponseProcessor();
    }

    /**
     * Create a single Course
     * @param course
     */
    public createOneBaseCourseAdminControllerCourseWithHttpInfo(course: Course, _options?: ConfigurationOptions): Observable<HttpInfo<Course>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCourseAdminControllerCourse(course, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCourseAdminControllerCourseWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Course
     * @param course
     */
    public createOneBaseCourseAdminControllerCourse(course: Course, _options?: ConfigurationOptions): Observable<Course> {
        return this.createOneBaseCourseAdminControllerCourseWithHttpInfo(course, _options).pipe(map((apiResponse: HttpInfo<Course>) => apiResponse.data));
    }

    /**
     * Delete a single Course
     * @param id
     */
    public deleteOneBaseCourseAdminControllerCourseWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCourseAdminControllerCourse(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCourseAdminControllerCourseWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Course
     * @param id
     */
    public deleteOneBaseCourseAdminControllerCourse(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCourseAdminControllerCourseWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Courses
     * @param lang
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseAdminControllerCourseWithHttpInfo(lang: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCourseAdminControllerCourse(lang, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCourseAdminControllerCourseWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Courses
     * @param lang
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseAdminControllerCourse(lang: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseCourseAdminControllerCourseWithHttpInfo(lang, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single Course
     * @param lang
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseAdminControllerCourseWithHttpInfo(lang: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCourseAdminControllerCourse(lang, id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCourseAdminControllerCourseWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Course
     * @param lang
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseAdminControllerCourse(lang: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCourseAdminControllerCourseWithHttpInfo(lang, id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Course
     * @param id
     * @param course
     */
    public replaceOneBaseCourseAdminControllerCourseWithHttpInfo(id: number, course: Course, _options?: ConfigurationOptions): Observable<HttpInfo<Course>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCourseAdminControllerCourse(id, course, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCourseAdminControllerCourseWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Course
     * @param id
     * @param course
     */
    public replaceOneBaseCourseAdminControllerCourse(id: number, course: Course, _options?: ConfigurationOptions): Observable<Course> {
        return this.replaceOneBaseCourseAdminControllerCourseWithHttpInfo(id, course, _options).pipe(map((apiResponse: HttpInfo<Course>) => apiResponse.data));
    }

    /**
     * Update a single Course
     * @param id
     * @param course
     */
    public updateOneBaseCourseAdminControllerCourseWithHttpInfo(id: number, course: Course, _options?: ConfigurationOptions): Observable<HttpInfo<Course>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCourseAdminControllerCourse(id, course, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCourseAdminControllerCourseWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Course
     * @param id
     * @param course
     */
    public updateOneBaseCourseAdminControllerCourse(id: number, course: Course, _options?: ConfigurationOptions): Observable<Course> {
        return this.updateOneBaseCourseAdminControllerCourseWithHttpInfo(id, course, _options).pipe(map((apiResponse: HttpInfo<Course>) => apiResponse.data));
    }

}

import { ADMINCourseModulesApiRequestFactory, ADMINCourseModulesApiResponseProcessor} from "../apis/ADMINCourseModulesApi";
export class ObservableADMINCourseModulesApi {
    private requestFactory: ADMINCourseModulesApiRequestFactory;
    private responseProcessor: ADMINCourseModulesApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCourseModulesApiRequestFactory,
        responseProcessor?: ADMINCourseModulesApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCourseModulesApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCourseModulesApiResponseProcessor();
    }

    /**
     * Create a single CourseModule
     * @param body
     */
    public createOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCourseModuleAdminControllerCourseModule(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single CourseModule
     * @param body
     */
    public createOneBaseCourseModuleAdminControllerCourseModule(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single CourseModule
     * @param id
     */
    public deleteOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCourseModuleAdminControllerCourseModule(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single CourseModule
     * @param id
     */
    public deleteOneBaseCourseModuleAdminControllerCourseModule(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple CourseModules
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseCourseModuleAdminControllerCourseModule200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCourseModuleAdminControllerCourseModule(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CourseModules
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseModuleAdminControllerCourseModule(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseCourseModuleAdminControllerCourseModule200Response> {
        return this.getManyBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseCourseModuleAdminControllerCourseModule200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single CourseModule
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCourseModuleAdminControllerCourseModule(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CourseModule
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseModuleAdminControllerCourseModule(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single CourseModule
     * @param id
     * @param body
     */
    public replaceOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCourseModuleAdminControllerCourseModule(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single CourseModule
     * @param id
     * @param body
     */
    public replaceOneBaseCourseModuleAdminControllerCourseModule(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single CourseModule
     * @param id
     * @param body
     */
    public updateOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCourseModuleAdminControllerCourseModule(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single CourseModule
     * @param id
     * @param body
     */
    public updateOneBaseCourseModuleAdminControllerCourseModule(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCourseModuleAdminControllerCourseModuleWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINCourseNewsApiRequestFactory, ADMINCourseNewsApiResponseProcessor} from "../apis/ADMINCourseNewsApi";
export class ObservableADMINCourseNewsApi {
    private requestFactory: ADMINCourseNewsApiRequestFactory;
    private responseProcessor: ADMINCourseNewsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCourseNewsApiRequestFactory,
        responseProcessor?: ADMINCourseNewsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCourseNewsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCourseNewsApiResponseProcessor();
    }

    /**
     * Create a single Article
     * @param body
     */
    public createOneBaseCourseNewsAdminControllerArticleWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCourseNewsAdminControllerArticle(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCourseNewsAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Article
     * @param body
     */
    public createOneBaseCourseNewsAdminControllerArticle(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCourseNewsAdminControllerArticleWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Article
     * @param id
     */
    public deleteOneBaseCourseNewsAdminControllerArticleWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCourseNewsAdminControllerArticle(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCourseNewsAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Article
     * @param id
     */
    public deleteOneBaseCourseNewsAdminControllerArticle(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCourseNewsAdminControllerArticleWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Articles
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseNewsAdminControllerArticleWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCourseNewsAdminControllerArticle(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCourseNewsAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Articles
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseNewsAdminControllerArticle(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseArticleKnowledgeAdminControllerArticle200Response> {
        return this.getManyBaseCourseNewsAdminControllerArticleWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Article
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseNewsAdminControllerArticleWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCourseNewsAdminControllerArticle(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCourseNewsAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Article
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseNewsAdminControllerArticle(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCourseNewsAdminControllerArticleWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Article
     * @param id
     * @param body
     */
    public replaceOneBaseCourseNewsAdminControllerArticleWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCourseNewsAdminControllerArticle(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCourseNewsAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Article
     * @param id
     * @param body
     */
    public replaceOneBaseCourseNewsAdminControllerArticle(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseCourseNewsAdminControllerArticleWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Article
     * @param id
     * @param body
     */
    public updateOneBaseCourseNewsAdminControllerArticleWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCourseNewsAdminControllerArticle(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCourseNewsAdminControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Article
     * @param id
     * @param body
     */
    public updateOneBaseCourseNewsAdminControllerArticle(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCourseNewsAdminControllerArticleWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINCoverLetterItemsApiRequestFactory, ADMINCoverLetterItemsApiResponseProcessor} from "../apis/ADMINCoverLetterItemsApi";
export class ObservableADMINCoverLetterItemsApi {
    private requestFactory: ADMINCoverLetterItemsApiRequestFactory;
    private responseProcessor: ADMINCoverLetterItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINCoverLetterItemsApiRequestFactory,
        responseProcessor?: ADMINCoverLetterItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINCoverLetterItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINCoverLetterItemsApiResponseProcessor();
    }

    /**
     * Create multiple CoverLetters
     * @param createManyCoverLetterDto
     */
    public createManyBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(createManyCoverLetterDto: CreateManyCoverLetterDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseCoverLetterAdminControllerCoverLetter(createManyCoverLetterDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple CoverLetters
     * @param createManyCoverLetterDto
     */
    public createManyBaseCoverLetterAdminControllerCoverLetter(createManyCoverLetterDto: CreateManyCoverLetterDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(createManyCoverLetterDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single CoverLetter
     * @param body
     */
    public createOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCoverLetterAdminControllerCoverLetter(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single CoverLetter
     * @param body
     */
    public createOneBaseCoverLetterAdminControllerCoverLetter(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single CoverLetter
     * @param id
     */
    public deleteOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCoverLetterAdminControllerCoverLetter(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single CoverLetter
     * @param id
     */
    public deleteOneBaseCoverLetterAdminControllerCoverLetter(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple CoverLetters
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseCoverLetterAdminControllerCoverLetter200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCoverLetterAdminControllerCoverLetter(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CoverLetters
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCoverLetterAdminControllerCoverLetter(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseCoverLetterAdminControllerCoverLetter200Response> {
        return this.getManyBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseCoverLetterAdminControllerCoverLetter200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single CoverLetter
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCoverLetterAdminControllerCoverLetter(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CoverLetter
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCoverLetterAdminControllerCoverLetter(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single CoverLetter
     * @param id
     * @param body
     */
    public replaceOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseCoverLetterAdminControllerCoverLetter(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single CoverLetter
     * @param id
     * @param body
     */
    public replaceOneBaseCoverLetterAdminControllerCoverLetter(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single CoverLetter
     * @param id
     * @param body
     */
    public updateOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCoverLetterAdminControllerCoverLetter(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single CoverLetter
     * @param id
     * @param body
     */
    public updateOneBaseCoverLetterAdminControllerCoverLetter(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCoverLetterAdminControllerCoverLetterWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINDataVerticalApiRequestFactory, ADMINDataVerticalApiResponseProcessor} from "../apis/ADMINDataVerticalApi";
export class ObservableADMINDataVerticalApi {
    private requestFactory: ADMINDataVerticalApiRequestFactory;
    private responseProcessor: ADMINDataVerticalApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINDataVerticalApiRequestFactory,
        responseProcessor?: ADMINDataVerticalApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINDataVerticalApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINDataVerticalApiResponseProcessor();
    }

    /**
     * Create multiple Verticals
     * @param createManyVerticalDto
     */
    public createManyBaseVerticalAdminControllerVerticalWithHttpInfo(createManyVerticalDto: CreateManyVerticalDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseVerticalAdminControllerVertical(createManyVerticalDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseVerticalAdminControllerVerticalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Verticals
     * @param createManyVerticalDto
     */
    public createManyBaseVerticalAdminControllerVertical(createManyVerticalDto: CreateManyVerticalDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseVerticalAdminControllerVerticalWithHttpInfo(createManyVerticalDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Vertical
     * @param body
     */
    public createOneBaseVerticalAdminControllerVerticalWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseVerticalAdminControllerVertical(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseVerticalAdminControllerVerticalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Vertical
     * @param body
     */
    public createOneBaseVerticalAdminControllerVertical(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseVerticalAdminControllerVerticalWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Vertical
     * @param id
     */
    public deleteOneBaseVerticalAdminControllerVerticalWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseVerticalAdminControllerVertical(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseVerticalAdminControllerVerticalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Vertical
     * @param id
     */
    public deleteOneBaseVerticalAdminControllerVertical(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseVerticalAdminControllerVerticalWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Verticals
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseVerticalAdminControllerVerticalWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseVerticalAdminControllerVertical200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseVerticalAdminControllerVertical(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseVerticalAdminControllerVerticalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Verticals
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseVerticalAdminControllerVertical(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseVerticalAdminControllerVertical200Response> {
        return this.getManyBaseVerticalAdminControllerVerticalWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseVerticalAdminControllerVertical200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Vertical
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseVerticalAdminControllerVerticalWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseVerticalAdminControllerVertical(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseVerticalAdminControllerVerticalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Vertical
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseVerticalAdminControllerVertical(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseVerticalAdminControllerVerticalWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Vertical
     * @param id
     * @param body
     */
    public replaceOneBaseVerticalAdminControllerVerticalWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseVerticalAdminControllerVertical(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseVerticalAdminControllerVerticalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Vertical
     * @param id
     * @param body
     */
    public replaceOneBaseVerticalAdminControllerVertical(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseVerticalAdminControllerVerticalWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Vertical
     * @param id
     * @param body
     */
    public updateOneBaseVerticalAdminControllerVerticalWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseVerticalAdminControllerVertical(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseVerticalAdminControllerVerticalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Vertical
     * @param id
     * @param body
     */
    public updateOneBaseVerticalAdminControllerVertical(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseVerticalAdminControllerVerticalWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINFavouriteFoldersApiRequestFactory, ADMINFavouriteFoldersApiResponseProcessor} from "../apis/ADMINFavouriteFoldersApi";
export class ObservableADMINFavouriteFoldersApi {
    private requestFactory: ADMINFavouriteFoldersApiRequestFactory;
    private responseProcessor: ADMINFavouriteFoldersApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINFavouriteFoldersApiRequestFactory,
        responseProcessor?: ADMINFavouriteFoldersApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINFavouriteFoldersApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINFavouriteFoldersApiResponseProcessor();
    }

    /**
     * Create multiple FavouriteFolders
     * @param createManyFavouriteFolderDto
     */
    public createManyBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(createManyFavouriteFolderDto: CreateManyFavouriteFolderDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseFavouriteFolderAdminControllerFavouriteFolder(createManyFavouriteFolderDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple FavouriteFolders
     * @param createManyFavouriteFolderDto
     */
    public createManyBaseFavouriteFolderAdminControllerFavouriteFolder(createManyFavouriteFolderDto: CreateManyFavouriteFolderDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(createManyFavouriteFolderDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single FavouriteFolder
     * @param body
     */
    public createOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseFavouriteFolderAdminControllerFavouriteFolder(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single FavouriteFolder
     * @param body
     */
    public createOneBaseFavouriteFolderAdminControllerFavouriteFolder(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single FavouriteFolder
     * @param id
     */
    public deleteOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseFavouriteFolderAdminControllerFavouriteFolder(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single FavouriteFolder
     * @param id
     */
    public deleteOneBaseFavouriteFolderAdminControllerFavouriteFolder(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple FavouriteFolders
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseFavouriteFolderAdminControllerFavouriteFolder200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseFavouriteFolderAdminControllerFavouriteFolder(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple FavouriteFolders
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseFavouriteFolderAdminControllerFavouriteFolder(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseFavouriteFolderAdminControllerFavouriteFolder200Response> {
        return this.getManyBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseFavouriteFolderAdminControllerFavouriteFolder200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single FavouriteFolder
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseFavouriteFolderAdminControllerFavouriteFolder(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single FavouriteFolder
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseFavouriteFolderAdminControllerFavouriteFolder(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single FavouriteFolder
     * @param id
     * @param body
     */
    public replaceOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseFavouriteFolderAdminControllerFavouriteFolder(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single FavouriteFolder
     * @param id
     * @param body
     */
    public replaceOneBaseFavouriteFolderAdminControllerFavouriteFolder(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single FavouriteFolder
     * @param id
     * @param body
     */
    public updateOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseFavouriteFolderAdminControllerFavouriteFolder(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single FavouriteFolder
     * @param id
     * @param body
     */
    public updateOneBaseFavouriteFolderAdminControllerFavouriteFolder(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseFavouriteFolderAdminControllerFavouriteFolderWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINFeedbackItemsApiRequestFactory, ADMINFeedbackItemsApiResponseProcessor} from "../apis/ADMINFeedbackItemsApi";
export class ObservableADMINFeedbackItemsApi {
    private requestFactory: ADMINFeedbackItemsApiRequestFactory;
    private responseProcessor: ADMINFeedbackItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINFeedbackItemsApiRequestFactory,
        responseProcessor?: ADMINFeedbackItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINFeedbackItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINFeedbackItemsApiResponseProcessor();
    }

    /**
     * Create multiple Feedbacks
     * @param createManyFeedbackDto
     */
    public createManyBaseFeedbackAdminControllerFeedbackWithHttpInfo(createManyFeedbackDto: CreateManyFeedbackDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseFeedbackAdminControllerFeedback(createManyFeedbackDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseFeedbackAdminControllerFeedbackWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Feedbacks
     * @param createManyFeedbackDto
     */
    public createManyBaseFeedbackAdminControllerFeedback(createManyFeedbackDto: CreateManyFeedbackDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseFeedbackAdminControllerFeedbackWithHttpInfo(createManyFeedbackDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Feedback
     * @param body
     */
    public createOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseFeedbackAdminControllerFeedback(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Feedback
     * @param body
     */
    public createOneBaseFeedbackAdminControllerFeedback(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Feedback
     * @param id
     */
    public deleteOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseFeedbackAdminControllerFeedback(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Feedback
     * @param id
     */
    public deleteOneBaseFeedbackAdminControllerFeedback(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Feedbacks
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseFeedbackAdminControllerFeedbackWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseFeedbackAdminControllerFeedback200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseFeedbackAdminControllerFeedback(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseFeedbackAdminControllerFeedbackWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Feedbacks
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseFeedbackAdminControllerFeedback(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseFeedbackAdminControllerFeedback200Response> {
        return this.getManyBaseFeedbackAdminControllerFeedbackWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseFeedbackAdminControllerFeedback200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Feedback
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseFeedbackAdminControllerFeedback(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Feedback
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseFeedbackAdminControllerFeedback(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Feedback
     * @param id
     * @param body
     */
    public replaceOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseFeedbackAdminControllerFeedback(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Feedback
     * @param id
     * @param body
     */
    public replaceOneBaseFeedbackAdminControllerFeedback(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Feedback
     * @param id
     * @param body
     */
    public updateOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseFeedbackAdminControllerFeedback(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Feedback
     * @param id
     * @param body
     */
    public updateOneBaseFeedbackAdminControllerFeedback(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseFeedbackAdminControllerFeedbackWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINGeoItemsApiRequestFactory, ADMINGeoItemsApiResponseProcessor} from "../apis/ADMINGeoItemsApi";
export class ObservableADMINGeoItemsApi {
    private requestFactory: ADMINGeoItemsApiRequestFactory;
    private responseProcessor: ADMINGeoItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINGeoItemsApiRequestFactory,
        responseProcessor?: ADMINGeoItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINGeoItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINGeoItemsApiResponseProcessor();
    }

    /**
     * Create multiple Geos
     * @param createManyGeoDto
     */
    public createManyBaseGeoAdminControllerGeoWithHttpInfo(createManyGeoDto: CreateManyGeoDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseGeoAdminControllerGeo(createManyGeoDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseGeoAdminControllerGeoWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Geos
     * @param createManyGeoDto
     */
    public createManyBaseGeoAdminControllerGeo(createManyGeoDto: CreateManyGeoDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseGeoAdminControllerGeoWithHttpInfo(createManyGeoDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Geo
     * @param body
     */
    public createOneBaseGeoAdminControllerGeoWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseGeoAdminControllerGeo(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseGeoAdminControllerGeoWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Geo
     * @param body
     */
    public createOneBaseGeoAdminControllerGeo(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseGeoAdminControllerGeoWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Geo
     * @param id
     */
    public deleteOneBaseGeoAdminControllerGeoWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseGeoAdminControllerGeo(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseGeoAdminControllerGeoWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Geo
     * @param id
     */
    public deleteOneBaseGeoAdminControllerGeo(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseGeoAdminControllerGeoWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Geos
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseGeoAdminControllerGeoWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseGeoAdminControllerGeo200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseGeoAdminControllerGeo(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseGeoAdminControllerGeoWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Geos
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseGeoAdminControllerGeo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseGeoAdminControllerGeo200Response> {
        return this.getManyBaseGeoAdminControllerGeoWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseGeoAdminControllerGeo200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Geo
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseGeoAdminControllerGeoWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseGeoAdminControllerGeo(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseGeoAdminControllerGeoWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Geo
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseGeoAdminControllerGeo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseGeoAdminControllerGeoWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Geo
     * @param id
     * @param body
     */
    public replaceOneBaseGeoAdminControllerGeoWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseGeoAdminControllerGeo(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseGeoAdminControllerGeoWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Geo
     * @param id
     * @param body
     */
    public replaceOneBaseGeoAdminControllerGeo(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseGeoAdminControllerGeoWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Geo
     * @param id
     * @param body
     */
    public updateOneBaseGeoAdminControllerGeoWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseGeoAdminControllerGeo(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseGeoAdminControllerGeoWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Geo
     * @param id
     * @param body
     */
    public updateOneBaseGeoAdminControllerGeo(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseGeoAdminControllerGeoWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINLocationItemsApiRequestFactory, ADMINLocationItemsApiResponseProcessor} from "../apis/ADMINLocationItemsApi";
export class ObservableADMINLocationItemsApi {
    private requestFactory: ADMINLocationItemsApiRequestFactory;
    private responseProcessor: ADMINLocationItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINLocationItemsApiRequestFactory,
        responseProcessor?: ADMINLocationItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINLocationItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINLocationItemsApiResponseProcessor();
    }

    /**
     * Create multiple Geonames
     * @param createManyGeonameDto
     */
    public createManyBaseLocationAdminControllerGeonameWithHttpInfo(createManyGeonameDto: CreateManyGeonameDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseLocationAdminControllerGeoname(createManyGeonameDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseLocationAdminControllerGeonameWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Geonames
     * @param createManyGeonameDto
     */
    public createManyBaseLocationAdminControllerGeoname(createManyGeonameDto: CreateManyGeonameDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseLocationAdminControllerGeonameWithHttpInfo(createManyGeonameDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Geoname
     * @param body
     */
    public createOneBaseLocationAdminControllerGeonameWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseLocationAdminControllerGeoname(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseLocationAdminControllerGeonameWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Geoname
     * @param body
     */
    public createOneBaseLocationAdminControllerGeoname(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseLocationAdminControllerGeonameWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Geoname
     * @param id
     */
    public deleteOneBaseLocationAdminControllerGeonameWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseLocationAdminControllerGeoname(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseLocationAdminControllerGeonameWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Geoname
     * @param id
     */
    public deleteOneBaseLocationAdminControllerGeoname(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseLocationAdminControllerGeonameWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Geonames
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseLocationAdminControllerGeonameWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseLocationAdminControllerGeoname200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseLocationAdminControllerGeoname(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseLocationAdminControllerGeonameWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Geonames
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseLocationAdminControllerGeoname(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseLocationAdminControllerGeoname200Response> {
        return this.getManyBaseLocationAdminControllerGeonameWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseLocationAdminControllerGeoname200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Geoname
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseLocationAdminControllerGeonameWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseLocationAdminControllerGeoname(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseLocationAdminControllerGeonameWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Geoname
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseLocationAdminControllerGeoname(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseLocationAdminControllerGeonameWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Geoname
     * @param id
     * @param body
     */
    public replaceOneBaseLocationAdminControllerGeonameWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseLocationAdminControllerGeoname(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseLocationAdminControllerGeonameWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Geoname
     * @param id
     * @param body
     */
    public replaceOneBaseLocationAdminControllerGeoname(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseLocationAdminControllerGeonameWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Geoname
     * @param id
     * @param body
     */
    public updateOneBaseLocationAdminControllerGeonameWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseLocationAdminControllerGeoname(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseLocationAdminControllerGeonameWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Geoname
     * @param id
     * @param body
     */
    public updateOneBaseLocationAdminControllerGeoname(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseLocationAdminControllerGeonameWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINManagerItemsApiRequestFactory, ADMINManagerItemsApiResponseProcessor} from "../apis/ADMINManagerItemsApi";
export class ObservableADMINManagerItemsApi {
    private requestFactory: ADMINManagerItemsApiRequestFactory;
    private responseProcessor: ADMINManagerItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINManagerItemsApiRequestFactory,
        responseProcessor?: ADMINManagerItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINManagerItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINManagerItemsApiResponseProcessor();
    }

    /**
     * Create multiple Profiles
     * @param createManyProfileDto
     */
    public createManyBaseManagerAdminControllerProfileWithHttpInfo(createManyProfileDto: CreateManyProfileDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseManagerAdminControllerProfile(createManyProfileDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseManagerAdminControllerProfileWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Profiles
     * @param createManyProfileDto
     */
    public createManyBaseManagerAdminControllerProfile(createManyProfileDto: CreateManyProfileDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseManagerAdminControllerProfileWithHttpInfo(createManyProfileDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Profile
     * @param body
     */
    public createOneBaseManagerAdminControllerProfileWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseManagerAdminControllerProfile(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseManagerAdminControllerProfileWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Profile
     * @param body
     */
    public createOneBaseManagerAdminControllerProfile(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseManagerAdminControllerProfileWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Profile
     * @param id
     */
    public deleteOneBaseManagerAdminControllerProfileWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseManagerAdminControllerProfile(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseManagerAdminControllerProfileWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Profile
     * @param id
     */
    public deleteOneBaseManagerAdminControllerProfile(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseManagerAdminControllerProfileWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Profiles
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseManagerAdminControllerProfileWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseManagerAdminControllerProfile200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseManagerAdminControllerProfile(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseManagerAdminControllerProfileWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Profiles
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseManagerAdminControllerProfile(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseManagerAdminControllerProfile200Response> {
        return this.getManyBaseManagerAdminControllerProfileWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseManagerAdminControllerProfile200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Profile
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseManagerAdminControllerProfileWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseManagerAdminControllerProfile(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseManagerAdminControllerProfileWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Profile
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseManagerAdminControllerProfile(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseManagerAdminControllerProfileWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Profile
     * @param id
     * @param body
     */
    public replaceOneBaseManagerAdminControllerProfileWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseManagerAdminControllerProfile(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseManagerAdminControllerProfileWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Profile
     * @param id
     * @param body
     */
    public replaceOneBaseManagerAdminControllerProfile(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseManagerAdminControllerProfileWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Profile
     * @param id
     * @param body
     */
    public updateOneBaseManagerAdminControllerProfileWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseManagerAdminControllerProfile(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseManagerAdminControllerProfileWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Profile
     * @param id
     * @param body
     */
    public updateOneBaseManagerAdminControllerProfile(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseManagerAdminControllerProfileWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINNotificationCreateNotificationApiRequestFactory, ADMINNotificationCreateNotificationApiResponseProcessor} from "../apis/ADMINNotificationCreateNotificationApi";
export class ObservableADMINNotificationCreateNotificationApi {
    private requestFactory: ADMINNotificationCreateNotificationApiRequestFactory;
    private responseProcessor: ADMINNotificationCreateNotificationApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINNotificationCreateNotificationApiRequestFactory,
        responseProcessor?: ADMINNotificationCreateNotificationApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINNotificationCreateNotificationApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINNotificationCreateNotificationApiResponseProcessor();
    }

    /**
     * @param notificationCustomContentDTO
     */
    public create0WithHttpInfo(notificationCustomContentDTO: NotificationCustomContentDTO, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.create0(notificationCustomContentDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.create0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param notificationCustomContentDTO
     */
    public create0(notificationCustomContentDTO: NotificationCustomContentDTO, _options?: ConfigurationOptions): Observable<void> {
        return this.create0WithHttpInfo(notificationCustomContentDTO, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

}

import { ADMINOrderItemsApiRequestFactory, ADMINOrderItemsApiResponseProcessor} from "../apis/ADMINOrderItemsApi";
export class ObservableADMINOrderItemsApi {
    private requestFactory: ADMINOrderItemsApiRequestFactory;
    private responseProcessor: ADMINOrderItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINOrderItemsApiRequestFactory,
        responseProcessor?: ADMINOrderItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINOrderItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINOrderItemsApiResponseProcessor();
    }

    /**
     * Create admin order
     * @param locale
     * @param id
     * @param adminCreateOrderDto
     */
    public createOrder0WithHttpInfo(locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu', id: number, adminCreateOrderDto: AdminCreateOrderDto, _options?: ConfigurationOptions): Observable<HttpInfo<OrderEntity | any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOrder0(locale, id, adminCreateOrderDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOrder0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Create admin order
     * @param locale
     * @param id
     * @param adminCreateOrderDto
     */
    public createOrder0(locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu', id: number, adminCreateOrderDto: AdminCreateOrderDto, _options?: ConfigurationOptions): Observable<OrderEntity | any> {
        return this.createOrder0WithHttpInfo(locale, id, adminCreateOrderDto, _options).pipe(map((apiResponse: HttpInfo<OrderEntity | any>) => apiResponse.data));
    }

}

import { ADMINOrderTransactionsApiRequestFactory, ADMINOrderTransactionsApiResponseProcessor} from "../apis/ADMINOrderTransactionsApi";
export class ObservableADMINOrderTransactionsApi {
    private requestFactory: ADMINOrderTransactionsApiRequestFactory;
    private responseProcessor: ADMINOrderTransactionsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINOrderTransactionsApiRequestFactory,
        responseProcessor?: ADMINOrderTransactionsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINOrderTransactionsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINOrderTransactionsApiResponseProcessor();
    }

    /**
     * Refund order
     * @param id
     */
    public cancallOrder0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<OrderEntity>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.cancallOrder0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.cancallOrder0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Refund order
     * @param id
     */
    public cancallOrder0(id: number, _options?: ConfigurationOptions): Observable<OrderEntity> {
        return this.cancallOrder0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<OrderEntity>) => apiResponse.data));
    }

    /**
     * Returns an array orders
     * @param [orderIds] Array of order IDs
     * @param [profileIds] Array of user IDs
     * @param [statuses] Array of order statuses
     * @param [productIds] Array of product IDs
     * @param [productTypes] Array of product types
     * @param [dateFrom] Date from
     * @param [dateTo] Date to
     * @param [limit] Limit of orders to return
     * @param [offset] Offset of orders to return
     * @param [sortMethod] Sort method
     * @param [sortBy] Sort by
     * @param [remoteIds] Array of remote order IDs
     * @param [orderIds2] Array of order IDs
     * @param [profileIds2] Array of user IDs
     * @param [statuses2] Array of order statuses
     * @param [productIds2] Array of product IDs
     * @param [productTypes2] Array of product types
     * @param [dateFrom2] Date from
     * @param [dateTo2] Date to
     * @param [limit2] Limit of orders to return
     * @param [offset2] Offset of orders to return
     * @param [sortMethod2] Sort method
     * @param [sortBy2] Sort by
     * @param [remoteIds2] Array of remote order IDs
     */
    public findAllOrdersOwned0WithHttpInfo(orderIds?: Array<number>, profileIds?: Array<number>, statuses?: Array<string>, productIds?: Array<number>, productTypes?: Array<string>, dateFrom?: string, dateTo?: string, limit?: number, offset?: number, sortMethod?: string, sortBy?: string, remoteIds?: Array<string>, orderIds2?: Array<string>, profileIds2?: Array<string>, statuses2?: Array<string>, productIds2?: Array<string>, productTypes2?: Array<string>, dateFrom2?: string, dateTo2?: string, limit2?: number, offset2?: number, sortMethod2?: string, sortBy2?: string, remoteIds2?: Array<string>, _options?: ConfigurationOptions): Observable<HttpInfo<Array<AdminOrderTransactionsPaginationDTO>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findAllOrdersOwned0(orderIds, profileIds, statuses, productIds, productTypes, dateFrom, dateTo, limit, offset, sortMethod, sortBy, remoteIds, orderIds2, profileIds2, statuses2, productIds2, productTypes2, dateFrom2, dateTo2, limit2, offset2, sortMethod2, sortBy2, remoteIds2, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findAllOrdersOwned0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns an array orders
     * @param [orderIds] Array of order IDs
     * @param [profileIds] Array of user IDs
     * @param [statuses] Array of order statuses
     * @param [productIds] Array of product IDs
     * @param [productTypes] Array of product types
     * @param [dateFrom] Date from
     * @param [dateTo] Date to
     * @param [limit] Limit of orders to return
     * @param [offset] Offset of orders to return
     * @param [sortMethod] Sort method
     * @param [sortBy] Sort by
     * @param [remoteIds] Array of remote order IDs
     * @param [orderIds2] Array of order IDs
     * @param [profileIds2] Array of user IDs
     * @param [statuses2] Array of order statuses
     * @param [productIds2] Array of product IDs
     * @param [productTypes2] Array of product types
     * @param [dateFrom2] Date from
     * @param [dateTo2] Date to
     * @param [limit2] Limit of orders to return
     * @param [offset2] Offset of orders to return
     * @param [sortMethod2] Sort method
     * @param [sortBy2] Sort by
     * @param [remoteIds2] Array of remote order IDs
     */
    public findAllOrdersOwned0(orderIds?: Array<number>, profileIds?: Array<number>, statuses?: Array<string>, productIds?: Array<number>, productTypes?: Array<string>, dateFrom?: string, dateTo?: string, limit?: number, offset?: number, sortMethod?: string, sortBy?: string, remoteIds?: Array<string>, orderIds2?: Array<string>, profileIds2?: Array<string>, statuses2?: Array<string>, productIds2?: Array<string>, productTypes2?: Array<string>, dateFrom2?: string, dateTo2?: string, limit2?: number, offset2?: number, sortMethod2?: string, sortBy2?: string, remoteIds2?: Array<string>, _options?: ConfigurationOptions): Observable<Array<AdminOrderTransactionsPaginationDTO>> {
        return this.findAllOrdersOwned0WithHttpInfo(orderIds, profileIds, statuses, productIds, productTypes, dateFrom, dateTo, limit, offset, sortMethod, sortBy, remoteIds, orderIds2, profileIds2, statuses2, productIds2, productTypes2, dateFrom2, dateTo2, limit2, offset2, sortMethod2, sortBy2, remoteIds2, _options).pipe(map((apiResponse: HttpInfo<Array<AdminOrderTransactionsPaginationDTO>>) => apiResponse.data));
    }

}

import { ADMINPageItemsApiRequestFactory, ADMINPageItemsApiResponseProcessor} from "../apis/ADMINPageItemsApi";
export class ObservableADMINPageItemsApi {
    private requestFactory: ADMINPageItemsApiRequestFactory;
    private responseProcessor: ADMINPageItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINPageItemsApiRequestFactory,
        responseProcessor?: ADMINPageItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINPageItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINPageItemsApiResponseProcessor();
    }

    /**
     * Create multiple PageHTMLBlocks
     * @param createManyPageHTMLBlockDto
     */
    public createManyBasePageAdminControllerPageHTMLBlockWithHttpInfo(createManyPageHTMLBlockDto: CreateManyPageHTMLBlockDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<PageHTMLBlock>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBasePageAdminControllerPageHTMLBlock(createManyPageHTMLBlockDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBasePageAdminControllerPageHTMLBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple PageHTMLBlocks
     * @param createManyPageHTMLBlockDto
     */
    public createManyBasePageAdminControllerPageHTMLBlock(createManyPageHTMLBlockDto: CreateManyPageHTMLBlockDto, _options?: ConfigurationOptions): Observable<Array<PageHTMLBlock>> {
        return this.createManyBasePageAdminControllerPageHTMLBlockWithHttpInfo(createManyPageHTMLBlockDto, _options).pipe(map((apiResponse: HttpInfo<Array<PageHTMLBlock>>) => apiResponse.data));
    }

    /**
     * Create a single PageHTMLBlock
     * @param pageHTMLBlock
     */
    public createOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(pageHTMLBlock: PageHTMLBlock, _options?: ConfigurationOptions): Observable<HttpInfo<PageHTMLBlock>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBasePageAdminControllerPageHTMLBlock(pageHTMLBlock, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single PageHTMLBlock
     * @param pageHTMLBlock
     */
    public createOneBasePageAdminControllerPageHTMLBlock(pageHTMLBlock: PageHTMLBlock, _options?: ConfigurationOptions): Observable<PageHTMLBlock> {
        return this.createOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(pageHTMLBlock, _options).pipe(map((apiResponse: HttpInfo<PageHTMLBlock>) => apiResponse.data));
    }

    /**
     * Delete a single PageHTMLBlock
     * @param id
     */
    public deleteOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBasePageAdminControllerPageHTMLBlock(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single PageHTMLBlock
     * @param id
     */
    public deleteOneBasePageAdminControllerPageHTMLBlock(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple PageHTMLBlocks
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBasePageAdminControllerPageHTMLBlockWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBasePageAdminControllerPageHTMLBlock200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBasePageAdminControllerPageHTMLBlock(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBasePageAdminControllerPageHTMLBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple PageHTMLBlocks
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBasePageAdminControllerPageHTMLBlock(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBasePageAdminControllerPageHTMLBlock200Response> {
        return this.getManyBasePageAdminControllerPageHTMLBlockWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBasePageAdminControllerPageHTMLBlock200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single PageHTMLBlock
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<PageHTMLBlock>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBasePageAdminControllerPageHTMLBlock(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single PageHTMLBlock
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBasePageAdminControllerPageHTMLBlock(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<PageHTMLBlock> {
        return this.getOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<PageHTMLBlock>) => apiResponse.data));
    }

    /**
     * Replace a single PageHTMLBlock
     * @param id
     * @param pageHTMLBlock
     */
    public replaceOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(id: number, pageHTMLBlock: PageHTMLBlock, _options?: ConfigurationOptions): Observable<HttpInfo<PageHTMLBlock>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBasePageAdminControllerPageHTMLBlock(id, pageHTMLBlock, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single PageHTMLBlock
     * @param id
     * @param pageHTMLBlock
     */
    public replaceOneBasePageAdminControllerPageHTMLBlock(id: number, pageHTMLBlock: PageHTMLBlock, _options?: ConfigurationOptions): Observable<PageHTMLBlock> {
        return this.replaceOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(id, pageHTMLBlock, _options).pipe(map((apiResponse: HttpInfo<PageHTMLBlock>) => apiResponse.data));
    }

    /**
     * Update a single PageHTMLBlock
     * @param id
     * @param pageHTMLBlock
     */
    public updateOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(id: number, pageHTMLBlock: PageHTMLBlock, _options?: ConfigurationOptions): Observable<HttpInfo<PageHTMLBlock>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBasePageAdminControllerPageHTMLBlock(id, pageHTMLBlock, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single PageHTMLBlock
     * @param id
     * @param pageHTMLBlock
     */
    public updateOneBasePageAdminControllerPageHTMLBlock(id: number, pageHTMLBlock: PageHTMLBlock, _options?: ConfigurationOptions): Observable<PageHTMLBlock> {
        return this.updateOneBasePageAdminControllerPageHTMLBlockWithHttpInfo(id, pageHTMLBlock, _options).pipe(map((apiResponse: HttpInfo<PageHTMLBlock>) => apiResponse.data));
    }

}

import { ADMINPaymentItemsApiRequestFactory, ADMINPaymentItemsApiResponseProcessor} from "../apis/ADMINPaymentItemsApi";
export class ObservableADMINPaymentItemsApi {
    private requestFactory: ADMINPaymentItemsApiRequestFactory;
    private responseProcessor: ADMINPaymentItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINPaymentItemsApiRequestFactory,
        responseProcessor?: ADMINPaymentItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINPaymentItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINPaymentItemsApiResponseProcessor();
    }

    /**
     * Create a single PaymentTransaction
     * @param body
     */
    public createOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBasePaymentAdminControllerPaymentTransaction(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single PaymentTransaction
     * @param body
     */
    public createOneBasePaymentAdminControllerPaymentTransaction(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single PaymentTransaction
     * @param id
     */
    public deleteOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(id: string, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBasePaymentAdminControllerPaymentTransaction(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single PaymentTransaction
     * @param id
     */
    public deleteOneBasePaymentAdminControllerPaymentTransaction(id: string, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple PaymentTransactions
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBasePaymentAdminControllerPaymentTransactionWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBasePaymentAdminControllerPaymentTransaction200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBasePaymentAdminControllerPaymentTransaction(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBasePaymentAdminControllerPaymentTransactionWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple PaymentTransactions
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBasePaymentAdminControllerPaymentTransaction(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBasePaymentAdminControllerPaymentTransaction200Response> {
        return this.getManyBasePaymentAdminControllerPaymentTransactionWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBasePaymentAdminControllerPaymentTransaction200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single PaymentTransaction
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBasePaymentAdminControllerPaymentTransaction(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single PaymentTransaction
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBasePaymentAdminControllerPaymentTransaction(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single PaymentTransaction
     * @param id
     * @param body
     */
    public replaceOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(id: string, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBasePaymentAdminControllerPaymentTransaction(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single PaymentTransaction
     * @param id
     * @param body
     */
    public replaceOneBasePaymentAdminControllerPaymentTransaction(id: string, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single PaymentTransaction
     * @param id
     * @param body
     */
    public updateOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(id: string, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBasePaymentAdminControllerPaymentTransaction(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single PaymentTransaction
     * @param id
     * @param body
     */
    public updateOneBasePaymentAdminControllerPaymentTransaction(id: string, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBasePaymentAdminControllerPaymentTransactionWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINPersonalPageItemsApiRequestFactory, ADMINPersonalPageItemsApiResponseProcessor} from "../apis/ADMINPersonalPageItemsApi";
export class ObservableADMINPersonalPageItemsApi {
    private requestFactory: ADMINPersonalPageItemsApiRequestFactory;
    private responseProcessor: ADMINPersonalPageItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINPersonalPageItemsApiRequestFactory,
        responseProcessor?: ADMINPersonalPageItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINPersonalPageItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINPersonalPageItemsApiResponseProcessor();
    }

    /**
     * Create multiple PersonalPages
     * @param createManyPersonalPageDto
     */
    public createManyBasePersonalPageAdminControllerPersonalPageWithHttpInfo(createManyPersonalPageDto: CreateManyPersonalPageDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBasePersonalPageAdminControllerPersonalPage(createManyPersonalPageDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBasePersonalPageAdminControllerPersonalPageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple PersonalPages
     * @param createManyPersonalPageDto
     */
    public createManyBasePersonalPageAdminControllerPersonalPage(createManyPersonalPageDto: CreateManyPersonalPageDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBasePersonalPageAdminControllerPersonalPageWithHttpInfo(createManyPersonalPageDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single PersonalPage
     * @param body
     */
    public createOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBasePersonalPageAdminControllerPersonalPage(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single PersonalPage
     * @param body
     */
    public createOneBasePersonalPageAdminControllerPersonalPage(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single PersonalPage
     * @param id
     */
    public deleteOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBasePersonalPageAdminControllerPersonalPage(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single PersonalPage
     * @param id
     */
    public deleteOneBasePersonalPageAdminControllerPersonalPage(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple PersonalPages
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBasePersonalPageAdminControllerPersonalPageWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBasePersonalPageAdminControllerPersonalPage200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBasePersonalPageAdminControllerPersonalPage(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBasePersonalPageAdminControllerPersonalPageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple PersonalPages
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBasePersonalPageAdminControllerPersonalPage(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBasePersonalPageAdminControllerPersonalPage200Response> {
        return this.getManyBasePersonalPageAdminControllerPersonalPageWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBasePersonalPageAdminControllerPersonalPage200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single PersonalPage
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBasePersonalPageAdminControllerPersonalPage(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single PersonalPage
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBasePersonalPageAdminControllerPersonalPage(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single PersonalPage
     * @param id
     * @param body
     */
    public replaceOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBasePersonalPageAdminControllerPersonalPage(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single PersonalPage
     * @param id
     * @param body
     */
    public replaceOneBasePersonalPageAdminControllerPersonalPage(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single PersonalPage
     * @param id
     * @param body
     */
    public updateOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBasePersonalPageAdminControllerPersonalPage(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single PersonalPage
     * @param id
     * @param body
     */
    public updateOneBasePersonalPageAdminControllerPersonalPage(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBasePersonalPageAdminControllerPersonalPageWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINProductItemsApiRequestFactory, ADMINProductItemsApiResponseProcessor} from "../apis/ADMINProductItemsApi";
export class ObservableADMINProductItemsApi {
    private requestFactory: ADMINProductItemsApiRequestFactory;
    private responseProcessor: ADMINProductItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINProductItemsApiRequestFactory,
        responseProcessor?: ADMINProductItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINProductItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINProductItemsApiResponseProcessor();
    }

    /**
     * Creates new product.
     * @param createProductDTO
     */
    public createOne0WithHttpInfo(createProductDTO: CreateProductDTO, _options?: ConfigurationOptions): Observable<HttpInfo<ProductEntity>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOne0(createProductDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOne0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Creates new product.
     * @param createProductDTO
     */
    public createOne0(createProductDTO: CreateProductDTO, _options?: ConfigurationOptions): Observable<ProductEntity> {
        return this.createOne0WithHttpInfo(createProductDTO, _options).pipe(map((apiResponse: HttpInfo<ProductEntity>) => apiResponse.data));
    }

    /**
     * Deletes an existing product by provided id.
     * @param id
     */
    public deleteOne0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<ProductEntity>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOne0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOne0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Deletes an existing product by provided id.
     * @param id
     */
    public deleteOne0(id: number, _options?: ConfigurationOptions): Observable<ProductEntity> {
        return this.deleteOne0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<ProductEntity>) => apiResponse.data));
    }

    /**
     * Returns an array of available products to buy by current profile type.
     */
    public findAll0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<ProductEntity>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findAll0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findAll0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns an array of available products to buy by current profile type.
     */
    public findAll0(_options?: ConfigurationOptions): Observable<Array<ProductEntity>> {
        return this.findAll0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<ProductEntity>>) => apiResponse.data));
    }

    /**
     * Returns product by provided id.
     * @param id
     */
    public findOne0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<ProductEntity>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findOne0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findOne0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns product by provided id.
     * @param id
     */
    public findOne0(id: number, _options?: ConfigurationOptions): Observable<ProductEntity> {
        return this.findOne0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<ProductEntity>) => apiResponse.data));
    }

    /**
     * Updates an existing product by provided id.
     * @param id
     * @param updateProductDTO
     */
    public updateOne0WithHttpInfo(id: number, updateProductDTO: UpdateProductDTO, _options?: ConfigurationOptions): Observable<HttpInfo<ProductEntity>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOne0(id, updateProductDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOne0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Updates an existing product by provided id.
     * @param id
     * @param updateProductDTO
     */
    public updateOne0(id: number, updateProductDTO: UpdateProductDTO, _options?: ConfigurationOptions): Observable<ProductEntity> {
        return this.updateOne0WithHttpInfo(id, updateProductDTO, _options).pipe(map((apiResponse: HttpInfo<ProductEntity>) => apiResponse.data));
    }

}

import { ADMINProfilesManagingApiRequestFactory, ADMINProfilesManagingApiResponseProcessor} from "../apis/ADMINProfilesManagingApi";
export class ObservableADMINProfilesManagingApi {
    private requestFactory: ADMINProfilesManagingApiRequestFactory;
    private responseProcessor: ADMINProfilesManagingApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINProfilesManagingApiRequestFactory,
        responseProcessor?: ADMINProfilesManagingApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINProfilesManagingApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINProfilesManagingApiResponseProcessor();
    }

    /**
     * Deletes an existing profile.
     * @param profileId Unique identifier of profile to process.
     */
    public destroyOne0WithHttpInfo(profileId: number, _options?: ConfigurationOptions): Observable<HttpInfo<ProfileResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.destroyOne0(profileId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.destroyOne0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Deletes an existing profile.
     * @param profileId Unique identifier of profile to process.
     */
    public destroyOne0(profileId: number, _options?: ConfigurationOptions): Observable<ProfileResponseDTO> {
        return this.destroyOne0WithHttpInfo(profileId, _options).pipe(map((apiResponse: HttpInfo<ProfileResponseDTO>) => apiResponse.data));
    }

    /**
     * Returns the set of existing profiles.
     * @param [filter]
     * @param [or]
     * @param [sort]
     * @param [limit]
     * @param [offset]
     * @param [page]
     */
    public findMany0WithHttpInfo(filter?: Array<QueryFilterDTO>, or?: Array<QueryFilterDTO>, sort?: Array<QuerySortDTO>, limit?: number, offset?: number, page?: number, _options?: ConfigurationOptions): Observable<HttpInfo<ProfileAdminFindManyControllerFindMany0200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findMany0(filter, or, sort, limit, offset, page, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findMany0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns the set of existing profiles.
     * @param [filter]
     * @param [or]
     * @param [sort]
     * @param [limit]
     * @param [offset]
     * @param [page]
     */
    public findMany0(filter?: Array<QueryFilterDTO>, or?: Array<QueryFilterDTO>, sort?: Array<QuerySortDTO>, limit?: number, offset?: number, page?: number, _options?: ConfigurationOptions): Observable<ProfileAdminFindManyControllerFindMany0200Response> {
        return this.findMany0WithHttpInfo(filter, or, sort, limit, offset, page, _options).pipe(map((apiResponse: HttpInfo<ProfileAdminFindManyControllerFindMany0200Response>) => apiResponse.data));
    }

    /**
     * Returns the set of existing profiles.
     * @param [filter]
     * @param [or]
     * @param [sort]
     * @param [limit]
     * @param [offset]
     * @param [page]
     */
    public findMany0_1WithHttpInfo(filter?: Array<QueryFilterDTO>, or?: Array<QueryFilterDTO>, sort?: Array<QuerySortDTO>, limit?: number, offset?: number, page?: number, _options?: ConfigurationOptions): Observable<HttpInfo<ProfileAdminFindManyControllerFindMany0200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findMany0_1(filter, or, sort, limit, offset, page, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findMany0_1WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns the set of existing profiles.
     * @param [filter]
     * @param [or]
     * @param [sort]
     * @param [limit]
     * @param [offset]
     * @param [page]
     */
    public findMany0_1(filter?: Array<QueryFilterDTO>, or?: Array<QueryFilterDTO>, sort?: Array<QuerySortDTO>, limit?: number, offset?: number, page?: number, _options?: ConfigurationOptions): Observable<ProfileAdminFindManyControllerFindMany0200Response> {
        return this.findMany0_1WithHttpInfo(filter, or, sort, limit, offset, page, _options).pipe(map((apiResponse: HttpInfo<ProfileAdminFindManyControllerFindMany0200Response>) => apiResponse.data));
    }

    /**
     * Returns the set of existing profiles.
     * @param [filter]
     * @param [or]
     * @param [sort]
     * @param [limit]
     * @param [offset]
     * @param [page]
     */
    public findMany0_2WithHttpInfo(filter?: Array<QueryFilterDTO>, or?: Array<QueryFilterDTO>, sort?: Array<QuerySortDTO>, limit?: number, offset?: number, page?: number, _options?: ConfigurationOptions): Observable<HttpInfo<ProfileAdminFindManyControllerFindMany0200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findMany0_2(filter, or, sort, limit, offset, page, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findMany0_2WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns the set of existing profiles.
     * @param [filter]
     * @param [or]
     * @param [sort]
     * @param [limit]
     * @param [offset]
     * @param [page]
     */
    public findMany0_2(filter?: Array<QueryFilterDTO>, or?: Array<QueryFilterDTO>, sort?: Array<QuerySortDTO>, limit?: number, offset?: number, page?: number, _options?: ConfigurationOptions): Observable<ProfileAdminFindManyControllerFindMany0200Response> {
        return this.findMany0_2WithHttpInfo(filter, or, sort, limit, offset, page, _options).pipe(map((apiResponse: HttpInfo<ProfileAdminFindManyControllerFindMany0200Response>) => apiResponse.data));
    }

    /**
     * Returns the set of existing profiles.
     * @param [filter]
     * @param [or]
     * @param [sort]
     * @param [limit]
     * @param [offset]
     * @param [page]
     */
    public findMany0_3WithHttpInfo(filter?: Array<QueryFilterDTO>, or?: Array<QueryFilterDTO>, sort?: Array<QuerySortDTO>, limit?: number, offset?: number, page?: number, _options?: ConfigurationOptions): Observable<HttpInfo<ProfileAdminFindManyControllerFindMany0200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findMany0_3(filter, or, sort, limit, offset, page, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findMany0_3WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns the set of existing profiles.
     * @param [filter]
     * @param [or]
     * @param [sort]
     * @param [limit]
     * @param [offset]
     * @param [page]
     */
    public findMany0_3(filter?: Array<QueryFilterDTO>, or?: Array<QueryFilterDTO>, sort?: Array<QuerySortDTO>, limit?: number, offset?: number, page?: number, _options?: ConfigurationOptions): Observable<ProfileAdminFindManyControllerFindMany0200Response> {
        return this.findMany0_3WithHttpInfo(filter, or, sort, limit, offset, page, _options).pipe(map((apiResponse: HttpInfo<ProfileAdminFindManyControllerFindMany0200Response>) => apiResponse.data));
    }

    /**
     * Returns an existing profile.
     * @param profileId Unique identifier of profile to process.
     */
    public findOne0WithHttpInfo(profileId: number, _options?: ConfigurationOptions): Observable<HttpInfo<ProfileResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findOne0(profileId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findOne0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns an existing profile.
     * @param profileId Unique identifier of profile to process.
     */
    public findOne0(profileId: number, _options?: ConfigurationOptions): Observable<ProfileResponseDTO> {
        return this.findOne0WithHttpInfo(profileId, _options).pipe(map((apiResponse: HttpInfo<ProfileResponseDTO>) => apiResponse.data));
    }

    /**
     * Updates an existing profile.
     * @param profileId Unique identifier of profile to process.
     * @param profileUpdateDTO
     */
    public updateOne0WithHttpInfo(profileId: number, profileUpdateDTO: ProfileUpdateDTO, _options?: ConfigurationOptions): Observable<HttpInfo<ProfileResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOne0(profileId, profileUpdateDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOne0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Updates an existing profile.
     * @param profileId Unique identifier of profile to process.
     * @param profileUpdateDTO
     */
    public updateOne0(profileId: number, profileUpdateDTO: ProfileUpdateDTO, _options?: ConfigurationOptions): Observable<ProfileResponseDTO> {
        return this.updateOne0WithHttpInfo(profileId, profileUpdateDTO, _options).pipe(map((apiResponse: HttpInfo<ProfileResponseDTO>) => apiResponse.data));
    }

}

import { ADMINProposalItemsApiRequestFactory, ADMINProposalItemsApiResponseProcessor} from "../apis/ADMINProposalItemsApi";
export class ObservableADMINProposalItemsApi {
    private requestFactory: ADMINProposalItemsApiRequestFactory;
    private responseProcessor: ADMINProposalItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINProposalItemsApiRequestFactory,
        responseProcessor?: ADMINProposalItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINProposalItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINProposalItemsApiResponseProcessor();
    }

    /**
     * Create multiple Proposals
     * @param createManyProposalDto
     */
    public createManyBaseProposalAdminControllerProposalWithHttpInfo(createManyProposalDto: CreateManyProposalDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseProposalAdminControllerProposal(createManyProposalDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseProposalAdminControllerProposalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Proposals
     * @param createManyProposalDto
     */
    public createManyBaseProposalAdminControllerProposal(createManyProposalDto: CreateManyProposalDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseProposalAdminControllerProposalWithHttpInfo(createManyProposalDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Proposal
     * @param body
     */
    public createOneBaseProposalAdminControllerProposalWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseProposalAdminControllerProposal(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseProposalAdminControllerProposalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Proposal
     * @param body
     */
    public createOneBaseProposalAdminControllerProposal(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseProposalAdminControllerProposalWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Proposal
     * @param id
     */
    public deleteOneBaseProposalAdminControllerProposalWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseProposalAdminControllerProposal(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseProposalAdminControllerProposalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Proposal
     * @param id
     */
    public deleteOneBaseProposalAdminControllerProposal(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseProposalAdminControllerProposalWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Proposals
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseProposalAdminControllerProposalWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseProposalAdminControllerProposal200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseProposalAdminControllerProposal(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseProposalAdminControllerProposalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Proposals
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseProposalAdminControllerProposal(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseProposalAdminControllerProposal200Response> {
        return this.getManyBaseProposalAdminControllerProposalWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseProposalAdminControllerProposal200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Proposal
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseProposalAdminControllerProposalWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseProposalAdminControllerProposal(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseProposalAdminControllerProposalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Proposal
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseProposalAdminControllerProposal(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseProposalAdminControllerProposalWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Proposal
     * @param id
     * @param body
     */
    public replaceOneBaseProposalAdminControllerProposalWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseProposalAdminControllerProposal(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseProposalAdminControllerProposalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Proposal
     * @param id
     * @param body
     */
    public replaceOneBaseProposalAdminControllerProposal(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseProposalAdminControllerProposalWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Proposal
     * @param id
     * @param body
     */
    public updateOneBaseProposalAdminControllerProposalWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseProposalAdminControllerProposal(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseProposalAdminControllerProposalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Proposal
     * @param id
     * @param body
     */
    public updateOneBaseProposalAdminControllerProposal(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseProposalAdminControllerProposalWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINSkillItemsApiRequestFactory, ADMINSkillItemsApiResponseProcessor} from "../apis/ADMINSkillItemsApi";
export class ObservableADMINSkillItemsApi {
    private requestFactory: ADMINSkillItemsApiRequestFactory;
    private responseProcessor: ADMINSkillItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINSkillItemsApiRequestFactory,
        responseProcessor?: ADMINSkillItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINSkillItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINSkillItemsApiResponseProcessor();
    }

    /**
     * Create multiple Skills
     * @param createManySkillDto
     */
    public createManyBaseSkillAdminControllerSkillWithHttpInfo(createManySkillDto: CreateManySkillDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseSkillAdminControllerSkill(createManySkillDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseSkillAdminControllerSkillWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Skills
     * @param createManySkillDto
     */
    public createManyBaseSkillAdminControllerSkill(createManySkillDto: CreateManySkillDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseSkillAdminControllerSkillWithHttpInfo(createManySkillDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Skill
     * @param body
     */
    public createOneBaseSkillAdminControllerSkillWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseSkillAdminControllerSkill(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseSkillAdminControllerSkillWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Skill
     * @param body
     */
    public createOneBaseSkillAdminControllerSkill(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseSkillAdminControllerSkillWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Skill
     * @param id
     */
    public deleteOneBaseSkillAdminControllerSkillWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseSkillAdminControllerSkill(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseSkillAdminControllerSkillWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Skill
     * @param id
     */
    public deleteOneBaseSkillAdminControllerSkill(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseSkillAdminControllerSkillWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Skills
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseSkillAdminControllerSkillWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseSkillAdminControllerSkill200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseSkillAdminControllerSkill(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseSkillAdminControllerSkillWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Skills
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseSkillAdminControllerSkill(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseSkillAdminControllerSkill200Response> {
        return this.getManyBaseSkillAdminControllerSkillWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseSkillAdminControllerSkill200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Skill
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseSkillAdminControllerSkillWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseSkillAdminControllerSkill(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseSkillAdminControllerSkillWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Skill
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseSkillAdminControllerSkill(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseSkillAdminControllerSkillWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param requestBody
     */
    public import0WithHttpInfo(requestBody: Array<string>, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.import0(requestBody, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.import0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param requestBody
     */
    public import0(requestBody: Array<string>, _options?: ConfigurationOptions): Observable<void> {
        return this.import0WithHttpInfo(requestBody, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Replace a single Skill
     * @param id
     * @param body
     */
    public replaceOneBaseSkillAdminControllerSkillWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseSkillAdminControllerSkill(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseSkillAdminControllerSkillWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Skill
     * @param id
     * @param body
     */
    public replaceOneBaseSkillAdminControllerSkill(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseSkillAdminControllerSkillWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Skill
     * @param id
     * @param body
     */
    public updateOneBaseSkillAdminControllerSkillWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseSkillAdminControllerSkill(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseSkillAdminControllerSkillWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Skill
     * @param id
     * @param body
     */
    public updateOneBaseSkillAdminControllerSkill(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseSkillAdminControllerSkillWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINSourceItemsApiRequestFactory, ADMINSourceItemsApiResponseProcessor} from "../apis/ADMINSourceItemsApi";
export class ObservableADMINSourceItemsApi {
    private requestFactory: ADMINSourceItemsApiRequestFactory;
    private responseProcessor: ADMINSourceItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINSourceItemsApiRequestFactory,
        responseProcessor?: ADMINSourceItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINSourceItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINSourceItemsApiResponseProcessor();
    }

    /**
     * Create multiple Sources
     * @param createManySourceDto
     */
    public createManyBaseSourceAdminControllerSourceWithHttpInfo(createManySourceDto: CreateManySourceDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseSourceAdminControllerSource(createManySourceDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseSourceAdminControllerSourceWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Sources
     * @param createManySourceDto
     */
    public createManyBaseSourceAdminControllerSource(createManySourceDto: CreateManySourceDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseSourceAdminControllerSourceWithHttpInfo(createManySourceDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Source
     * @param body
     */
    public createOneBaseSourceAdminControllerSourceWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseSourceAdminControllerSource(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseSourceAdminControllerSourceWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Source
     * @param body
     */
    public createOneBaseSourceAdminControllerSource(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseSourceAdminControllerSourceWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Source
     * @param id
     */
    public deleteOneBaseSourceAdminControllerSourceWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseSourceAdminControllerSource(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseSourceAdminControllerSourceWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Source
     * @param id
     */
    public deleteOneBaseSourceAdminControllerSource(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseSourceAdminControllerSourceWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Sources
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseSourceAdminControllerSourceWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseSourceAdminControllerSource200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseSourceAdminControllerSource(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseSourceAdminControllerSourceWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Sources
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseSourceAdminControllerSource(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseSourceAdminControllerSource200Response> {
        return this.getManyBaseSourceAdminControllerSourceWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseSourceAdminControllerSource200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Source
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseSourceAdminControllerSourceWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseSourceAdminControllerSource(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseSourceAdminControllerSourceWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Source
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseSourceAdminControllerSource(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseSourceAdminControllerSourceWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Source
     * @param id
     * @param body
     */
    public replaceOneBaseSourceAdminControllerSourceWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseSourceAdminControllerSource(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseSourceAdminControllerSourceWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Source
     * @param id
     * @param body
     */
    public replaceOneBaseSourceAdminControllerSource(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseSourceAdminControllerSourceWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Source
     * @param id
     * @param body
     */
    public updateOneBaseSourceAdminControllerSourceWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseSourceAdminControllerSource(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseSourceAdminControllerSourceWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Source
     * @param id
     * @param body
     */
    public updateOneBaseSourceAdminControllerSource(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseSourceAdminControllerSourceWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINStopWordItemsApiRequestFactory, ADMINStopWordItemsApiResponseProcessor} from "../apis/ADMINStopWordItemsApi";
export class ObservableADMINStopWordItemsApi {
    private requestFactory: ADMINStopWordItemsApiRequestFactory;
    private responseProcessor: ADMINStopWordItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINStopWordItemsApiRequestFactory,
        responseProcessor?: ADMINStopWordItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINStopWordItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINStopWordItemsApiResponseProcessor();
    }

    /**
     * Create multiple StopWords
     * @param createManyStopWordDto
     */
    public createManyBaseStopWordAdminControllerStopWordWithHttpInfo(createManyStopWordDto: CreateManyStopWordDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseStopWordAdminControllerStopWord(createManyStopWordDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseStopWordAdminControllerStopWordWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple StopWords
     * @param createManyStopWordDto
     */
    public createManyBaseStopWordAdminControllerStopWord(createManyStopWordDto: CreateManyStopWordDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseStopWordAdminControllerStopWordWithHttpInfo(createManyStopWordDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single StopWord
     * @param body
     */
    public createOneBaseStopWordAdminControllerStopWordWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseStopWordAdminControllerStopWord(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseStopWordAdminControllerStopWordWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single StopWord
     * @param body
     */
    public createOneBaseStopWordAdminControllerStopWord(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseStopWordAdminControllerStopWordWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single StopWord
     * @param id
     */
    public deleteOneBaseStopWordAdminControllerStopWordWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseStopWordAdminControllerStopWord(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseStopWordAdminControllerStopWordWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single StopWord
     * @param id
     */
    public deleteOneBaseStopWordAdminControllerStopWord(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseStopWordAdminControllerStopWordWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple StopWords
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseStopWordAdminControllerStopWordWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseStopWordAdminControllerStopWord200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseStopWordAdminControllerStopWord(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseStopWordAdminControllerStopWordWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple StopWords
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseStopWordAdminControllerStopWord(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseStopWordAdminControllerStopWord200Response> {
        return this.getManyBaseStopWordAdminControllerStopWordWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseStopWordAdminControllerStopWord200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single StopWord
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseStopWordAdminControllerStopWordWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseStopWordAdminControllerStopWord(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseStopWordAdminControllerStopWordWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single StopWord
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseStopWordAdminControllerStopWord(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseStopWordAdminControllerStopWordWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single StopWord
     * @param id
     * @param body
     */
    public replaceOneBaseStopWordAdminControllerStopWordWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseStopWordAdminControllerStopWord(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseStopWordAdminControllerStopWordWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single StopWord
     * @param id
     * @param body
     */
    public replaceOneBaseStopWordAdminControllerStopWord(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseStopWordAdminControllerStopWordWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single StopWord
     * @param id
     * @param body
     */
    public updateOneBaseStopWordAdminControllerStopWordWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseStopWordAdminControllerStopWord(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseStopWordAdminControllerStopWordWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single StopWord
     * @param id
     * @param body
     */
    public updateOneBaseStopWordAdminControllerStopWord(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseStopWordAdminControllerStopWordWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINStoryItemsApiRequestFactory, ADMINStoryItemsApiResponseProcessor} from "../apis/ADMINStoryItemsApi";
export class ObservableADMINStoryItemsApi {
    private requestFactory: ADMINStoryItemsApiRequestFactory;
    private responseProcessor: ADMINStoryItemsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINStoryItemsApiRequestFactory,
        responseProcessor?: ADMINStoryItemsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINStoryItemsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINStoryItemsApiResponseProcessor();
    }

    /**
     * Create a single Story
     * @param body
     */
    public createOneBaseStoryAdminControllerStoryWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseStoryAdminControllerStory(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseStoryAdminControllerStoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Story
     * @param body
     */
    public createOneBaseStoryAdminControllerStory(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseStoryAdminControllerStoryWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Story
     * @param id
     */
    public deleteOneBaseStoryAdminControllerStoryWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseStoryAdminControllerStory(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseStoryAdminControllerStoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Story
     * @param id
     */
    public deleteOneBaseStoryAdminControllerStory(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseStoryAdminControllerStoryWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Stories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseStoryAdminControllerStoryWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseStoryAdminControllerStory200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseStoryAdminControllerStory(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseStoryAdminControllerStoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Stories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseStoryAdminControllerStory(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseStoryAdminControllerStory200Response> {
        return this.getManyBaseStoryAdminControllerStoryWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseStoryAdminControllerStory200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Story
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseStoryAdminControllerStoryWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseStoryAdminControllerStory(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseStoryAdminControllerStoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Story
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseStoryAdminControllerStory(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseStoryAdminControllerStoryWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Story
     * @param id
     * @param body
     */
    public replaceOneBaseStoryAdminControllerStoryWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseStoryAdminControllerStory(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseStoryAdminControllerStoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Story
     * @param id
     * @param body
     */
    public replaceOneBaseStoryAdminControllerStory(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseStoryAdminControllerStoryWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Story
     * @param id
     * @param body
     */
    public updateOneBaseStoryAdminControllerStoryWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseStoryAdminControllerStory(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseStoryAdminControllerStoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Story
     * @param id
     * @param body
     */
    public updateOneBaseStoryAdminControllerStory(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseStoryAdminControllerStoryWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINVacancyApprovedApiRequestFactory, ADMINVacancyApprovedApiResponseProcessor} from "../apis/ADMINVacancyApprovedApi";
export class ObservableADMINVacancyApprovedApi {
    private requestFactory: ADMINVacancyApprovedApiRequestFactory;
    private responseProcessor: ADMINVacancyApprovedApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINVacancyApprovedApiRequestFactory,
        responseProcessor?: ADMINVacancyApprovedApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINVacancyApprovedApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINVacancyApprovedApiResponseProcessor();
    }

    /**
     * Create multiple Vacancies
     * @param createManyVacancyDto
     */
    public createManyBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(createManyVacancyDto: CreateManyVacancyDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseVacancyApprovedAdminControllerVacancy(createManyVacancyDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Vacancies
     * @param createManyVacancyDto
     */
    public createManyBaseVacancyApprovedAdminControllerVacancy(createManyVacancyDto: CreateManyVacancyDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(createManyVacancyDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Vacancy
     * @param body
     */
    public createOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseVacancyApprovedAdminControllerVacancy(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Vacancy
     * @param body
     */
    public createOneBaseVacancyApprovedAdminControllerVacancy(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Vacancy
     * @param id
     */
    public deleteOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseVacancyApprovedAdminControllerVacancy(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Vacancy
     * @param id
     */
    public deleteOneBaseVacancyApprovedAdminControllerVacancy(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Vacancies
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseVacancyApprovedAdminControllerVacancy(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Vacancies
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseVacancyApprovedAdminControllerVacancy(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single Vacancy
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseVacancyApprovedAdminControllerVacancy(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Vacancy
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseVacancyApprovedAdminControllerVacancy(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Vacancy
     * @param id
     * @param body
     */
    public replaceOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseVacancyApprovedAdminControllerVacancy(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Vacancy
     * @param id
     * @param body
     */
    public replaceOneBaseVacancyApprovedAdminControllerVacancy(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Vacancy
     * @param id
     * @param body
     */
    public updateOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseVacancyApprovedAdminControllerVacancy(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Vacancy
     * @param id
     * @param body
     */
    public updateOneBaseVacancyApprovedAdminControllerVacancy(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseVacancyApprovedAdminControllerVacancyWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ADMINVacancyModerationApiRequestFactory, ADMINVacancyModerationApiResponseProcessor} from "../apis/ADMINVacancyModerationApi";
export class ObservableADMINVacancyModerationApi {
    private requestFactory: ADMINVacancyModerationApiRequestFactory;
    private responseProcessor: ADMINVacancyModerationApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ADMINVacancyModerationApiRequestFactory,
        responseProcessor?: ADMINVacancyModerationApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ADMINVacancyModerationApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ADMINVacancyModerationApiResponseProcessor();
    }

    /**
     * Create multiple Vacancies
     * @param createManyVacancyDto
     */
    public createManyBaseVacancyModerationAdminControllerVacancyWithHttpInfo(createManyVacancyDto: CreateManyVacancyDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseVacancyModerationAdminControllerVacancy(createManyVacancyDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseVacancyModerationAdminControllerVacancyWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple Vacancies
     * @param createManyVacancyDto
     */
    public createManyBaseVacancyModerationAdminControllerVacancy(createManyVacancyDto: CreateManyVacancyDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseVacancyModerationAdminControllerVacancyWithHttpInfo(createManyVacancyDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single Vacancy
     * @param body
     */
    public createOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseVacancyModerationAdminControllerVacancy(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Vacancy
     * @param body
     */
    public createOneBaseVacancyModerationAdminControllerVacancy(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Vacancy
     * @param id
     */
    public deleteOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseVacancyModerationAdminControllerVacancy(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Vacancy
     * @param id
     */
    public deleteOneBaseVacancyModerationAdminControllerVacancy(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Vacancies
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseVacancyModerationAdminControllerVacancyWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseVacancyModerationAdminControllerVacancy(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseVacancyModerationAdminControllerVacancyWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Vacancies
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseVacancyModerationAdminControllerVacancy(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseVacancyModerationAdminControllerVacancyWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single Vacancy
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseVacancyModerationAdminControllerVacancy(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Vacancy
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseVacancyModerationAdminControllerVacancy(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Vacancy
     * @param id
     * @param body
     */
    public replaceOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseVacancyModerationAdminControllerVacancy(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Vacancy
     * @param id
     * @param body
     */
    public replaceOneBaseVacancyModerationAdminControllerVacancy(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Vacancy
     * @param id
     * @param body
     */
    public updateOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseVacancyModerationAdminControllerVacancy(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Vacancy
     * @param id
     * @param body
     */
    public updateOneBaseVacancyModerationAdminControllerVacancy(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseVacancyModerationAdminControllerVacancyWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { AdminLoginApiRequestFactory, AdminLoginApiResponseProcessor} from "../apis/AdminLoginApi";
export class ObservableAdminLoginApi {
    private requestFactory: AdminLoginApiRequestFactory;
    private responseProcessor: AdminLoginApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: AdminLoginApiRequestFactory,
        responseProcessor?: AdminLoginApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new AdminLoginApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new AdminLoginApiResponseProcessor();
    }

    /**
     * @param adminLoginRequestDTO
     */
    public login0WithHttpInfo(adminLoginRequestDTO: AdminLoginRequestDTO, _options?: ConfigurationOptions): Observable<HttpInfo<AdminLoginResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.login0(adminLoginRequestDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.login0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param adminLoginRequestDTO
     */
    public login0(adminLoginRequestDTO: AdminLoginRequestDTO, _options?: ConfigurationOptions): Observable<AdminLoginResponseDTO> {
        return this.login0WithHttpInfo(adminLoginRequestDTO, _options).pipe(map((apiResponse: HttpInfo<AdminLoginResponseDTO>) => apiResponse.data));
    }

}

import { AdminPromoCodesApiRequestFactory, AdminPromoCodesApiResponseProcessor} from "../apis/AdminPromoCodesApi";
export class ObservableAdminPromoCodesApi {
    private requestFactory: AdminPromoCodesApiRequestFactory;
    private responseProcessor: AdminPromoCodesApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: AdminPromoCodesApiRequestFactory,
        responseProcessor?: AdminPromoCodesApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new AdminPromoCodesApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new AdminPromoCodesApiResponseProcessor();
    }

    /**
     * Assign a promo code to profiles
     * @param assignPromoCodeQueryDto
     */
    public assignToProfiles0WithHttpInfo(assignPromoCodeQueryDto: AssignPromoCodeQueryDto, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.assignToProfiles0(assignPromoCodeQueryDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.assignToProfiles0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Assign a promo code to profiles
     * @param assignPromoCodeQueryDto
     */
    public assignToProfiles0(assignPromoCodeQueryDto: AssignPromoCodeQueryDto, _options?: ConfigurationOptions): Observable<void> {
        return this.assignToProfiles0WithHttpInfo(assignPromoCodeQueryDto, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Create a new promo code
     * @param createPromoCodeQueryDto
     */
    public create0WithHttpInfo(createPromoCodeQueryDto: CreatePromoCodeQueryDto, _options?: ConfigurationOptions): Observable<HttpInfo<PromoCodeResponseDto>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.create0(createPromoCodeQueryDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.create0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a new promo code
     * @param createPromoCodeQueryDto
     */
    public create0(createPromoCodeQueryDto: CreatePromoCodeQueryDto, _options?: ConfigurationOptions): Observable<PromoCodeResponseDto> {
        return this.create0WithHttpInfo(createPromoCodeQueryDto, _options).pipe(map((apiResponse: HttpInfo<PromoCodeResponseDto>) => apiResponse.data));
    }

    /**
     * Delete a promo code by code
     * @param code
     */
    public delete0WithHttpInfo(code: string, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.delete0(code, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.delete0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a promo code by code
     * @param code
     */
    public delete0(code: string, _options?: ConfigurationOptions): Observable<void> {
        return this.delete0WithHttpInfo(code, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Get all promo codes
     */
    public findAll0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<PromoCodeResponseDto>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findAll0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findAll0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Get all promo codes
     */
    public findAll0(_options?: ConfigurationOptions): Observable<Array<PromoCodeResponseDto>> {
        return this.findAll0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<PromoCodeResponseDto>>) => apiResponse.data));
    }

    /**
     * Get a promo code by code
     * @param code
     */
    public getByCode0WithHttpInfo(code: string, _options?: ConfigurationOptions): Observable<HttpInfo<PromoCodeResponseDto>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getByCode0(code, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getByCode0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Get a promo code by code
     * @param code
     */
    public getByCode0(code: string, _options?: ConfigurationOptions): Observable<PromoCodeResponseDto> {
        return this.getByCode0WithHttpInfo(code, _options).pipe(map((apiResponse: HttpInfo<PromoCodeResponseDto>) => apiResponse.data));
    }

    /**
     * Remove a promo code from profiles
     * @param code
     */
    public removeFromProfiles0WithHttpInfo(code: string, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.removeFromProfiles0(code, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.removeFromProfiles0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Remove a promo code from profiles
     * @param code
     */
    public removeFromProfiles0(code: string, _options?: ConfigurationOptions): Observable<void> {
        return this.removeFromProfiles0WithHttpInfo(code, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Update an existing promo code by code
     * @param code
     * @param updatePromoCodeQueryDto
     */
    public update0WithHttpInfo(code: string, updatePromoCodeQueryDto: UpdatePromoCodeQueryDto, _options?: ConfigurationOptions): Observable<HttpInfo<PromoCodeResponseDto>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.update0(code, updatePromoCodeQueryDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.update0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Update an existing promo code by code
     * @param code
     * @param updatePromoCodeQueryDto
     */
    public update0(code: string, updatePromoCodeQueryDto: UpdatePromoCodeQueryDto, _options?: ConfigurationOptions): Observable<PromoCodeResponseDto> {
        return this.update0WithHttpInfo(code, updatePromoCodeQueryDto, _options).pipe(map((apiResponse: HttpInfo<PromoCodeResponseDto>) => apiResponse.data));
    }

}

import { ApplicationApiRequestFactory, ApplicationApiResponseProcessor} from "../apis/ApplicationApi";
export class ObservableApplicationApi {
    private requestFactory: ApplicationApiRequestFactory;
    private responseProcessor: ApplicationApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ApplicationApiRequestFactory,
        responseProcessor?: ApplicationApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ApplicationApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ApplicationApiResponseProcessor();
    }

    /**
     * Create a single Application
     * @param body
     */
    public createOneBaseApplicationControllerApplicationWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseApplicationControllerApplication(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseApplicationControllerApplicationWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Application
     * @param body
     */
    public createOneBaseApplicationControllerApplication(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseApplicationControllerApplicationWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Application
     * @param id
     */
    public deleteOneBaseApplicationControllerApplicationWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseApplicationControllerApplication(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseApplicationControllerApplicationWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Application
     * @param id
     */
    public deleteOneBaseApplicationControllerApplication(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.deleteOneBaseApplicationControllerApplicationWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Applications
     * @param lang
     * @param status
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseApplicationControllerApplicationWithHttpInfo(lang: string, status: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseApplicationControllerApplication(lang, status, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseApplicationControllerApplicationWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Applications
     * @param lang
     * @param status
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseApplicationControllerApplication(lang: string, status: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.getManyBaseApplicationControllerApplicationWithHttpInfo(lang, status, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Retrieve a single Application
     * @param lang
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseApplicationControllerApplicationWithHttpInfo(lang: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseApplicationControllerApplication(lang, id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseApplicationControllerApplicationWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Application
     * @param lang
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseApplicationControllerApplication(lang: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseApplicationControllerApplicationWithHttpInfo(lang, id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     */
    public getStats0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getStats0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getStats0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public getStats0(_options?: ConfigurationOptions): Observable<Array<any>> {
        return this.getStats0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Update a single Application
     * @param id
     * @param body
     */
    public updateOneBaseApplicationControllerApplicationWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseApplicationControllerApplication(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseApplicationControllerApplicationWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Application
     * @param id
     * @param body
     */
    public updateOneBaseApplicationControllerApplication(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseApplicationControllerApplicationWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ArticleApiRequestFactory, ArticleApiResponseProcessor} from "../apis/ArticleApi";
export class ObservableArticleApi {
    private requestFactory: ArticleApiRequestFactory;
    private responseProcessor: ArticleApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ArticleApiRequestFactory,
        responseProcessor?: ArticleApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ArticleApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ArticleApiResponseProcessor();
    }

    /**
     * @param id
     */
    public addToSaved0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.addToSaved0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.addToSaved0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public addToSaved0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.addToSaved0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param url
     */
    public findByFriendlyName0WithHttpInfo(url: string, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findByFriendlyName0(url, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findByFriendlyName0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param url
     */
    public findByFriendlyName0(url: string, _options?: ConfigurationOptions): Observable<any> {
        return this.findByFriendlyName0WithHttpInfo(url, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public findById0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findById0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findById0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public findById0(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.findById0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public like0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.like0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.like0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public like0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.like0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param limit
     * @param page
     * @param categories
     * @param communities
     * @param search
     * @param savedByCurrentProfile
     */
    public listByProfile0WithHttpInfo(limit: number, page: number, categories: Array<string>, communities: Array<string>, search: string, savedByCurrentProfile: string, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.listByProfile0(limit, page, categories, communities, search, savedByCurrentProfile, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.listByProfile0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param limit
     * @param page
     * @param categories
     * @param communities
     * @param search
     * @param savedByCurrentProfile
     */
    public listByProfile0(limit: number, page: number, categories: Array<string>, communities: Array<string>, search: string, savedByCurrentProfile: string, _options?: ConfigurationOptions): Observable<void> {
        return this.listByProfile0WithHttpInfo(limit, page, categories, communities, search, savedByCurrentProfile, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public removeFromSaved0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.removeFromSaved0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.removeFromSaved0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public removeFromSaved0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.removeFromSaved0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public unLike0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.unLike0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.unLike0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public unLike0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.unLike0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

}

import { ArticleCategoryApiRequestFactory, ArticleCategoryApiResponseProcessor} from "../apis/ArticleCategoryApi";
export class ObservableArticleCategoryApi {
    private requestFactory: ArticleCategoryApiRequestFactory;
    private responseProcessor: ArticleCategoryApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ArticleCategoryApiRequestFactory,
        responseProcessor?: ArticleCategoryApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ArticleCategoryApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ArticleCategoryApiResponseProcessor();
    }

    /**
     * @param id
     */
    public addToSaved0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.addToSaved0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.addToSaved0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public addToSaved0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.addToSaved0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public findById0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<ArticleCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findById0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findById0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public findById0(id: number, _options?: ConfigurationOptions): Observable<ArticleCategory> {
        return this.findById0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<ArticleCategory>) => apiResponse.data));
    }

    /**
     */
    public list0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.list0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.list0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public list0(_options?: ConfigurationOptions): Observable<void> {
        return this.list0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public removeFromSaved0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.removeFromSaved0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.removeFromSaved0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public removeFromSaved0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.removeFromSaved0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

}

import { ArticleCommunityApiRequestFactory, ArticleCommunityApiResponseProcessor} from "../apis/ArticleCommunityApi";
export class ObservableArticleCommunityApi {
    private requestFactory: ArticleCommunityApiRequestFactory;
    private responseProcessor: ArticleCommunityApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ArticleCommunityApiRequestFactory,
        responseProcessor?: ArticleCommunityApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ArticleCommunityApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ArticleCommunityApiResponseProcessor();
    }

    /**
     * Create a single Article
     * @param body
     */
    public createOneBaseArticleCommunityControllerArticleWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseArticleCommunityControllerArticle(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseArticleCommunityControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Article
     * @param body
     */
    public createOneBaseArticleCommunityControllerArticle(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseArticleCommunityControllerArticleWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Article
     * @param id
     */
    public deleteOneBaseArticleCommunityControllerArticleWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseArticleCommunityControllerArticle(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseArticleCommunityControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Article
     * @param id
     */
    public deleteOneBaseArticleCommunityControllerArticle(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.deleteOneBaseArticleCommunityControllerArticleWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Articles
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleCommunityControllerArticleWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseArticleCommunityControllerArticle(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseArticleCommunityControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Articles
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseArticleCommunityControllerArticle(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseArticleKnowledgeAdminControllerArticle200Response> {
        return this.getManyBaseArticleCommunityControllerArticleWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseArticleKnowledgeAdminControllerArticle200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Article
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleCommunityControllerArticleWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseArticleCommunityControllerArticle(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseArticleCommunityControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Article
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseArticleCommunityControllerArticle(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseArticleCommunityControllerArticleWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single Article
     * @param id
     * @param body
     */
    public replaceOneBaseArticleCommunityControllerArticleWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseArticleCommunityControllerArticle(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseArticleCommunityControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single Article
     * @param id
     * @param body
     */
    public replaceOneBaseArticleCommunityControllerArticle(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseArticleCommunityControllerArticleWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Article
     * @param id
     * @param body
     */
    public updateOneBaseArticleCommunityControllerArticleWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseArticleCommunityControllerArticle(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseArticleCommunityControllerArticleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Article
     * @param id
     * @param body
     */
    public updateOneBaseArticleCommunityControllerArticle(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseArticleCommunityControllerArticleWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { AssetApiRequestFactory, AssetApiResponseProcessor} from "../apis/AssetApi";
export class ObservableAssetApi {
    private requestFactory: AssetApiRequestFactory;
    private responseProcessor: AssetApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: AssetApiRequestFactory,
        responseProcessor?: AssetApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new AssetApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new AssetApiResponseProcessor();
    }

    /**
     * Delete a single Asset
     * @param id
     */
    public deleteOneBaseAssetControllerAssetWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseAssetControllerAsset(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseAssetControllerAssetWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Asset
     * @param id
     */
    public deleteOneBaseAssetControllerAsset(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseAssetControllerAssetWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param key
     */
    public fileRedirect0WithHttpInfo(key: string, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.fileRedirect0(key, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.fileRedirect0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param key
     */
    public fileRedirect0(key: string, _options?: ConfigurationOptions): Observable<void> {
        return this.fileRedirect0WithHttpInfo(key, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Assets
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseAssetControllerAssetWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseAssetAdminControllerAsset200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseAssetControllerAsset(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseAssetControllerAssetWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Assets
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseAssetControllerAsset(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseAssetAdminControllerAsset200Response> {
        return this.getManyBaseAssetControllerAssetWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseAssetAdminControllerAsset200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single Asset
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseAssetControllerAssetWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<Asset>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseAssetControllerAsset(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseAssetControllerAssetWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Asset
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseAssetControllerAsset(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<Asset> {
        return this.getOneBaseAssetControllerAssetWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<Asset>) => apiResponse.data));
    }

    /**
     * @param [file] File to upload
     */
    public upload0WithHttpInfo(file?: HttpFile, _options?: ConfigurationOptions): Observable<HttpInfo<Asset>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.upload0(file, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.upload0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param [file] File to upload
     */
    public upload0(file?: HttpFile, _options?: ConfigurationOptions): Observable<Asset> {
        return this.upload0WithHttpInfo(file, _options).pipe(map((apiResponse: HttpInfo<Asset>) => apiResponse.data));
    }

}

import { AuthProfileSocialProviderApiRequestFactory, AuthProfileSocialProviderApiResponseProcessor} from "../apis/AuthProfileSocialProviderApi";
export class ObservableAuthProfileSocialProviderApi {
    private requestFactory: AuthProfileSocialProviderApiRequestFactory;
    private responseProcessor: AuthProfileSocialProviderApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: AuthProfileSocialProviderApiRequestFactory,
        responseProcessor?: AuthProfileSocialProviderApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new AuthProfileSocialProviderApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new AuthProfileSocialProviderApiResponseProcessor();
    }

    /**
     */
    public get0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.get0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.get0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public get0(_options?: ConfigurationOptions): Observable<void> {
        return this.get0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

}

import { AuthSessionApiRequestFactory, AuthSessionApiResponseProcessor} from "../apis/AuthSessionApi";
export class ObservableAuthSessionApi {
    private requestFactory: AuthSessionApiRequestFactory;
    private responseProcessor: AuthSessionApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: AuthSessionApiRequestFactory,
        responseProcessor?: AuthSessionApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new AuthSessionApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new AuthSessionApiResponseProcessor();
    }

    /**
     * Logs out, completely deletes the session and the tokens bound to it.
     * @param sessionId Unique identifier of session to process.
     */
    public destroy0WithHttpInfo(sessionId: number, _options?: ConfigurationOptions): Observable<HttpInfo<AuthProfileSessionDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.destroy0(sessionId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.destroy0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Logs out, completely deletes the session and the tokens bound to it.
     * @param sessionId Unique identifier of session to process.
     */
    public destroy0(sessionId: number, _options?: ConfigurationOptions): Observable<AuthProfileSessionDTO> {
        return this.destroy0WithHttpInfo(sessionId, _options).pipe(map((apiResponse: HttpInfo<AuthProfileSessionDTO>) => apiResponse.data));
    }

    /**
     * Returns a list of sessions that are active at the user.
     */
    public get0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<AuthProfileSessionCurrentDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.get0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.get0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns a list of sessions that are active at the user.
     */
    public get0(_options?: ConfigurationOptions): Observable<AuthProfileSessionCurrentDTO> {
        return this.get0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<AuthProfileSessionCurrentDTO>) => apiResponse.data));
    }

    /**
     * Returns a list of sessions that are active at the user.
     */
    public get0_1WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<AuthProfileSessionDTO>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.get0_1(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.get0_1WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns a list of sessions that are active at the user.
     */
    public get0_1(_options?: ConfigurationOptions): Observable<Array<AuthProfileSessionDTO>> {
        return this.get0_1WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<AuthProfileSessionDTO>>) => apiResponse.data));
    }

    /**
     * Registers new Firebase Push Notification Token.
     * @param authProfileSessionPushDTO
     */
    public push0WithHttpInfo(authProfileSessionPushDTO: AuthProfileSessionPushDTO, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.push0(authProfileSessionPushDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.push0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Registers new Firebase Push Notification Token.
     * @param authProfileSessionPushDTO
     */
    public push0(authProfileSessionPushDTO: AuthProfileSessionPushDTO, _options?: ConfigurationOptions): Observable<void> {
        return this.push0WithHttpInfo(authProfileSessionPushDTO, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Renews a couple of access and refresh keys, old ones become inactive.
     */
    public refresh0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<AuthResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.refresh0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.refresh0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Renews a couple of access and refresh keys, old ones become inactive.
     */
    public refresh0(_options?: ConfigurationOptions): Observable<AuthResponseDTO> {
        return this.refresh0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<AuthResponseDTO>) => apiResponse.data));
    }

}

import { AuthSocialApiRequestFactory, AuthSocialApiResponseProcessor} from "../apis/AuthSocialApi";
export class ObservableAuthSocialApi {
    private requestFactory: AuthSocialApiRequestFactory;
    private responseProcessor: AuthSocialApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: AuthSocialApiRequestFactory,
        responseProcessor?: AuthSocialApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new AuthSocialApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new AuthSocialApiResponseProcessor();
    }

    /**
     * Facebook callback.
     */
    public facebook0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<AuthResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.facebook0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.facebook0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Facebook callback.
     */
    public facebook0(_options?: ConfigurationOptions): Observable<AuthResponseDTO> {
        return this.facebook0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<AuthResponseDTO>) => apiResponse.data));
    }

    /**
     * Facebook link.
     */
    public facebook0_1WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<AuthResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.facebook0_1(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.facebook0_1WithHttpInfo(rsp)));
            }));
    }

    /**
     * Facebook link.
     */
    public facebook0_1(_options?: ConfigurationOptions): Observable<AuthResponseDTO> {
        return this.facebook0_1WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<AuthResponseDTO>) => apiResponse.data));
    }

    /**
     * Facebook OAUTH2 redirect.
     */
    public facebook0_2WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.facebook0_2(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.facebook0_2WithHttpInfo(rsp)));
            }));
    }

    /**
     * Facebook OAUTH2 redirect.
     */
    public facebook0_2(_options?: ConfigurationOptions): Observable<void> {
        return this.facebook0_2WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Google callback.
     */
    public google0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<AuthResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.google0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.google0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Google callback.
     */
    public google0(_options?: ConfigurationOptions): Observable<AuthResponseDTO> {
        return this.google0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<AuthResponseDTO>) => apiResponse.data));
    }

    /**
     * Google link.
     */
    public google0_3WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<AuthResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.google0_3(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.google0_3WithHttpInfo(rsp)));
            }));
    }

    /**
     * Google link.
     */
    public google0_3(_options?: ConfigurationOptions): Observable<AuthResponseDTO> {
        return this.google0_3WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<AuthResponseDTO>) => apiResponse.data));
    }

    /**
     * Google OAUTH2 redirect.
     */
    public google0_4WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.google0_4(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.google0_4WithHttpInfo(rsp)));
            }));
    }

    /**
     * Google OAUTH2 redirect.
     */
    public google0_4(_options?: ConfigurationOptions): Observable<void> {
        return this.google0_4WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Twitter (X) callback.
     */
    public twitter0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<AuthResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.twitter0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.twitter0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Twitter (X) callback.
     */
    public twitter0(_options?: ConfigurationOptions): Observable<AuthResponseDTO> {
        return this.twitter0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<AuthResponseDTO>) => apiResponse.data));
    }

    /**
     * Twitter link.
     */
    public twitter0_5WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<AuthResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.twitter0_5(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.twitter0_5WithHttpInfo(rsp)));
            }));
    }

    /**
     * Twitter link.
     */
    public twitter0_5(_options?: ConfigurationOptions): Observable<AuthResponseDTO> {
        return this.twitter0_5WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<AuthResponseDTO>) => apiResponse.data));
    }

    /**
     * Twitter OAUTH2 redirect.
     */
    public twitter0_6WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.twitter0_6(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.twitter0_6WithHttpInfo(rsp)));
            }));
    }

    /**
     * Twitter OAUTH2 redirect.
     */
    public twitter0_6(_options?: ConfigurationOptions): Observable<void> {
        return this.twitter0_6WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * VK callback.
     */
    public vk0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<AuthResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.vk0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.vk0WithHttpInfo(rsp)));
            }));
    }

    /**
     * VK callback.
     */
    public vk0(_options?: ConfigurationOptions): Observable<AuthResponseDTO> {
        return this.vk0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<AuthResponseDTO>) => apiResponse.data));
    }

    /**
     * VK link.
     */
    public vk0_7WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<AuthResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.vk0_7(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.vk0_7WithHttpInfo(rsp)));
            }));
    }

    /**
     * VK link.
     */
    public vk0_7(_options?: ConfigurationOptions): Observable<AuthResponseDTO> {
        return this.vk0_7WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<AuthResponseDTO>) => apiResponse.data));
    }

    /**
     * VK OAUTH2 redirect.
     */
    public vk0_8WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.vk0_8(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.vk0_8WithHttpInfo(rsp)));
            }));
    }

    /**
     * VK OAUTH2 redirect.
     */
    public vk0_8(_options?: ConfigurationOptions): Observable<void> {
        return this.vk0_8WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Yandex callback.
     */
    public yandex0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<AuthResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.yandex0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.yandex0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Yandex callback.
     */
    public yandex0(_options?: ConfigurationOptions): Observable<AuthResponseDTO> {
        return this.yandex0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<AuthResponseDTO>) => apiResponse.data));
    }

    /**
     * Yandex link.
     */
    public yandex0_9WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<AuthResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.yandex0_9(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.yandex0_9WithHttpInfo(rsp)));
            }));
    }

    /**
     * Yandex link.
     */
    public yandex0_9(_options?: ConfigurationOptions): Observable<AuthResponseDTO> {
        return this.yandex0_9WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<AuthResponseDTO>) => apiResponse.data));
    }

    /**
     * Yandex OAUTH2 redirect.
     */
    public yandex0_10WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.yandex0_10(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.yandex0_10WithHttpInfo(rsp)));
            }));
    }

    /**
     * Yandex OAUTH2 redirect.
     */
    public yandex0_10(_options?: ConfigurationOptions): Observable<void> {
        return this.yandex0_10WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

}

import { AuthVerificationApiRequestFactory, AuthVerificationApiResponseProcessor} from "../apis/AuthVerificationApi";
export class ObservableAuthVerificationApi {
    private requestFactory: AuthVerificationApiRequestFactory;
    private responseProcessor: AuthVerificationApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: AuthVerificationApiRequestFactory,
        responseProcessor?: AuthVerificationApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new AuthVerificationApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new AuthVerificationApiResponseProcessor();
    }

    /**
     * @param authVerificationCodeDTO
     */
    public code0WithHttpInfo(authVerificationCodeDTO: AuthVerificationCodeDTO, _options?: ConfigurationOptions): Observable<HttpInfo<AuthVerificationResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.code0(authVerificationCodeDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.code0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param authVerificationCodeDTO
     */
    public code0(authVerificationCodeDTO: AuthVerificationCodeDTO, _options?: ConfigurationOptions): Observable<AuthVerificationResponseDTO> {
        return this.code0WithHttpInfo(authVerificationCodeDTO, _options).pipe(map((apiResponse: HttpInfo<AuthVerificationResponseDTO>) => apiResponse.data));
    }

    /**
     * @param authVerificationVerifyDTO
     */
    public verify0WithHttpInfo(authVerificationVerifyDTO: AuthVerificationVerifyDTO, _options?: ConfigurationOptions): Observable<HttpInfo<AuthResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.verify0(authVerificationVerifyDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.verify0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param authVerificationVerifyDTO
     */
    public verify0(authVerificationVerifyDTO: AuthVerificationVerifyDTO, _options?: ConfigurationOptions): Observable<AuthResponseDTO> {
        return this.verify0WithHttpInfo(authVerificationVerifyDTO, _options).pipe(map((apiResponse: HttpInfo<AuthResponseDTO>) => apiResponse.data));
    }

}

import { BackgroundApiRequestFactory, BackgroundApiResponseProcessor} from "../apis/BackgroundApi";
export class ObservableBackgroundApi {
    private requestFactory: BackgroundApiRequestFactory;
    private responseProcessor: BackgroundApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: BackgroundApiRequestFactory,
        responseProcessor?: BackgroundApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new BackgroundApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new BackgroundApiResponseProcessor();
    }

    /**
     * @param body
     */
    public create0WithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.create0(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.create0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param body
     */
    public create0(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.create0WithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public findById0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findById0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findById0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public findById0(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.findById0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     */
    public list0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.list0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.list0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public list0(_options?: ConfigurationOptions): Observable<Array<any>> {
        return this.list0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

}

import { BackgroundCategoryApiRequestFactory, BackgroundCategoryApiResponseProcessor} from "../apis/BackgroundCategoryApi";
export class ObservableBackgroundCategoryApi {
    private requestFactory: BackgroundCategoryApiRequestFactory;
    private responseProcessor: BackgroundCategoryApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: BackgroundCategoryApiRequestFactory,
        responseProcessor?: BackgroundCategoryApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new BackgroundCategoryApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new BackgroundCategoryApiResponseProcessor();
    }

    /**
     */
    public list0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.list0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.list0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public list0(_options?: ConfigurationOptions): Observable<Array<any>> {
        return this.list0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

}

import { BannerGetApiRequestFactory, BannerGetApiResponseProcessor} from "../apis/BannerGetApi";
export class ObservableBannerGetApi {
    private requestFactory: BannerGetApiRequestFactory;
    private responseProcessor: BannerGetApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: BannerGetApiRequestFactory,
        responseProcessor?: BannerGetApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new BannerGetApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new BannerGetApiResponseProcessor();
    }

    /**
     * Returns banners data.
     * @param positions Array of types, that needed to be returned.
     * @param profileType Profile type to filter banners to be returned.
     * @param [language] Specific language code for query.
     * @param [uuid] Current advertising uuid.
     */
    public get0WithHttpInfo(positions: Array<'HERO' | 'SIDEBAR' | 'TOP' | 'LIST'>, profileType: 'employee' | 'hirer' | 'unknown', language?: 'en' | 'ru' | 'uk', uuid?: string, _options?: ConfigurationOptions): Observable<HttpInfo<BannerResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.get0(positions, profileType, language, uuid, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.get0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns banners data.
     * @param positions Array of types, that needed to be returned.
     * @param profileType Profile type to filter banners to be returned.
     * @param [language] Specific language code for query.
     * @param [uuid] Current advertising uuid.
     */
    public get0(positions: Array<'HERO' | 'SIDEBAR' | 'TOP' | 'LIST'>, profileType: 'employee' | 'hirer' | 'unknown', language?: 'en' | 'ru' | 'uk', uuid?: string, _options?: ConfigurationOptions): Observable<BannerResponseDTO> {
        return this.get0WithHttpInfo(positions, profileType, language, uuid, _options).pipe(map((apiResponse: HttpInfo<BannerResponseDTO>) => apiResponse.data));
    }

    /**
     * Returns banners data.
     * @param bannerId Unique id of banner to find.
     * @param platform Platform type to filter banners to be returned.
     * @param [advertisingId] Current advertising uuid.
     */
    public referral0WithHttpInfo(bannerId: number, platform: 'MOBILE' | 'DESKTOP', advertisingId?: string, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.referral0(bannerId, platform, advertisingId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.referral0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns banners data.
     * @param bannerId Unique id of banner to find.
     * @param platform Platform type to filter banners to be returned.
     * @param [advertisingId] Current advertising uuid.
     */
    public referral0(bannerId: number, platform: 'MOBILE' | 'DESKTOP', advertisingId?: string, _options?: ConfigurationOptions): Observable<any> {
        return this.referral0WithHttpInfo(bannerId, platform, advertisingId, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { CVApiRequestFactory, CVApiResponseProcessor} from "../apis/CVApi";
export class ObservableCVApi {
    private requestFactory: CVApiRequestFactory;
    private responseProcessor: CVApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CVApiRequestFactory,
        responseProcessor?: CVApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CVApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CVApiResponseProcessor();
    }

    /**
     */
    public addToBlackList0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.addToBlackList0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.addToBlackList0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public addToBlackList0(_options?: ConfigurationOptions): Observable<void> {
        return this.addToBlackList0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param favouriteFolderId
     */
    public addToSaved0WithHttpInfo(favouriteFolderId: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.addToSaved0(favouriteFolderId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.addToSaved0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param favouriteFolderId
     */
    public addToSaved0(favouriteFolderId: number, _options?: ConfigurationOptions): Observable<void> {
        return this.addToSaved0WithHttpInfo(favouriteFolderId, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Create a single CV
     * @param body
     */
    public createOneBaseCVControllerCVWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCVControllerCV(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCVControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single CV
     * @param body
     */
    public createOneBaseCVControllerCV(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCVControllerCVWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single CV
     * @param id
     */
    public deleteOneBaseCVControllerCVWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCVControllerCV(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCVControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single CV
     * @param id
     */
    public deleteOneBaseCVControllerCV(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.deleteOneBaseCVControllerCVWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple CVS
     * @param ids
     * @param categories
     * @param skills
     * @param sources
     * @param verticals
     * @param geos
     * @param countries
     * @param cities
     * @param employment
     * @param schedule
     * @param gender
     * @param workExperiencePresense
     * @param experience
     * @param education
     * @param relocation
     * @param nativeLanguage
     * @param compensation
     * @param search
     * @param currency
     * @param gybridurrency
     * @param pieceworkurrency
     * @param salaryMin
     * @param salaryMax
     * @param pieceworkSalaryMin
     * @param pieceworkSalaryMax
     * @param commissionMin
     * @param commissionMax
     * @param gybridSalaryMin
     * @param gybridSalaryMax
     * @param gybridCommissionMin
     * @param gybridCommissionMax
     * @param isTop
     * @param savedByCurrentProfile
     * @param blackListedByCurrentProfile
     * @param languageKnowledges
     * @param withCharacter
     * @param forLastNumberOfDays
     * @param institutions
     * @param vacancyLookType
     * @param ageMin
     * @param ageMax
     * @param withImage
     * @param favouriteFolderId
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCVControllerCVWithHttpInfo(ids: Array<string>, categories: Array<string>, skills: Array<string>, sources: Array<string>, verticals: Array<string>, geos: Array<string>, countries: Array<string>, cities: Array<string>, employment: Array<string>, schedule: Array<string>, gender: Array<string>, workExperiencePresense: Array<string>, experience: Array<string>, education: Array<string>, relocation: Array<string>, nativeLanguage: Array<string>, compensation: Array<string>, search: string, currency: string, gybridurrency: string, pieceworkurrency: string, salaryMin: number, salaryMax: number, pieceworkSalaryMin: number, pieceworkSalaryMax: number, commissionMin: number, commissionMax: number, gybridSalaryMin: number, gybridSalaryMax: number, gybridCommissionMin: number, gybridCommissionMax: number, isTop: string, savedByCurrentProfile: string, blackListedByCurrentProfile: string, languageKnowledges: string, withCharacter: string, forLastNumberOfDays: number, institutions: Array<string>, vacancyLookType: Array<string>, ageMin: number, ageMax: number, withImage: string, favouriteFolderId: number, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCVControllerCV(ids, categories, skills, sources, verticals, geos, countries, cities, employment, schedule, gender, workExperiencePresense, experience, education, relocation, nativeLanguage, compensation, search, currency, gybridurrency, pieceworkurrency, salaryMin, salaryMax, pieceworkSalaryMin, pieceworkSalaryMax, commissionMin, commissionMax, gybridSalaryMin, gybridSalaryMax, gybridCommissionMin, gybridCommissionMax, isTop, savedByCurrentProfile, blackListedByCurrentProfile, languageKnowledges, withCharacter, forLastNumberOfDays, institutions, vacancyLookType, ageMin, ageMax, withImage, favouriteFolderId, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCVControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CVS
     * @param ids
     * @param categories
     * @param skills
     * @param sources
     * @param verticals
     * @param geos
     * @param countries
     * @param cities
     * @param employment
     * @param schedule
     * @param gender
     * @param workExperiencePresense
     * @param experience
     * @param education
     * @param relocation
     * @param nativeLanguage
     * @param compensation
     * @param search
     * @param currency
     * @param gybridurrency
     * @param pieceworkurrency
     * @param salaryMin
     * @param salaryMax
     * @param pieceworkSalaryMin
     * @param pieceworkSalaryMax
     * @param commissionMin
     * @param commissionMax
     * @param gybridSalaryMin
     * @param gybridSalaryMax
     * @param gybridCommissionMin
     * @param gybridCommissionMax
     * @param isTop
     * @param savedByCurrentProfile
     * @param blackListedByCurrentProfile
     * @param languageKnowledges
     * @param withCharacter
     * @param forLastNumberOfDays
     * @param institutions
     * @param vacancyLookType
     * @param ageMin
     * @param ageMax
     * @param withImage
     * @param favouriteFolderId
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCVControllerCV(ids: Array<string>, categories: Array<string>, skills: Array<string>, sources: Array<string>, verticals: Array<string>, geos: Array<string>, countries: Array<string>, cities: Array<string>, employment: Array<string>, schedule: Array<string>, gender: Array<string>, workExperiencePresense: Array<string>, experience: Array<string>, education: Array<string>, relocation: Array<string>, nativeLanguage: Array<string>, compensation: Array<string>, search: string, currency: string, gybridurrency: string, pieceworkurrency: string, salaryMin: number, salaryMax: number, pieceworkSalaryMin: number, pieceworkSalaryMax: number, commissionMin: number, commissionMax: number, gybridSalaryMin: number, gybridSalaryMax: number, gybridCommissionMin: number, gybridCommissionMax: number, isTop: string, savedByCurrentProfile: string, blackListedByCurrentProfile: string, languageKnowledges: string, withCharacter: string, forLastNumberOfDays: number, institutions: Array<string>, vacancyLookType: Array<string>, ageMin: number, ageMax: number, withImage: string, favouriteFolderId: number, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseCVControllerCVWithHttpInfo(ids, categories, skills, sources, verticals, geos, countries, cities, employment, schedule, gender, workExperiencePresense, experience, education, relocation, nativeLanguage, compensation, search, currency, gybridurrency, pieceworkurrency, salaryMin, salaryMax, pieceworkSalaryMin, pieceworkSalaryMax, commissionMin, commissionMax, gybridSalaryMin, gybridSalaryMax, gybridCommissionMin, gybridCommissionMax, isTop, savedByCurrentProfile, blackListedByCurrentProfile, languageKnowledges, withCharacter, forLastNumberOfDays, institutions, vacancyLookType, ageMin, ageMax, withImage, favouriteFolderId, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single CV
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCVControllerCVWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCVControllerCV(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCVControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CV
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCVControllerCV(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCVControllerCVWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public getViews0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getViews0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getViews0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public getViews0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.getViews0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     */
    public listByCurrentProfile0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.listByCurrentProfile0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.listByCurrentProfile0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public listByCurrentProfile0(_options?: ConfigurationOptions): Observable<Array<any>> {
        return this.listByCurrentProfile0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     */
    public removeFromBlackList0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.removeFromBlackList0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.removeFromBlackList0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public removeFromBlackList0(_options?: ConfigurationOptions): Observable<void> {
        return this.removeFromBlackList0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     */
    public removeFromSaved0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.removeFromSaved0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.removeFromSaved0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public removeFromSaved0(_options?: ConfigurationOptions): Observable<void> {
        return this.removeFromSaved0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param search
     */
    public suggest0WithHttpInfo(search: string, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.suggest0(search, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.suggest0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param search
     */
    public suggest0(search: string, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.suggest0WithHttpInfo(search, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     */
    public toTop0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.toTop0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.toTop0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public toTop0(_options?: ConfigurationOptions): Observable<void> {
        return this.toTop0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Update a single CV
     * @param id
     * @param body
     */
    public updateOneBaseCVControllerCVWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCVControllerCV(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCVControllerCVWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single CV
     * @param id
     * @param body
     */
    public updateOneBaseCVControllerCV(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCVControllerCVWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { CVContactsApiRequestFactory, CVContactsApiResponseProcessor} from "../apis/CVContactsApi";
export class ObservableCVContactsApi {
    private requestFactory: CVContactsApiRequestFactory;
    private responseProcessor: CVContactsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CVContactsApiRequestFactory,
        responseProcessor?: CVContactsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CVContactsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CVContactsApiResponseProcessor();
    }

    /**
     * Add contacts to CV
     * @param cvId ID of the CV
     * @param addContactsInCvDto
     */
    public add0WithHttpInfo(cvId: number, addContactsInCvDto: AddContactsInCvDto, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.add0(cvId, addContactsInCvDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.add0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Add contacts to CV
     * @param cvId ID of the CV
     * @param addContactsInCvDto
     */
    public add0(cvId: number, addContactsInCvDto: AddContactsInCvDto, _options?: ConfigurationOptions): Observable<any> {
        return this.add0WithHttpInfo(cvId, addContactsInCvDto, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Get active contact accesses for CV
     * @param cvId ID of the CV
     */
    public getActiveContactAccess0WithHttpInfo(cvId: number, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getActiveContactAccess0(cvId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getActiveContactAccess0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Get active contact accesses for CV
     * @param cvId ID of the CV
     */
    public getActiveContactAccess0(cvId: number, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.getActiveContactAccess0WithHttpInfo(cvId, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Grant access to CV contacts
     * @param cvId ID of the CV
     * @param productId ID of the product
     */
    public grantAccess0WithHttpInfo(cvId: number, productId: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.grantAccess0(cvId, productId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.grantAccess0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Grant access to CV contacts
     * @param cvId ID of the CV
     * @param productId ID of the product
     */
    public grantAccess0(cvId: number, productId: number, _options?: ConfigurationOptions): Observable<any> {
        return this.grantAccess0WithHttpInfo(cvId, productId, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update contacts in CV
     * @param cvId ID of the CV
     * @param addContactsInCvDto
     */
    public update0WithHttpInfo(cvId: number, addContactsInCvDto: AddContactsInCvDto, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.update0(cvId, addContactsInCvDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.update0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Update contacts in CV
     * @param cvId ID of the CV
     * @param addContactsInCvDto
     */
    public update0(cvId: number, addContactsInCvDto: AddContactsInCvDto, _options?: ConfigurationOptions): Observable<any> {
        return this.update0WithHttpInfo(cvId, addContactsInCvDto, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { CVDownloadApiRequestFactory, CVDownloadApiResponseProcessor} from "../apis/CVDownloadApi";
export class ObservableCVDownloadApi {
    private requestFactory: CVDownloadApiRequestFactory;
    private responseProcessor: CVDownloadApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CVDownloadApiRequestFactory,
        responseProcessor?: CVDownloadApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CVDownloadApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CVDownloadApiResponseProcessor();
    }

    /**
     * Скачать резюме в формате PDF
     * @param lang
     * @param id ID резюме
     */
    public downloadPdf0WithHttpInfo(lang: string, id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.downloadPdf0(lang, id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.downloadPdf0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Скачать резюме в формате PDF
     * @param lang
     * @param id ID резюме
     */
    public downloadPdf0(lang: string, id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.downloadPdf0WithHttpInfo(lang, id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

}

import { CharacterApiRequestFactory, CharacterApiResponseProcessor} from "../apis/CharacterApi";
export class ObservableCharacterApi {
    private requestFactory: CharacterApiRequestFactory;
    private responseProcessor: CharacterApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CharacterApiRequestFactory,
        responseProcessor?: CharacterApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CharacterApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CharacterApiResponseProcessor();
    }

    /**
     */
    public buy0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.buy0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.buy0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public buy0(_options?: ConfigurationOptions): Observable<void> {
        return this.buy0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Create a single Character
     */
    public createOneBaseCharacterControllerCharacterWithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCharacterControllerCharacter(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCharacterControllerCharacterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Character
     */
    public createOneBaseCharacterControllerCharacter(_options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCharacterControllerCharacterWithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Character
     * @param id
     */
    public deleteOneBaseCharacterControllerCharacterWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCharacterControllerCharacter(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCharacterControllerCharacterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Character
     * @param id
     */
    public deleteOneBaseCharacterControllerCharacter(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.deleteOneBaseCharacterControllerCharacterWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Characters
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCharacterControllerCharacterWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCharacterControllerCharacter(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCharacterControllerCharacterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Characters
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCharacterControllerCharacter(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseCharacterControllerCharacterWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single Character
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCharacterControllerCharacterWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCharacterControllerCharacter(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCharacterControllerCharacterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Character
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCharacterControllerCharacter(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCharacterControllerCharacterWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     */
    public listByCurrentProfile0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.listByCurrentProfile0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.listByCurrentProfile0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public listByCurrentProfile0(_options?: ConfigurationOptions): Observable<any> {
        return this.listByCurrentProfile0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Character
     * @param id
     * @param body
     */
    public updateOneBaseCharacterControllerCharacterWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCharacterControllerCharacter(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCharacterControllerCharacterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Character
     * @param id
     * @param body
     */
    public updateOneBaseCharacterControllerCharacter(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCharacterControllerCharacterWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { CharacterItemApiRequestFactory, CharacterItemApiResponseProcessor} from "../apis/CharacterItemApi";
export class ObservableCharacterItemApi {
    private requestFactory: CharacterItemApiRequestFactory;
    private responseProcessor: CharacterItemApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CharacterItemApiRequestFactory,
        responseProcessor?: CharacterItemApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CharacterItemApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CharacterItemApiResponseProcessor();
    }

    /**
     * @param id
     */
    public buy0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<CharacterItem>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.buy0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.buy0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public buy0(id: number, _options?: ConfigurationOptions): Observable<CharacterItem> {
        return this.buy0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<CharacterItem>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public deselectForCharacter0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deselectForCharacter0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deselectForCharacter0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public deselectForCharacter0(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.deselectForCharacter0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public findById0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findById0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findById0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public findById0(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.findById0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     */
    public list0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.list0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.list0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public list0(_options?: ConfigurationOptions): Observable<Array<any>> {
        return this.list0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public selectForCharacter0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.selectForCharacter0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.selectForCharacter0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public selectForCharacter0(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.selectForCharacter0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { CharacterItemCategoryApiRequestFactory, CharacterItemCategoryApiResponseProcessor} from "../apis/CharacterItemCategoryApi";
export class ObservableCharacterItemCategoryApi {
    private requestFactory: CharacterItemCategoryApiRequestFactory;
    private responseProcessor: CharacterItemCategoryApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CharacterItemCategoryApiRequestFactory,
        responseProcessor?: CharacterItemCategoryApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CharacterItemCategoryApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CharacterItemCategoryApiResponseProcessor();
    }

    /**
     */
    public list0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.list0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.list0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public list0(_options?: ConfigurationOptions): Observable<Array<any>> {
        return this.list0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

}

import { ChatApiRequestFactory, ChatApiResponseProcessor} from "../apis/ChatApi";
export class ObservableChatApi {
    private requestFactory: ChatApiRequestFactory;
    private responseProcessor: ChatApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ChatApiRequestFactory,
        responseProcessor?: ChatApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ChatApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ChatApiResponseProcessor();
    }

    /**
     * @param body
     */
    public create0WithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.create0(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.create0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param body
     */
    public create0(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.create0WithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public delete0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.delete0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.delete0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public delete0(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.delete0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param body
     */
    public deleteChats0WithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteChats0(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteChats0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param body
     */
    public deleteChats0(body: any, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteChats0WithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param toId
     * @param applicationId
     * @param proposalId
     */
    public findDialog0WithHttpInfo(toId: number, applicationId: number, proposalId: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findDialog0(toId, applicationId, proposalId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findDialog0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param toId
     * @param applicationId
     * @param proposalId
     */
    public findDialog0(toId: number, applicationId: number, proposalId: number, _options?: ConfigurationOptions): Observable<any> {
        return this.findDialog0WithHttpInfo(toId, applicationId, proposalId, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     */
    public indexAllChatsContacts0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.indexAllChatsContacts0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.indexAllChatsContacts0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public indexAllChatsContacts0(_options?: ConfigurationOptions): Observable<void> {
        return this.indexAllChatsContacts0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param limit
     * @param page
     */
    public indexAllChatsVacancies0WithHttpInfo(limit: number, page: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.indexAllChatsVacancies0(limit, page, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.indexAllChatsVacancies0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param limit
     * @param page
     */
    public indexAllChatsVacancies0(limit: number, page: number, _options?: ConfigurationOptions): Observable<void> {
        return this.indexAllChatsVacancies0WithHttpInfo(limit, page, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param vacanciesIds
     */
    public indexDialogs0WithHttpInfo(vacanciesIds: Array<string>, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.indexDialogs0(vacanciesIds, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.indexDialogs0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param vacanciesIds
     */
    public indexDialogs0(vacanciesIds: Array<string>, _options?: ConfigurationOptions): Observable<void> {
        return this.indexDialogs0WithHttpInfo(vacanciesIds, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param id
     * @param limit
     * @param page
     */
    public listMedia0WithHttpInfo(id: number, limit: number, page: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.listMedia0(id, limit, page, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.listMedia0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     * @param limit
     * @param page
     */
    public listMedia0(id: number, limit: number, page: number, _options?: ConfigurationOptions): Observable<void> {
        return this.listMedia0WithHttpInfo(id, limit, page, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param id
     * @param limit
     * @param page
     */
    public listUrl0WithHttpInfo(id: number, limit: number, page: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.listUrl0(id, limit, page, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.listUrl0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     * @param limit
     * @param page
     */
    public listUrl0(id: number, limit: number, page: number, _options?: ConfigurationOptions): Observable<void> {
        return this.listUrl0WithHttpInfo(id, limit, page, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param body
     */
    public moveChatsToFolder0WithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.moveChatsToFolder0(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.moveChatsToFolder0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param body
     */
    public moveChatsToFolder0(body: any, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.moveChatsToFolder0WithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * @param body
     */
    public setRead0WithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.setRead0(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.setRead0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param body
     */
    public setRead0(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.setRead0WithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public show0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.show0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.show0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public show0(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.show0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param id
     * @param body
     */
    public update0WithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.update0(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.update0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     * @param body
     */
    public update0(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.update0WithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ChatFolderApiRequestFactory, ChatFolderApiResponseProcessor} from "../apis/ChatFolderApi";
export class ObservableChatFolderApi {
    private requestFactory: ChatFolderApiRequestFactory;
    private responseProcessor: ChatFolderApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ChatFolderApiRequestFactory,
        responseProcessor?: ChatFolderApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ChatFolderApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ChatFolderApiResponseProcessor();
    }

    /**
     * Create a single ChatFolder
     * @param body
     */
    public createOneBaseChatFolderControllerChatFolderWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseChatFolderControllerChatFolder(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseChatFolderControllerChatFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single ChatFolder
     * @param body
     */
    public createOneBaseChatFolderControllerChatFolder(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseChatFolderControllerChatFolderWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single ChatFolder
     * @param id
     */
    public deleteOneBaseChatFolderControllerChatFolderWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseChatFolderControllerChatFolder(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseChatFolderControllerChatFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single ChatFolder
     * @param id
     */
    public deleteOneBaseChatFolderControllerChatFolder(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.deleteOneBaseChatFolderControllerChatFolderWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple ChatFolders
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseChatFolderControllerChatFolderWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseChatFolderControllerChatFolder(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseChatFolderControllerChatFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple ChatFolders
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseChatFolderControllerChatFolder(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseChatFolderControllerChatFolderWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single ChatFolder
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseChatFolderControllerChatFolderWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseChatFolderControllerChatFolder(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseChatFolderControllerChatFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single ChatFolder
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseChatFolderControllerChatFolder(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseChatFolderControllerChatFolderWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single ChatFolder
     * @param id
     * @param body
     */
    public updateOneBaseChatFolderControllerChatFolderWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseChatFolderControllerChatFolder(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseChatFolderControllerChatFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single ChatFolder
     * @param id
     * @param body
     */
    public updateOneBaseChatFolderControllerChatFolder(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseChatFolderControllerChatFolderWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ChatMessageApiRequestFactory, ChatMessageApiResponseProcessor} from "../apis/ChatMessageApi";
export class ObservableChatMessageApi {
    private requestFactory: ChatMessageApiRequestFactory;
    private responseProcessor: ChatMessageApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ChatMessageApiRequestFactory,
        responseProcessor?: ChatMessageApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ChatMessageApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ChatMessageApiResponseProcessor();
    }

    /**
     * @param body
     */
    public changeProfileState0WithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.changeProfileState0(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.changeProfileState0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param body
     */
    public changeProfileState0(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.changeProfileState0WithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param body
     */
    public create0WithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.create0(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.create0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param body
     */
    public create0(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.create0WithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param id
     * @param deleteType
     */
    public delete0WithHttpInfo(id: number, deleteType: string, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.delete0(id, deleteType, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.delete0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     * @param deleteType
     */
    public delete0(id: number, deleteType: string, _options?: ConfigurationOptions): Observable<any> {
        return this.delete0WithHttpInfo(id, deleteType, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     */
    public extractUrls0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.extractUrls0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.extractUrls0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public extractUrls0(_options?: ConfigurationOptions): Observable<Array<any>> {
        return this.extractUrls0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * @param chatId
     */
    public index0WithHttpInfo(chatId: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.index0(chatId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.index0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param chatId
     */
    public index0(chatId: number, _options?: ConfigurationOptions): Observable<void> {
        return this.index0WithHttpInfo(chatId, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     */
    public search0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.search0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.search0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public search0(_options?: ConfigurationOptions): Observable<void> {
        return this.search0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param id
     * @param body
     */
    public setPinned0WithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.setPinned0(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.setPinned0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     * @param body
     */
    public setPinned0(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.setPinned0WithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public show0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.show0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.show0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public show0(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.show0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ChatMessageUrlApiRequestFactory, ChatMessageUrlApiResponseProcessor} from "../apis/ChatMessageUrlApi";
export class ObservableChatMessageUrlApi {
    private requestFactory: ChatMessageUrlApiRequestFactory;
    private responseProcessor: ChatMessageUrlApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ChatMessageUrlApiRequestFactory,
        responseProcessor?: ChatMessageUrlApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ChatMessageUrlApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ChatMessageUrlApiResponseProcessor();
    }

    /**
     * Create multiple ChatMessageUrls
     * @param createManyChatMessageUrlDto
     */
    public createManyBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(createManyChatMessageUrlDto: CreateManyChatMessageUrlDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseChatMessageUrlControllerChatMessageUrl(createManyChatMessageUrlDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple ChatMessageUrls
     * @param createManyChatMessageUrlDto
     */
    public createManyBaseChatMessageUrlControllerChatMessageUrl(createManyChatMessageUrlDto: CreateManyChatMessageUrlDto, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.createManyBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(createManyChatMessageUrlDto, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Create a single ChatMessageUrl
     * @param body
     */
    public createOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseChatMessageUrlControllerChatMessageUrl(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single ChatMessageUrl
     * @param body
     */
    public createOneBaseChatMessageUrlControllerChatMessageUrl(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single ChatMessageUrl
     * @param id
     */
    public deleteOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseChatMessageUrlControllerChatMessageUrl(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single ChatMessageUrl
     * @param id
     */
    public deleteOneBaseChatMessageUrlControllerChatMessageUrl(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple ChatMessageUrls
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseChatMessageUrlControllerChatMessageUrl200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseChatMessageUrlControllerChatMessageUrl(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple ChatMessageUrls
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseChatMessageUrlControllerChatMessageUrl(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseChatMessageUrlControllerChatMessageUrl200Response> {
        return this.getManyBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseChatMessageUrlControllerChatMessageUrl200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single ChatMessageUrl
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseChatMessageUrlControllerChatMessageUrl(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single ChatMessageUrl
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseChatMessageUrlControllerChatMessageUrl(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single ChatMessageUrl
     * @param id
     * @param body
     */
    public replaceOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseChatMessageUrlControllerChatMessageUrl(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single ChatMessageUrl
     * @param id
     * @param body
     */
    public replaceOneBaseChatMessageUrlControllerChatMessageUrl(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single ChatMessageUrl
     * @param id
     * @param body
     */
    public updateOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseChatMessageUrlControllerChatMessageUrl(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single ChatMessageUrl
     * @param id
     * @param body
     */
    public updateOneBaseChatMessageUrlControllerChatMessageUrl(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseChatMessageUrlControllerChatMessageUrlWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { CommunityApiRequestFactory, CommunityApiResponseProcessor} from "../apis/CommunityApi";
export class ObservableCommunityApi {
    private requestFactory: CommunityApiRequestFactory;
    private responseProcessor: CommunityApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CommunityApiRequestFactory,
        responseProcessor?: CommunityApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CommunityApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CommunityApiResponseProcessor();
    }

    /**
     */
    public addToSaved0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.addToSaved0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.addToSaved0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public addToSaved0(_options?: ConfigurationOptions): Observable<void> {
        return this.addToSaved0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Create a single Community
     * @param body
     */
    public createOneBaseCommunityControllerCommunityWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCommunityControllerCommunity(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCommunityControllerCommunityWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Community
     * @param body
     */
    public createOneBaseCommunityControllerCommunity(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCommunityControllerCommunityWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Community
     * @param id
     */
    public deleteOneBaseCommunityControllerCommunityWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCommunityControllerCommunity(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCommunityControllerCommunityWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Community
     * @param id
     */
    public deleteOneBaseCommunityControllerCommunity(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.deleteOneBaseCommunityControllerCommunityWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Communities
     * @param search
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCommunityControllerCommunityWithHttpInfo(search: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCommunityControllerCommunity(search, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCommunityControllerCommunityWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Communities
     * @param search
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCommunityControllerCommunity(search: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseCommunityControllerCommunityWithHttpInfo(search, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single Community
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCommunityControllerCommunityWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCommunityControllerCommunity(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCommunityControllerCommunityWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Community
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCommunityControllerCommunity(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCommunityControllerCommunityWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     */
    public listByCurrentProfile0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.listByCurrentProfile0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.listByCurrentProfile0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public listByCurrentProfile0(_options?: ConfigurationOptions): Observable<any> {
        return this.listByCurrentProfile0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param id
     * @param search
     */
    public listSubscribers0WithHttpInfo(id: number, search: string, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.listSubscribers0(id, search, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.listSubscribers0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     * @param search
     */
    public listSubscribers0(id: number, search: string, _options?: ConfigurationOptions): Observable<any> {
        return this.listSubscribers0WithHttpInfo(id, search, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     */
    public removeFromSaved0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.removeFromSaved0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.removeFromSaved0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public removeFromSaved0(_options?: ConfigurationOptions): Observable<void> {
        return this.removeFromSaved0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Update a single Community
     * @param id
     * @param body
     */
    public updateOneBaseCommunityControllerCommunityWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCommunityControllerCommunity(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCommunityControllerCommunityWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Community
     * @param id
     * @param body
     */
    public updateOneBaseCommunityControllerCommunity(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCommunityControllerCommunityWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { CourseApiRequestFactory, CourseApiResponseProcessor} from "../apis/CourseApi";
export class ObservableCourseApi {
    private requestFactory: CourseApiRequestFactory;
    private responseProcessor: CourseApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CourseApiRequestFactory,
        responseProcessor?: CourseApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CourseApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CourseApiResponseProcessor();
    }

    /**
     * @param id
     */
    public addToSaved0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.addToSaved0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.addToSaved0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public addToSaved0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.addToSaved0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public findById0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findById0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findById0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public findById0(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.findById0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param limit
     * @param page
     * @param categories
     * @param languages
     * @param savedByCurrentProfile
     */
    public listByProfile0WithHttpInfo(limit: number, page: number, categories: Array<string>, languages: Array<string>, savedByCurrentProfile: string, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.listByProfile0(limit, page, categories, languages, savedByCurrentProfile, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.listByProfile0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param limit
     * @param page
     * @param categories
     * @param languages
     * @param savedByCurrentProfile
     */
    public listByProfile0(limit: number, page: number, categories: Array<string>, languages: Array<string>, savedByCurrentProfile: string, _options?: ConfigurationOptions): Observable<void> {
        return this.listByProfile0WithHttpInfo(limit, page, categories, languages, savedByCurrentProfile, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public removeFromSaved0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.removeFromSaved0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.removeFromSaved0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public removeFromSaved0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.removeFromSaved0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

}

import { CourseBlockApiRequestFactory, CourseBlockApiResponseProcessor} from "../apis/CourseBlockApi";
export class ObservableCourseBlockApi {
    private requestFactory: CourseBlockApiRequestFactory;
    private responseProcessor: CourseBlockApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CourseBlockApiRequestFactory,
        responseProcessor?: CourseBlockApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CourseBlockApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CourseBlockApiResponseProcessor();
    }

    /**
     * Retrieve multiple CourseBlocks
     * @param lang
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseBlockControllerCourseBlockWithHttpInfo(lang: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCourseBlockControllerCourseBlock(lang, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCourseBlockControllerCourseBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CourseBlocks
     * @param lang
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseBlockControllerCourseBlock(lang: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseCourseBlockControllerCourseBlockWithHttpInfo(lang, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single CourseBlock
     * @param lang
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseBlockControllerCourseBlockWithHttpInfo(lang: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCourseBlockControllerCourseBlock(lang, id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCourseBlockControllerCourseBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CourseBlock
     * @param lang
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseBlockControllerCourseBlock(lang: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCourseBlockControllerCourseBlockWithHttpInfo(lang, id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { CourseBlockStepApiRequestFactory, CourseBlockStepApiResponseProcessor} from "../apis/CourseBlockStepApi";
export class ObservableCourseBlockStepApi {
    private requestFactory: CourseBlockStepApiRequestFactory;
    private responseProcessor: CourseBlockStepApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CourseBlockStepApiRequestFactory,
        responseProcessor?: CourseBlockStepApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CourseBlockStepApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CourseBlockStepApiResponseProcessor();
    }

    /**
     * Retrieve multiple CourseBlockSteps
     * @param lang
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseBlockStepControllerCourseBlockStepWithHttpInfo(lang: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCourseBlockStepControllerCourseBlockStep(lang, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCourseBlockStepControllerCourseBlockStepWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CourseBlockSteps
     * @param lang
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseBlockStepControllerCourseBlockStep(lang: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseCourseBlockStepControllerCourseBlockStepWithHttpInfo(lang, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single CourseBlockStep
     * @param lang
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseBlockStepControllerCourseBlockStepWithHttpInfo(lang: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCourseBlockStepControllerCourseBlockStep(lang, id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCourseBlockStepControllerCourseBlockStepWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CourseBlockStep
     * @param lang
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseBlockStepControllerCourseBlockStep(lang: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCourseBlockStepControllerCourseBlockStepWithHttpInfo(lang, id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { CourseBlockStepAnswerApiRequestFactory, CourseBlockStepAnswerApiResponseProcessor} from "../apis/CourseBlockStepAnswerApi";
export class ObservableCourseBlockStepAnswerApi {
    private requestFactory: CourseBlockStepAnswerApiRequestFactory;
    private responseProcessor: CourseBlockStepAnswerApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CourseBlockStepAnswerApiRequestFactory,
        responseProcessor?: CourseBlockStepAnswerApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CourseBlockStepAnswerApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CourseBlockStepAnswerApiResponseProcessor();
    }

    /**
     * Create a single CourseBlockStepAnswer
     * @param body
     */
    public createOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single CourseBlockStepAnswer
     * @param body
     */
    public createOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple CourseBlockStepAnswers
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CourseBlockStepAnswers
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single CourseBlockStepAnswer
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CourseBlockStepAnswer
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single CourseBlockStepAnswer
     * @param id
     * @param body
     */
    public updateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single CourseBlockStepAnswer
     * @param id
     * @param body
     */
    public updateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswer(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCourseBlockStepAnswerControllerCourseBlockStepAnswerWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { CourseModuleApiRequestFactory, CourseModuleApiResponseProcessor} from "../apis/CourseModuleApi";
export class ObservableCourseModuleApi {
    private requestFactory: CourseModuleApiRequestFactory;
    private responseProcessor: CourseModuleApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CourseModuleApiRequestFactory,
        responseProcessor?: CourseModuleApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CourseModuleApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CourseModuleApiResponseProcessor();
    }

    /**
     * Retrieve multiple CourseModules
     * @param lang
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseModuleControllerCourseModuleWithHttpInfo(lang: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCourseModuleControllerCourseModule(lang, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCourseModuleControllerCourseModuleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CourseModules
     * @param lang
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCourseModuleControllerCourseModule(lang: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseCourseModuleControllerCourseModuleWithHttpInfo(lang, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single CourseModule
     * @param lang
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseModuleControllerCourseModuleWithHttpInfo(lang: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCourseModuleControllerCourseModule(lang, id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCourseModuleControllerCourseModuleWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CourseModule
     * @param lang
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCourseModuleControllerCourseModule(lang: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCourseModuleControllerCourseModuleWithHttpInfo(lang, id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { CoverLetterApiRequestFactory, CoverLetterApiResponseProcessor} from "../apis/CoverLetterApi";
export class ObservableCoverLetterApi {
    private requestFactory: CoverLetterApiRequestFactory;
    private responseProcessor: CoverLetterApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: CoverLetterApiRequestFactory,
        responseProcessor?: CoverLetterApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new CoverLetterApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new CoverLetterApiResponseProcessor();
    }

    /**
     * Create a single CoverLetter
     * @param body
     */
    public createOneBaseCoverLetterControllerCoverLetterWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseCoverLetterControllerCoverLetter(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseCoverLetterControllerCoverLetterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single CoverLetter
     * @param body
     */
    public createOneBaseCoverLetterControllerCoverLetter(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseCoverLetterControllerCoverLetterWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single CoverLetter
     * @param id
     */
    public deleteOneBaseCoverLetterControllerCoverLetterWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseCoverLetterControllerCoverLetter(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseCoverLetterControllerCoverLetterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single CoverLetter
     * @param id
     */
    public deleteOneBaseCoverLetterControllerCoverLetter(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.deleteOneBaseCoverLetterControllerCoverLetterWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple CoverLetters
     * @param type
     * @param cvId
     * @param vacancyId
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCoverLetterControllerCoverLetterWithHttpInfo(type: string, cvId: number, vacancyId: number, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseCoverLetterControllerCoverLetter(type, cvId, vacancyId, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseCoverLetterControllerCoverLetterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple CoverLetters
     * @param type
     * @param cvId
     * @param vacancyId
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseCoverLetterControllerCoverLetter(type: string, cvId: number, vacancyId: number, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseCoverLetterControllerCoverLetterWithHttpInfo(type, cvId, vacancyId, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single CoverLetter
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCoverLetterControllerCoverLetterWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseCoverLetterControllerCoverLetter(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseCoverLetterControllerCoverLetterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single CoverLetter
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseCoverLetterControllerCoverLetter(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseCoverLetterControllerCoverLetterWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single CoverLetter
     * @param id
     * @param body
     */
    public updateOneBaseCoverLetterControllerCoverLetterWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseCoverLetterControllerCoverLetter(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseCoverLetterControllerCoverLetterWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single CoverLetter
     * @param id
     * @param body
     */
    public updateOneBaseCoverLetterControllerCoverLetter(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseCoverLetterControllerCoverLetterWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { FavouriteFolderApiRequestFactory, FavouriteFolderApiResponseProcessor} from "../apis/FavouriteFolderApi";
export class ObservableFavouriteFolderApi {
    private requestFactory: FavouriteFolderApiRequestFactory;
    private responseProcessor: FavouriteFolderApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: FavouriteFolderApiRequestFactory,
        responseProcessor?: FavouriteFolderApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new FavouriteFolderApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new FavouriteFolderApiResponseProcessor();
    }

    /**
     * Create a single FavouriteFolder
     * @param body
     */
    public createOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseFavouriteFolderControllerFavouriteFolder(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single FavouriteFolder
     * @param body
     */
    public createOneBaseFavouriteFolderControllerFavouriteFolder(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single FavouriteFolder
     * @param id
     */
    public deleteOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseFavouriteFolderControllerFavouriteFolder(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single FavouriteFolder
     * @param id
     */
    public deleteOneBaseFavouriteFolderControllerFavouriteFolder(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.deleteOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     */
    public getDefaultFolder0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getDefaultFolder0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getDefaultFolder0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public getDefaultFolder0(_options?: ConfigurationOptions): Observable<any> {
        return this.getDefaultFolder0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple FavouriteFolders
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseFavouriteFolderControllerFavouriteFolder(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple FavouriteFolders
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseFavouriteFolderControllerFavouriteFolder(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single FavouriteFolder
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseFavouriteFolderControllerFavouriteFolder(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single FavouriteFolder
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseFavouriteFolderControllerFavouriteFolder(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single FavouriteFolder
     * @param id
     * @param body
     */
    public updateOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseFavouriteFolderControllerFavouriteFolder(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single FavouriteFolder
     * @param id
     * @param body
     */
    public updateOneBaseFavouriteFolderControllerFavouriteFolder(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseFavouriteFolderControllerFavouriteFolderWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { FeedbackApiRequestFactory, FeedbackApiResponseProcessor} from "../apis/FeedbackApi";
export class ObservableFeedbackApi {
    private requestFactory: FeedbackApiRequestFactory;
    private responseProcessor: FeedbackApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: FeedbackApiRequestFactory,
        responseProcessor?: FeedbackApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new FeedbackApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new FeedbackApiResponseProcessor();
    }

    /**
     * Create a single Feedback
     * @param body
     */
    public createOneBaseFeedbackControllerFeedbackWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseFeedbackControllerFeedback(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseFeedbackControllerFeedbackWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Feedback
     * @param body
     */
    public createOneBaseFeedbackControllerFeedback(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseFeedbackControllerFeedbackWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Feedback
     * @param id
     */
    public deleteOneBaseFeedbackControllerFeedbackWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseFeedbackControllerFeedback(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseFeedbackControllerFeedbackWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Feedback
     * @param id
     */
    public deleteOneBaseFeedbackControllerFeedback(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.deleteOneBaseFeedbackControllerFeedbackWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Feedbacks
     * @param lang
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseFeedbackControllerFeedbackWithHttpInfo(lang: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseFeedbackControllerFeedback(lang, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseFeedbackControllerFeedbackWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Feedbacks
     * @param lang
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseFeedbackControllerFeedback(lang: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseFeedbackControllerFeedbackWithHttpInfo(lang, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single Feedback
     * @param lang
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseFeedbackControllerFeedbackWithHttpInfo(lang: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseFeedbackControllerFeedback(lang, id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseFeedbackControllerFeedbackWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Feedback
     * @param lang
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseFeedbackControllerFeedback(lang: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseFeedbackControllerFeedbackWithHttpInfo(lang, id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     */
    public getStats0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getStats0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getStats0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public getStats0(_options?: ConfigurationOptions): Observable<void> {
        return this.getStats0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Update a single Feedback
     * @param id
     * @param body
     */
    public updateOneBaseFeedbackControllerFeedbackWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseFeedbackControllerFeedback(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseFeedbackControllerFeedbackWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Feedback
     * @param id
     * @param body
     */
    public updateOneBaseFeedbackControllerFeedback(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseFeedbackControllerFeedbackWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { GeoApiRequestFactory, GeoApiResponseProcessor} from "../apis/GeoApi";
export class ObservableGeoApi {
    private requestFactory: GeoApiRequestFactory;
    private responseProcessor: GeoApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: GeoApiRequestFactory,
        responseProcessor?: GeoApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new GeoApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new GeoApiResponseProcessor();
    }

    /**
     * Retrieve multiple Geos
     * @param search
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseGeoControllerGeoWithHttpInfo(search: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseGeoControllerGeo(search, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseGeoControllerGeoWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Geos
     * @param search
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseGeoControllerGeo(search: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseGeoControllerGeoWithHttpInfo(search, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single Geo
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseGeoControllerGeoWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseGeoControllerGeo(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseGeoControllerGeoWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Geo
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseGeoControllerGeo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseGeoControllerGeoWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { HealthApiRequestFactory, HealthApiResponseProcessor} from "../apis/HealthApi";
export class ObservableHealthApi {
    private requestFactory: HealthApiRequestFactory;
    private responseProcessor: HealthApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: HealthApiRequestFactory,
        responseProcessor?: HealthApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new HealthApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new HealthApiResponseProcessor();
    }

    /**
     */
    public check0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<HealthControllerCheck0200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.check0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.check0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public check0(_options?: ConfigurationOptions): Observable<HealthControllerCheck0200Response> {
        return this.check0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<HealthControllerCheck0200Response>) => apiResponse.data));
    }

}

import { InfluenceCategoryApiRequestFactory, InfluenceCategoryApiResponseProcessor} from "../apis/InfluenceCategoryApi";
export class ObservableInfluenceCategoryApi {
    private requestFactory: InfluenceCategoryApiRequestFactory;
    private responseProcessor: InfluenceCategoryApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: InfluenceCategoryApiRequestFactory,
        responseProcessor?: InfluenceCategoryApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new InfluenceCategoryApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new InfluenceCategoryApiResponseProcessor();
    }

    /**
     * Returns a set of category, according to the given limit, page number and search query.
     * @param page Page.
     * @param limit Amount of items to take.
     * @param [lang] Specific language code for query.
     * @param [search] Search string to filter items.
     */
    public paginate0WithHttpInfo(page: number, limit: number, lang?: 'en' | 'ru' | 'uk', search?: string, _options?: ConfigurationOptions): Observable<HttpInfo<InfluenceCategoryControllerPaginate0200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.paginate0(page, limit, lang, search, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.paginate0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns a set of category, according to the given limit, page number and search query.
     * @param page Page.
     * @param limit Amount of items to take.
     * @param [lang] Specific language code for query.
     * @param [search] Search string to filter items.
     */
    public paginate0(page: number, limit: number, lang?: 'en' | 'ru' | 'uk', search?: string, _options?: ConfigurationOptions): Observable<InfluenceCategoryControllerPaginate0200Response> {
        return this.paginate0WithHttpInfo(page, limit, lang, search, _options).pipe(map((apiResponse: HttpInfo<InfluenceCategoryControllerPaginate0200Response>) => apiResponse.data));
    }

}

import { InfluenceContactsApiRequestFactory, InfluenceContactsApiResponseProcessor} from "../apis/InfluenceContactsApi";
export class ObservableInfluenceContactsApi {
    private requestFactory: InfluenceContactsApiRequestFactory;
    private responseProcessor: InfluenceContactsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: InfluenceContactsApiRequestFactory,
        responseProcessor?: InfluenceContactsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new InfluenceContactsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new InfluenceContactsApiResponseProcessor();
    }

    /**
     * Open contacts for resume.
     * @param resumeId Unique id of resume to find.
     */
    public open0WithHttpInfo(resumeId: number, _options?: ConfigurationOptions): Observable<HttpInfo<InfluenceResumeDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.open0(resumeId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.open0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Open contacts for resume.
     * @param resumeId Unique id of resume to find.
     */
    public open0(resumeId: number, _options?: ConfigurationOptions): Observable<InfluenceResumeDTO> {
        return this.open0WithHttpInfo(resumeId, _options).pipe(map((apiResponse: HttpInfo<InfluenceResumeDTO>) => apiResponse.data));
    }

}

import { InfluenceDirectionApiRequestFactory, InfluenceDirectionApiResponseProcessor} from "../apis/InfluenceDirectionApi";
export class ObservableInfluenceDirectionApi {
    private requestFactory: InfluenceDirectionApiRequestFactory;
    private responseProcessor: InfluenceDirectionApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: InfluenceDirectionApiRequestFactory,
        responseProcessor?: InfluenceDirectionApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new InfluenceDirectionApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new InfluenceDirectionApiResponseProcessor();
    }

    /**
     * Returns a set of direction, according to the given limit, page number and search query.
     * @param page Page.
     * @param limit Amount of items to take.
     * @param [lang] Specific language code for query.
     * @param [search] Search string to filter items.
     */
    public paginate0WithHttpInfo(page: number, limit: number, lang?: 'en' | 'ru' | 'uk', search?: string, _options?: ConfigurationOptions): Observable<HttpInfo<InfluenceDirectionControllerPaginate0200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.paginate0(page, limit, lang, search, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.paginate0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns a set of direction, according to the given limit, page number and search query.
     * @param page Page.
     * @param limit Amount of items to take.
     * @param [lang] Specific language code for query.
     * @param [search] Search string to filter items.
     */
    public paginate0(page: number, limit: number, lang?: 'en' | 'ru' | 'uk', search?: string, _options?: ConfigurationOptions): Observable<InfluenceDirectionControllerPaginate0200Response> {
        return this.paginate0WithHttpInfo(page, limit, lang, search, _options).pipe(map((apiResponse: HttpInfo<InfluenceDirectionControllerPaginate0200Response>) => apiResponse.data));
    }

}

import { InfluenceFavouriteApiRequestFactory, InfluenceFavouriteApiResponseProcessor} from "../apis/InfluenceFavouriteApi";
export class ObservableInfluenceFavouriteApi {
    private requestFactory: InfluenceFavouriteApiRequestFactory;
    private responseProcessor: InfluenceFavouriteApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: InfluenceFavouriteApiRequestFactory,
        responseProcessor?: InfluenceFavouriteApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new InfluenceFavouriteApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new InfluenceFavouriteApiResponseProcessor();
    }

    /**
     * Add to favourite.
     * @param resumeId Unique id of resume to find.
     * @param [lang] Specific language code for query.
     */
    public addToFavourite0WithHttpInfo(resumeId: number, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<HttpInfo<InfluenceResumeDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.addToFavourite0(resumeId, lang, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.addToFavourite0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Add to favourite.
     * @param resumeId Unique id of resume to find.
     * @param [lang] Specific language code for query.
     */
    public addToFavourite0(resumeId: number, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<InfluenceResumeDTO> {
        return this.addToFavourite0WithHttpInfo(resumeId, lang, _options).pipe(map((apiResponse: HttpInfo<InfluenceResumeDTO>) => apiResponse.data));
    }

    /**
     * Remove from favourite.
     * @param resumeId Unique id of resume to find.
     * @param [lang] Specific language code for query.
     */
    public removeFromFavourite0WithHttpInfo(resumeId: number, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<HttpInfo<InfluenceResumeDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.removeFromFavourite0(resumeId, lang, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.removeFromFavourite0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Remove from favourite.
     * @param resumeId Unique id of resume to find.
     * @param [lang] Specific language code for query.
     */
    public removeFromFavourite0(resumeId: number, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<InfluenceResumeDTO> {
        return this.removeFromFavourite0WithHttpInfo(resumeId, lang, _options).pipe(map((apiResponse: HttpInfo<InfluenceResumeDTO>) => apiResponse.data));
    }

}

import { InfluencePlatformApiRequestFactory, InfluencePlatformApiResponseProcessor} from "../apis/InfluencePlatformApi";
export class ObservableInfluencePlatformApi {
    private requestFactory: InfluencePlatformApiRequestFactory;
    private responseProcessor: InfluencePlatformApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: InfluencePlatformApiRequestFactory,
        responseProcessor?: InfluencePlatformApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new InfluencePlatformApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new InfluencePlatformApiResponseProcessor();
    }

    /**
     * Returns a set of platform, according to the given limit, page number and search query.
     * @param page Page.
     * @param limit Amount of items to take.
     * @param [lang] Specific language code for query.
     * @param [search] Search string to filter items.
     */
    public paginate0WithHttpInfo(page: number, limit: number, lang?: 'en' | 'ru' | 'uk', search?: string, _options?: ConfigurationOptions): Observable<HttpInfo<InfluencePlatformControllerPaginate0200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.paginate0(page, limit, lang, search, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.paginate0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns a set of platform, according to the given limit, page number and search query.
     * @param page Page.
     * @param limit Amount of items to take.
     * @param [lang] Specific language code for query.
     * @param [search] Search string to filter items.
     */
    public paginate0(page: number, limit: number, lang?: 'en' | 'ru' | 'uk', search?: string, _options?: ConfigurationOptions): Observable<InfluencePlatformControllerPaginate0200Response> {
        return this.paginate0WithHttpInfo(page, limit, lang, search, _options).pipe(map((apiResponse: HttpInfo<InfluencePlatformControllerPaginate0200Response>) => apiResponse.data));
    }

}

import { InfluenceResumeApiRequestFactory, InfluenceResumeApiResponseProcessor} from "../apis/InfluenceResumeApi";
export class ObservableInfluenceResumeApi {
    private requestFactory: InfluenceResumeApiRequestFactory;
    private responseProcessor: InfluenceResumeApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: InfluenceResumeApiRequestFactory,
        responseProcessor?: InfluenceResumeApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new InfluenceResumeApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new InfluenceResumeApiResponseProcessor();
    }

    /**
     * Creates new resume.
     * @param [lang] Specific language code for query.
     * @param [avatar] File to upload
     */
    public create0WithHttpInfo(lang?: 'en' | 'ru' | 'uk', avatar?: HttpFile, _options?: ConfigurationOptions): Observable<HttpInfo<InfluenceResumeDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.create0(lang, avatar, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.create0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Creates new resume.
     * @param [lang] Specific language code for query.
     * @param [avatar] File to upload
     */
    public create0(lang?: 'en' | 'ru' | 'uk', avatar?: HttpFile, _options?: ConfigurationOptions): Observable<InfluenceResumeDTO> {
        return this.create0WithHttpInfo(lang, avatar, _options).pipe(map((apiResponse: HttpInfo<InfluenceResumeDTO>) => apiResponse.data));
    }

    /**
     * Deletes resume, according to the given unique id query.
     * @param resumeId Unique id of resume to find.
     * @param [lang] Specific language code for query.
     */
    public destroy0WithHttpInfo(resumeId: number, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.destroy0(resumeId, lang, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.destroy0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Deletes resume, according to the given unique id query.
     * @param resumeId Unique id of resume to find.
     * @param [lang] Specific language code for query.
     */
    public destroy0(resumeId: number, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<void> {
        return this.destroy0WithHttpInfo(resumeId, lang, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Deletes channel.
     * @param resumeId Unique id of resume to find.
     * @param influenceResumeChannelDestroyDTO
     * @param [lang] Specific language code for query.
     */
    public destroy0_1WithHttpInfo(resumeId: number, influenceResumeChannelDestroyDTO: Array<InfluenceResumeChannelDestroyDTO>, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<HttpInfo<InfluenceResumeDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.destroy0_1(resumeId, influenceResumeChannelDestroyDTO, lang, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.destroy0_1WithHttpInfo(rsp)));
            }));
    }

    /**
     * Deletes channel.
     * @param resumeId Unique id of resume to find.
     * @param influenceResumeChannelDestroyDTO
     * @param [lang] Specific language code for query.
     */
    public destroy0_1(resumeId: number, influenceResumeChannelDestroyDTO: Array<InfluenceResumeChannelDestroyDTO>, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<InfluenceResumeDTO> {
        return this.destroy0_1WithHttpInfo(resumeId, influenceResumeChannelDestroyDTO, lang, _options).pipe(map((apiResponse: HttpInfo<InfluenceResumeDTO>) => apiResponse.data));
    }

    /**
     * Deletes price.
     * @param resumeId Unique id of resume to find.
     * @param influenceResumeChannelPriceDestroyDTO
     * @param [lang] Specific language code for query.
     */
    public destroy0_2WithHttpInfo(resumeId: number, influenceResumeChannelPriceDestroyDTO: Array<InfluenceResumeChannelPriceDestroyDTO>, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<HttpInfo<InfluenceResumeDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.destroy0_2(resumeId, influenceResumeChannelPriceDestroyDTO, lang, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.destroy0_2WithHttpInfo(rsp)));
            }));
    }

    /**
     * Deletes price.
     * @param resumeId Unique id of resume to find.
     * @param influenceResumeChannelPriceDestroyDTO
     * @param [lang] Specific language code for query.
     */
    public destroy0_2(resumeId: number, influenceResumeChannelPriceDestroyDTO: Array<InfluenceResumeChannelPriceDestroyDTO>, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<InfluenceResumeDTO> {
        return this.destroy0_2WithHttpInfo(resumeId, influenceResumeChannelPriceDestroyDTO, lang, _options).pipe(map((apiResponse: HttpInfo<InfluenceResumeDTO>) => apiResponse.data));
    }

    /**
     * Returns resume, according to the given unique id query.
     * @param resumeId Unique id of resume to find.
     * @param [lang] Specific language code for query.
     */
    public findById0WithHttpInfo(resumeId: number, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<HttpInfo<InfluenceResumeDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findById0(resumeId, lang, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findById0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns resume, according to the given unique id query.
     * @param resumeId Unique id of resume to find.
     * @param [lang] Specific language code for query.
     */
    public findById0(resumeId: number, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<InfluenceResumeDTO> {
        return this.findById0WithHttpInfo(resumeId, lang, _options).pipe(map((apiResponse: HttpInfo<InfluenceResumeDTO>) => apiResponse.data));
    }

    /**
     * Returns a set of resume, according to the given limit and page number query.
     * @param page Page.
     * @param limit Amount of items to take.
     * @param [lang] Specific language code for query.
     * @param [search] Search string to filter items.
     * @param [self] Returns only owned resumes.
     * @param [favourite] Returns only favourite resumes.
     */
    public paginate0WithHttpInfo(page: number, limit: number, lang?: 'en' | 'ru' | 'uk', search?: string, self?: boolean, favourite?: boolean, _options?: ConfigurationOptions): Observable<HttpInfo<InfluenceResumePaginateControllerPaginate0200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.paginate0(page, limit, lang, search, self, favourite, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.paginate0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns a set of resume, according to the given limit and page number query.
     * @param page Page.
     * @param limit Amount of items to take.
     * @param [lang] Specific language code for query.
     * @param [search] Search string to filter items.
     * @param [self] Returns only owned resumes.
     * @param [favourite] Returns only favourite resumes.
     */
    public paginate0(page: number, limit: number, lang?: 'en' | 'ru' | 'uk', search?: string, self?: boolean, favourite?: boolean, _options?: ConfigurationOptions): Observable<InfluenceResumePaginateControllerPaginate0200Response> {
        return this.paginate0WithHttpInfo(page, limit, lang, search, self, favourite, _options).pipe(map((apiResponse: HttpInfo<InfluenceResumePaginateControllerPaginate0200Response>) => apiResponse.data));
    }

    /**
     * Updates resume, according to the given unique id query.
     * @param resumeId Unique id of resume to find.
     * @param [lang] Specific language code for query.
     * @param [avatar] File to upload
     */
    public update0WithHttpInfo(resumeId: number, lang?: 'en' | 'ru' | 'uk', avatar?: HttpFile, _options?: ConfigurationOptions): Observable<HttpInfo<InfluenceResumeDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.update0(resumeId, lang, avatar, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.update0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Updates resume, according to the given unique id query.
     * @param resumeId Unique id of resume to find.
     * @param [lang] Specific language code for query.
     * @param [avatar] File to upload
     */
    public update0(resumeId: number, lang?: 'en' | 'ru' | 'uk', avatar?: HttpFile, _options?: ConfigurationOptions): Observable<InfluenceResumeDTO> {
        return this.update0WithHttpInfo(resumeId, lang, avatar, _options).pipe(map((apiResponse: HttpInfo<InfluenceResumeDTO>) => apiResponse.data));
    }

    /**
     * Creates or updates channel.
     * @param resumeId Unique id of resume to find.
     * @param influenceResumeChannelMutableDTO
     * @param [lang] Specific language code for query.
     */
    public update0_3WithHttpInfo(resumeId: number, influenceResumeChannelMutableDTO: Array<InfluenceResumeChannelMutableDTO>, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<HttpInfo<InfluenceResumeDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.update0_3(resumeId, influenceResumeChannelMutableDTO, lang, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.update0_3WithHttpInfo(rsp)));
            }));
    }

    /**
     * Creates or updates channel.
     * @param resumeId Unique id of resume to find.
     * @param influenceResumeChannelMutableDTO
     * @param [lang] Specific language code for query.
     */
    public update0_3(resumeId: number, influenceResumeChannelMutableDTO: Array<InfluenceResumeChannelMutableDTO>, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<InfluenceResumeDTO> {
        return this.update0_3WithHttpInfo(resumeId, influenceResumeChannelMutableDTO, lang, _options).pipe(map((apiResponse: HttpInfo<InfluenceResumeDTO>) => apiResponse.data));
    }

    /**
     * Creates or updates price.
     * @param resumeId Unique id of resume to find.
     * @param influenceResumeChannelPriceMutableDTO
     * @param [lang] Specific language code for query.
     */
    public update0_4WithHttpInfo(resumeId: number, influenceResumeChannelPriceMutableDTO: Array<InfluenceResumeChannelPriceMutableDTO>, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<HttpInfo<InfluenceResumeDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.update0_4(resumeId, influenceResumeChannelPriceMutableDTO, lang, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.update0_4WithHttpInfo(rsp)));
            }));
    }

    /**
     * Creates or updates price.
     * @param resumeId Unique id of resume to find.
     * @param influenceResumeChannelPriceMutableDTO
     * @param [lang] Specific language code for query.
     */
    public update0_4(resumeId: number, influenceResumeChannelPriceMutableDTO: Array<InfluenceResumeChannelPriceMutableDTO>, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<InfluenceResumeDTO> {
        return this.update0_4WithHttpInfo(resumeId, influenceResumeChannelPriceMutableDTO, lang, _options).pipe(map((apiResponse: HttpInfo<InfluenceResumeDTO>) => apiResponse.data));
    }

}

import { LocationApiRequestFactory, LocationApiResponseProcessor} from "../apis/LocationApi";
export class ObservableLocationApi {
    private requestFactory: LocationApiRequestFactory;
    private responseProcessor: LocationApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: LocationApiRequestFactory,
        responseProcessor?: LocationApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new LocationApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new LocationApiResponseProcessor();
    }

    /**
     */
    public findAll0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findAll0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findAll0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public findAll0(_options?: ConfigurationOptions): Observable<void> {
        return this.findAll0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param geonameid
     * @param lang
     */
    public findById0WithHttpInfo(geonameid: number, lang: string, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findById0(geonameid, lang, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findById0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param geonameid
     * @param lang
     */
    public findById0(geonameid: number, lang: string, _options?: ConfigurationOptions): Observable<any> {
        return this.findById0WithHttpInfo(geonameid, lang, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     */
    public findCountries0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findCountries0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findCountries0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public findCountries0(_options?: ConfigurationOptions): Observable<Array<any>> {
        return this.findCountries0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

}

import { ManagerApiRequestFactory, ManagerApiResponseProcessor} from "../apis/ManagerApi";
export class ObservableManagerApi {
    private requestFactory: ManagerApiRequestFactory;
    private responseProcessor: ManagerApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ManagerApiRequestFactory,
        responseProcessor?: ManagerApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ManagerApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ManagerApiResponseProcessor();
    }

    /**
     * @param managerCreateDTO
     */
    public create0WithHttpInfo(managerCreateDTO: ManagerCreateDTO, _options?: ConfigurationOptions): Observable<HttpInfo<ProfileResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.create0(managerCreateDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.create0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param managerCreateDTO
     */
    public create0(managerCreateDTO: ManagerCreateDTO, _options?: ConfigurationOptions): Observable<ProfileResponseDTO> {
        return this.create0WithHttpInfo(managerCreateDTO, _options).pipe(map((apiResponse: HttpInfo<ProfileResponseDTO>) => apiResponse.data));
    }

    /**
     * @param profileId
     */
    public destroy0WithHttpInfo(profileId: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.destroy0(profileId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.destroy0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param profileId
     */
    public destroy0(profileId: number, _options?: ConfigurationOptions): Observable<void> {
        return this.destroy0WithHttpInfo(profileId, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param limit Items count.
     * @param page Page number.
     * @param lang Preferred language.
     */
    public list0WithHttpInfo(limit: number, page: number, lang: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu', _options?: ConfigurationOptions): Observable<HttpInfo<ManagerResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.list0(limit, page, lang, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.list0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param limit Items count.
     * @param page Page number.
     * @param lang Preferred language.
     */
    public list0(limit: number, page: number, lang: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu', _options?: ConfigurationOptions): Observable<ManagerResponseDTO> {
        return this.list0WithHttpInfo(limit, page, lang, _options).pipe(map((apiResponse: HttpInfo<ManagerResponseDTO>) => apiResponse.data));
    }

    /**
     * @param profileId
     * @param managerUpdateDTO
     */
    public updatePost0WithHttpInfo(profileId: number, managerUpdateDTO: ManagerUpdateDTO, _options?: ConfigurationOptions): Observable<HttpInfo<ProfileResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updatePost0(profileId, managerUpdateDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updatePost0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param profileId
     * @param managerUpdateDTO
     */
    public updatePost0(profileId: number, managerUpdateDTO: ManagerUpdateDTO, _options?: ConfigurationOptions): Observable<ProfileResponseDTO> {
        return this.updatePost0WithHttpInfo(profileId, managerUpdateDTO, _options).pipe(map((apiResponse: HttpInfo<ProfileResponseDTO>) => apiResponse.data));
    }

    /**
     * @param profileId
     * @param managerUpdateDTO
     */
    public updatePut0WithHttpInfo(profileId: number, managerUpdateDTO: ManagerUpdateDTO, _options?: ConfigurationOptions): Observable<HttpInfo<ProfileResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updatePut0(profileId, managerUpdateDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updatePut0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param profileId
     * @param managerUpdateDTO
     */
    public updatePut0(profileId: number, managerUpdateDTO: ManagerUpdateDTO, _options?: ConfigurationOptions): Observable<ProfileResponseDTO> {
        return this.updatePut0WithHttpInfo(profileId, managerUpdateDTO, _options).pipe(map((apiResponse: HttpInfo<ProfileResponseDTO>) => apiResponse.data));
    }

}

import { NotificationCategorySettingsApiRequestFactory, NotificationCategorySettingsApiResponseProcessor} from "../apis/NotificationCategorySettingsApi";
export class ObservableNotificationCategorySettingsApi {
    private requestFactory: NotificationCategorySettingsApiRequestFactory;
    private responseProcessor: NotificationCategorySettingsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: NotificationCategorySettingsApiRequestFactory,
        responseProcessor?: NotificationCategorySettingsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new NotificationCategorySettingsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new NotificationCategorySettingsApiResponseProcessor();
    }

    /**
     * Enables notification category.
     * @param notificationProfileCategorySettingsDTO
     */
    public disable0WithHttpInfo(notificationProfileCategorySettingsDTO: NotificationProfileCategorySettingsDTO, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.disable0(notificationProfileCategorySettingsDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.disable0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Enables notification category.
     * @param notificationProfileCategorySettingsDTO
     */
    public disable0(notificationProfileCategorySettingsDTO: NotificationProfileCategorySettingsDTO, _options?: ConfigurationOptions): Observable<void> {
        return this.disable0WithHttpInfo(notificationProfileCategorySettingsDTO, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Disables notification category.
     * @param notificationProfileCategorySettingsDTO
     */
    public disable0_1WithHttpInfo(notificationProfileCategorySettingsDTO: NotificationProfileCategorySettingsDTO, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.disable0_1(notificationProfileCategorySettingsDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.disable0_1WithHttpInfo(rsp)));
            }));
    }

    /**
     * Disables notification category.
     * @param notificationProfileCategorySettingsDTO
     */
    public disable0_1(notificationProfileCategorySettingsDTO: NotificationProfileCategorySettingsDTO, _options?: ConfigurationOptions): Observable<void> {
        return this.disable0_1WithHttpInfo(notificationProfileCategorySettingsDTO, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Returns array of current categories status.
     */
    public findAllCategories0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<NotificationProfileCategoryDTO>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findAllCategories0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findAllCategories0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns array of current categories status.
     */
    public findAllCategories0(_options?: ConfigurationOptions): Observable<Array<NotificationProfileCategoryDTO>> {
        return this.findAllCategories0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<NotificationProfileCategoryDTO>>) => apiResponse.data));
    }

}

import { NotificationProviderSettingsApiRequestFactory, NotificationProviderSettingsApiResponseProcessor} from "../apis/NotificationProviderSettingsApi";
export class ObservableNotificationProviderSettingsApi {
    private requestFactory: NotificationProviderSettingsApiRequestFactory;
    private responseProcessor: NotificationProviderSettingsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: NotificationProviderSettingsApiRequestFactory,
        responseProcessor?: NotificationProviderSettingsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new NotificationProviderSettingsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new NotificationProviderSettingsApiResponseProcessor();
    }

    /**
     * Enables notification provider.
     * @param notificationProfileProviderSettingsDTO
     */
    public disable0WithHttpInfo(notificationProfileProviderSettingsDTO: NotificationProfileProviderSettingsDTO, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.disable0(notificationProfileProviderSettingsDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.disable0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Enables notification provider.
     * @param notificationProfileProviderSettingsDTO
     */
    public disable0(notificationProfileProviderSettingsDTO: NotificationProfileProviderSettingsDTO, _options?: ConfigurationOptions): Observable<void> {
        return this.disable0WithHttpInfo(notificationProfileProviderSettingsDTO, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Disables notification provider.
     * @param notificationProfileProviderSettingsDTO
     */
    public disable0_1WithHttpInfo(notificationProfileProviderSettingsDTO: NotificationProfileProviderSettingsDTO, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.disable0_1(notificationProfileProviderSettingsDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.disable0_1WithHttpInfo(rsp)));
            }));
    }

    /**
     * Disables notification provider.
     * @param notificationProfileProviderSettingsDTO
     */
    public disable0_1(notificationProfileProviderSettingsDTO: NotificationProfileProviderSettingsDTO, _options?: ConfigurationOptions): Observable<void> {
        return this.disable0_1WithHttpInfo(notificationProfileProviderSettingsDTO, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Returns array of current providers status.
     */
    public findAllCategories0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<NotificationProfileProviderDTO>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findAllCategories0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findAllCategories0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns array of current providers status.
     */
    public findAllCategories0(_options?: ConfigurationOptions): Observable<Array<NotificationProfileProviderDTO>> {
        return this.findAllCategories0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<NotificationProfileProviderDTO>>) => apiResponse.data));
    }

}

import { NotificationProvidersApiRequestFactory, NotificationProvidersApiResponseProcessor} from "../apis/NotificationProvidersApi";
export class ObservableNotificationProvidersApi {
    private requestFactory: NotificationProvidersApiRequestFactory;
    private responseProcessor: NotificationProvidersApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: NotificationProvidersApiRequestFactory,
        responseProcessor?: NotificationProvidersApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new NotificationProvidersApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new NotificationProvidersApiResponseProcessor();
    }

    /**
     * Returns all available providers
     */
    public findAll0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findAll0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findAll0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns all available providers
     */
    public findAll0(_options?: ConfigurationOptions): Observable<Array<any>> {
        return this.findAll0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Generate new link for telegram.
     */
    public generate0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<NotificationProfileProviderGenerateDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.generate0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.generate0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Generate new link for telegram.
     */
    public generate0(_options?: ConfigurationOptions): Observable<NotificationProfileProviderGenerateDTO> {
        return this.generate0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<NotificationProfileProviderGenerateDTO>) => apiResponse.data));
    }

    /**
     * Remove linking to provider.
     * @param notificationProfileProviderUnLinkDTO
     */
    public unLink0WithHttpInfo(notificationProfileProviderUnLinkDTO: NotificationProfileProviderUnLinkDTO, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.unLink0(notificationProfileProviderUnLinkDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.unLink0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Remove linking to provider.
     * @param notificationProfileProviderUnLinkDTO
     */
    public unLink0(notificationProfileProviderUnLinkDTO: NotificationProfileProviderUnLinkDTO, _options?: ConfigurationOptions): Observable<void> {
        return this.unLink0WithHttpInfo(notificationProfileProviderUnLinkDTO, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

}

import { NotificationUserApiRequestFactory, NotificationUserApiResponseProcessor} from "../apis/NotificationUserApi";
export class ObservableNotificationUserApi {
    private requestFactory: NotificationUserApiRequestFactory;
    private responseProcessor: NotificationUserApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: NotificationUserApiRequestFactory,
        responseProcessor?: NotificationUserApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new NotificationUserApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new NotificationUserApiResponseProcessor();
    }

    /**
     * Returns paginated notifications.
     */
    public findAll0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<NotificationProfileRootDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findAll0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findAll0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns paginated notifications.
     */
    public findAll0(_options?: ConfigurationOptions): Observable<NotificationProfileRootDTO> {
        return this.findAll0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<NotificationProfileRootDTO>) => apiResponse.data));
    }

    /**
     * Reads notifications by notification ids.
     * @param notificationProfileReadDTO
     */
    public read0WithHttpInfo(notificationProfileReadDTO: NotificationProfileReadDTO, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.read0(notificationProfileReadDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.read0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Reads notifications by notification ids.
     * @param notificationProfileReadDTO
     */
    public read0(notificationProfileReadDTO: NotificationProfileReadDTO, _options?: ConfigurationOptions): Observable<void> {
        return this.read0WithHttpInfo(notificationProfileReadDTO, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Returns notification stats.
     */
    public stats0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<NotificationProfileRootDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.stats0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.stats0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns notification stats.
     */
    public stats0(_options?: ConfigurationOptions): Observable<NotificationProfileRootDTO> {
        return this.stats0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<NotificationProfileRootDTO>) => apiResponse.data));
    }

}

import { OrderApiRequestFactory, OrderApiResponseProcessor} from "../apis/OrderApi";
export class ObservableOrderApi {
    private requestFactory: OrderApiRequestFactory;
    private responseProcessor: OrderApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: OrderApiRequestFactory,
        responseProcessor?: OrderApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new OrderApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new OrderApiResponseProcessor();
    }

    /**
     * Returns an order that can be used with requested features
     * @param locale
     */
    public canUseProduct0WithHttpInfo(locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu', _options?: ConfigurationOptions): Observable<HttpInfo<OrderEntity | void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.canUseProduct0(locale, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.canUseProduct0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns an order that can be used with requested features
     * @param locale
     */
    public canUseProduct0(locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu', _options?: ConfigurationOptions): Observable<OrderEntity | void> {
        return this.canUseProduct0WithHttpInfo(locale, _options).pipe(map((apiResponse: HttpInfo<OrderEntity | void>) => apiResponse.data));
    }

    /**
     * @param productId
     */
    public checkCanUseProduct0WithHttpInfo(productId: number, _options?: ConfigurationOptions): Observable<HttpInfo<OrderEntity>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.checkCanUseProduct0(productId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.checkCanUseProduct0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param productId
     */
    public checkCanUseProduct0(productId: number, _options?: ConfigurationOptions): Observable<OrderEntity> {
        return this.checkCanUseProduct0WithHttpInfo(productId, _options).pipe(map((apiResponse: HttpInfo<OrderEntity>) => apiResponse.data));
    }

    /**
     * Creates order
     * @param locale
     * @param id
     * @param createOrderQueryDto
     */
    public createOrder0WithHttpInfo(locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu', id: number, createOrderQueryDto: CreateOrderQueryDto, _options?: ConfigurationOptions): Observable<HttpInfo<OrderEntity | any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOrder0(locale, id, createOrderQueryDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOrder0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Creates order
     * @param locale
     * @param id
     * @param createOrderQueryDto
     */
    public createOrder0(locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu', id: number, createOrderQueryDto: CreateOrderQueryDto, _options?: ConfigurationOptions): Observable<OrderEntity | any> {
        return this.createOrder0WithHttpInfo(locale, id, createOrderQueryDto, _options).pipe(map((apiResponse: HttpInfo<OrderEntity | any>) => apiResponse.data));
    }

    /**
     * Returns an array of owned orders
     * @param locale
     * @param [cvId]
     */
    public findAllOrdersOwned0WithHttpInfo(locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu', cvId?: number, _options?: ConfigurationOptions): Observable<HttpInfo<Array<OrderEntity>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findAllOrdersOwned0(locale, cvId, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findAllOrdersOwned0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns an array of owned orders
     * @param locale
     * @param [cvId]
     */
    public findAllOrdersOwned0(locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu', cvId?: number, _options?: ConfigurationOptions): Observable<Array<OrderEntity>> {
        return this.findAllOrdersOwned0WithHttpInfo(locale, cvId, _options).pipe(map((apiResponse: HttpInfo<Array<OrderEntity>>) => apiResponse.data));
    }

}

import { OrderTransactionApiRequestFactory, OrderTransactionApiResponseProcessor} from "../apis/OrderTransactionApi";
export class ObservableOrderTransactionApi {
    private requestFactory: OrderTransactionApiRequestFactory;
    private responseProcessor: OrderTransactionApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: OrderTransactionApiRequestFactory,
        responseProcessor?: OrderTransactionApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new OrderTransactionApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new OrderTransactionApiResponseProcessor();
    }

    /**
     * Returns an array of all transactions by owner type and id.
     * @param id
     * @param type
     */
    public findAllTransactions0WithHttpInfo(id: number, type: 'employee' | 'hirer' | 'unknown', _options?: ConfigurationOptions): Observable<HttpInfo<Array<OrderTransactionEntity>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findAllTransactions0(id, type, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findAllTransactions0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns an array of all transactions by owner type and id.
     * @param id
     * @param type
     */
    public findAllTransactions0(id: number, type: 'employee' | 'hirer' | 'unknown', _options?: ConfigurationOptions): Observable<Array<OrderTransactionEntity>> {
        return this.findAllTransactions0WithHttpInfo(id, type, _options).pipe(map((apiResponse: HttpInfo<Array<OrderTransactionEntity>>) => apiResponse.data));
    }

}

import { PageApiRequestFactory, PageApiResponseProcessor} from "../apis/PageApi";
export class ObservablePageApi {
    private requestFactory: PageApiRequestFactory;
    private responseProcessor: PageApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: PageApiRequestFactory,
        responseProcessor?: PageApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new PageApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new PageApiResponseProcessor();
    }

    /**
     * Retrieve multiple PageHTMLBlocks
     * @param language
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBasePageControllerPageHTMLBlockWithHttpInfo(language: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBasePageControllerPageHTMLBlock(language, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBasePageControllerPageHTMLBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple PageHTMLBlocks
     * @param language
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBasePageControllerPageHTMLBlock(language: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBasePageControllerPageHTMLBlockWithHttpInfo(language, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single PageHTMLBlock
     * @param language
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBasePageControllerPageHTMLBlockWithHttpInfo(language: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBasePageControllerPageHTMLBlock(language, id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBasePageControllerPageHTMLBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single PageHTMLBlock
     * @param language
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBasePageControllerPageHTMLBlock(language: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBasePageControllerPageHTMLBlockWithHttpInfo(language, id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { PageJsonBlockApiRequestFactory, PageJsonBlockApiResponseProcessor} from "../apis/PageJsonBlockApi";
export class ObservablePageJsonBlockApi {
    private requestFactory: PageJsonBlockApiRequestFactory;
    private responseProcessor: PageJsonBlockApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: PageJsonBlockApiRequestFactory,
        responseProcessor?: PageJsonBlockApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new PageJsonBlockApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new PageJsonBlockApiResponseProcessor();
    }

    /**
     * Create a new page JSON block
     * @param createPageJsonBlockDto
     */
    public create0WithHttpInfo(createPageJsonBlockDto: CreatePageJsonBlockDto, _options?: ConfigurationOptions): Observable<HttpInfo<PageJsonBlock>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.create0(createPageJsonBlockDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.create0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a new page JSON block
     * @param createPageJsonBlockDto
     */
    public create0(createPageJsonBlockDto: CreatePageJsonBlockDto, _options?: ConfigurationOptions): Observable<PageJsonBlock> {
        return this.create0WithHttpInfo(createPageJsonBlockDto, _options).pipe(map((apiResponse: HttpInfo<PageJsonBlock>) => apiResponse.data));
    }

    /**
     * Delete a page JSON block by key
     * @param key
     */
    public delete0WithHttpInfo(key: string, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.delete0(key, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.delete0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a page JSON block by key
     * @param key
     */
    public delete0(key: string, _options?: ConfigurationOptions): Observable<void> {
        return this.delete0WithHttpInfo(key, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Get a page JSON block by key
     * @param key
     */
    public getByKey0WithHttpInfo(key: string, _options?: ConfigurationOptions): Observable<HttpInfo<PageJsonBlock>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getByKey0(key, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getByKey0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Get a page JSON block by key
     * @param key
     */
    public getByKey0(key: string, _options?: ConfigurationOptions): Observable<PageJsonBlock> {
        return this.getByKey0WithHttpInfo(key, _options).pipe(map((apiResponse: HttpInfo<PageJsonBlock>) => apiResponse.data));
    }

    /**
     * Update an existing page JSON block by key
     * @param key
     * @param updatePageJsonBlockDto
     */
    public update0WithHttpInfo(key: string, updatePageJsonBlockDto: UpdatePageJsonBlockDto, _options?: ConfigurationOptions): Observable<HttpInfo<PageJsonBlock>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.update0(key, updatePageJsonBlockDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.update0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Update an existing page JSON block by key
     * @param key
     * @param updatePageJsonBlockDto
     */
    public update0(key: string, updatePageJsonBlockDto: UpdatePageJsonBlockDto, _options?: ConfigurationOptions): Observable<PageJsonBlock> {
        return this.update0WithHttpInfo(key, updatePageJsonBlockDto, _options).pipe(map((apiResponse: HttpInfo<PageJsonBlock>) => apiResponse.data));
    }

}

import { PageJsonBlockTranslationApiRequestFactory, PageJsonBlockTranslationApiResponseProcessor} from "../apis/PageJsonBlockTranslationApi";
export class ObservablePageJsonBlockTranslationApi {
    private requestFactory: PageJsonBlockTranslationApiRequestFactory;
    private responseProcessor: PageJsonBlockTranslationApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: PageJsonBlockTranslationApiRequestFactory,
        responseProcessor?: PageJsonBlockTranslationApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new PageJsonBlockTranslationApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new PageJsonBlockTranslationApiResponseProcessor();
    }

    /**
     * Create a new translation for a page JSON block
     * @param key
     * @param createPageJsonBlockTranslationDto
     */
    public create0WithHttpInfo(key: string, createPageJsonBlockTranslationDto: CreatePageJsonBlockTranslationDto, _options?: ConfigurationOptions): Observable<HttpInfo<PageJsonBlockTranslation>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.create0(key, createPageJsonBlockTranslationDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.create0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a new translation for a page JSON block
     * @param key
     * @param createPageJsonBlockTranslationDto
     */
    public create0(key: string, createPageJsonBlockTranslationDto: CreatePageJsonBlockTranslationDto, _options?: ConfigurationOptions): Observable<PageJsonBlockTranslation> {
        return this.create0WithHttpInfo(key, createPageJsonBlockTranslationDto, _options).pipe(map((apiResponse: HttpInfo<PageJsonBlockTranslation>) => apiResponse.data));
    }

}

import { PaymentMethodApiRequestFactory, PaymentMethodApiResponseProcessor} from "../apis/PaymentMethodApi";
export class ObservablePaymentMethodApi {
    private requestFactory: PaymentMethodApiRequestFactory;
    private responseProcessor: PaymentMethodApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: PaymentMethodApiRequestFactory,
        responseProcessor?: PaymentMethodApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new PaymentMethodApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new PaymentMethodApiResponseProcessor();
    }

    /**
     * @param getPaymentMethodsRequestDto
     */
    public getPaymentMethods0WithHttpInfo(getPaymentMethodsRequestDto: GetPaymentMethodsRequestDto, _options?: ConfigurationOptions): Observable<HttpInfo<GetPaymentMethodsResponseDto>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getPaymentMethods0(getPaymentMethodsRequestDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getPaymentMethods0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param getPaymentMethodsRequestDto
     */
    public getPaymentMethods0(getPaymentMethodsRequestDto: GetPaymentMethodsRequestDto, _options?: ConfigurationOptions): Observable<GetPaymentMethodsResponseDto> {
        return this.getPaymentMethods0WithHttpInfo(getPaymentMethodsRequestDto, _options).pipe(map((apiResponse: HttpInfo<GetPaymentMethodsResponseDto>) => apiResponse.data));
    }

}

import { PaymentPassimPayCallbackApiRequestFactory, PaymentPassimPayCallbackApiResponseProcessor} from "../apis/PaymentPassimPayCallbackApi";
export class ObservablePaymentPassimPayCallbackApi {
    private requestFactory: PaymentPassimPayCallbackApiRequestFactory;
    private responseProcessor: PaymentPassimPayCallbackApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: PaymentPassimPayCallbackApiRequestFactory,
        responseProcessor?: PaymentPassimPayCallbackApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new PaymentPassimPayCallbackApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new PaymentPassimPayCallbackApiResponseProcessor();
    }

    /**
     * PassimPay callback
     */
    public callback0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<CallbackResponseDto>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.callback0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.callback0WithHttpInfo(rsp)));
            }));
    }

    /**
     * PassimPay callback
     */
    public callback0(_options?: ConfigurationOptions): Observable<CallbackResponseDto> {
        return this.callback0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<CallbackResponseDto>) => apiResponse.data));
    }

}

import { PaymentPassimPayDepositApiRequestFactory, PaymentPassimPayDepositApiResponseProcessor} from "../apis/PaymentPassimPayDepositApi";
export class ObservablePaymentPassimPayDepositApi {
    private requestFactory: PaymentPassimPayDepositApiRequestFactory;
    private responseProcessor: PaymentPassimPayDepositApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: PaymentPassimPayDepositApiRequestFactory,
        responseProcessor?: PaymentPassimPayDepositApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new PaymentPassimPayDepositApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new PaymentPassimPayDepositApiResponseProcessor();
    }

    /**
     * @param createDepositPassimPayRequestDto
     */
    public createDeposit0WithHttpInfo(createDepositPassimPayRequestDto: CreateDepositPassimPayRequestDto, _options?: ConfigurationOptions): Observable<HttpInfo<CreatePassimPayDepositResponseDto>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createDeposit0(createDepositPassimPayRequestDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createDeposit0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param createDepositPassimPayRequestDto
     */
    public createDeposit0(createDepositPassimPayRequestDto: CreateDepositPassimPayRequestDto, _options?: ConfigurationOptions): Observable<CreatePassimPayDepositResponseDto> {
        return this.createDeposit0WithHttpInfo(createDepositPassimPayRequestDto, _options).pipe(map((apiResponse: HttpInfo<CreatePassimPayDepositResponseDto>) => apiResponse.data));
    }

}

import { PaymentPassimPayGetLinkApiRequestFactory, PaymentPassimPayGetLinkApiResponseProcessor} from "../apis/PaymentPassimPayGetLinkApi";
export class ObservablePaymentPassimPayGetLinkApi {
    private requestFactory: PaymentPassimPayGetLinkApiRequestFactory;
    private responseProcessor: PaymentPassimPayGetLinkApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: PaymentPassimPayGetLinkApiRequestFactory,
        responseProcessor?: PaymentPassimPayGetLinkApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new PaymentPassimPayGetLinkApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new PaymentPassimPayGetLinkApiResponseProcessor();
    }

    /**
     * Get link an deposit
     * @param orderIds
     */
    public getLink0WithHttpInfo(orderIds: Array<number>, _options?: ConfigurationOptions): Observable<HttpInfo<GetDepositLinkResponseDto>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getLink0(orderIds, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getLink0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Get link an deposit
     * @param orderIds
     */
    public getLink0(orderIds: Array<number>, _options?: ConfigurationOptions): Observable<GetDepositLinkResponseDto> {
        return this.getLink0WithHttpInfo(orderIds, _options).pipe(map((apiResponse: HttpInfo<GetDepositLinkResponseDto>) => apiResponse.data));
    }

}

import { PaymentPassimPayTestDepositApiRequestFactory, PaymentPassimPayTestDepositApiResponseProcessor} from "../apis/PaymentPassimPayTestDepositApi";
export class ObservablePaymentPassimPayTestDepositApi {
    private requestFactory: PaymentPassimPayTestDepositApiRequestFactory;
    private responseProcessor: PaymentPassimPayTestDepositApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: PaymentPassimPayTestDepositApiRequestFactory,
        responseProcessor?: PaymentPassimPayTestDepositApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new PaymentPassimPayTestDepositApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new PaymentPassimPayTestDepositApiResponseProcessor();
    }

    /**
     * Create deposit link method
     * @param createTestDepositPassimPayRequestDto
     */
    public createTestDeposit0WithHttpInfo(createTestDepositPassimPayRequestDto: CreateTestDepositPassimPayRequestDto, _options?: ConfigurationOptions): Observable<HttpInfo<CreatePassimPayTestDepositResponseDto>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createTestDeposit0(createTestDepositPassimPayRequestDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createTestDeposit0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Create deposit link method
     * @param createTestDepositPassimPayRequestDto
     */
    public createTestDeposit0(createTestDepositPassimPayRequestDto: CreateTestDepositPassimPayRequestDto, _options?: ConfigurationOptions): Observable<CreatePassimPayTestDepositResponseDto> {
        return this.createTestDeposit0WithHttpInfo(createTestDepositPassimPayRequestDto, _options).pipe(map((apiResponse: HttpInfo<CreatePassimPayTestDepositResponseDto>) => apiResponse.data));
    }

}

import { PersonalPageApiRequestFactory, PersonalPageApiResponseProcessor} from "../apis/PersonalPageApi";
export class ObservablePersonalPageApi {
    private requestFactory: PersonalPageApiRequestFactory;
    private responseProcessor: PersonalPageApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: PersonalPageApiRequestFactory,
        responseProcessor?: PersonalPageApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new PersonalPageApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new PersonalPageApiResponseProcessor();
    }

    /**
     * Create a single PersonalPage
     * @param body
     */
    public createOneBasePersonalPageControllerPersonalPageWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBasePersonalPageControllerPersonalPage(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBasePersonalPageControllerPersonalPageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single PersonalPage
     * @param body
     */
    public createOneBasePersonalPageControllerPersonalPage(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBasePersonalPageControllerPersonalPageWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single PersonalPage
     * @param id
     */
    public deleteOneBasePersonalPageControllerPersonalPageWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBasePersonalPageControllerPersonalPage(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBasePersonalPageControllerPersonalPageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single PersonalPage
     * @param id
     */
    public deleteOneBasePersonalPageControllerPersonalPage(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.deleteOneBasePersonalPageControllerPersonalPageWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple PersonalPages
     * @param profileId
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBasePersonalPageControllerPersonalPageWithHttpInfo(profileId: number, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBasePersonalPageControllerPersonalPage(profileId, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBasePersonalPageControllerPersonalPageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple PersonalPages
     * @param profileId
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBasePersonalPageControllerPersonalPage(profileId: number, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBasePersonalPageControllerPersonalPageWithHttpInfo(profileId, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single PersonalPage
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBasePersonalPageControllerPersonalPageWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBasePersonalPageControllerPersonalPage(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBasePersonalPageControllerPersonalPageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single PersonalPage
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBasePersonalPageControllerPersonalPage(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBasePersonalPageControllerPersonalPageWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     */
    public listByCurrentProfile0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.listByCurrentProfile0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.listByCurrentProfile0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public listByCurrentProfile0(_options?: ConfigurationOptions): Observable<any> {
        return this.listByCurrentProfile0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single PersonalPage
     * @param id
     * @param body
     */
    public updateOneBasePersonalPageControllerPersonalPageWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBasePersonalPageControllerPersonalPage(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBasePersonalPageControllerPersonalPageWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single PersonalPage
     * @param id
     * @param body
     */
    public updateOneBasePersonalPageControllerPersonalPage(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBasePersonalPageControllerPersonalPageWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ProductApiRequestFactory, ProductApiResponseProcessor} from "../apis/ProductApi";
export class ObservableProductApi {
    private requestFactory: ProductApiRequestFactory;
    private responseProcessor: ProductApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ProductApiRequestFactory,
        responseProcessor?: ProductApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ProductApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ProductApiResponseProcessor();
    }

    /**
     * Returns an array of product that can buy current user
     * @param type
     * @param locale
     */
    public findAll0WithHttpInfo(type: 'VACANCY' | 'PROFILE' | 'CV_CONTACTS_OPEN', locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu', _options?: ConfigurationOptions): Observable<HttpInfo<Array<ProductEntity>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findAll0(type, locale, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findAll0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns an array of product that can buy current user
     * @param type
     * @param locale
     */
    public findAll0(type: 'VACANCY' | 'PROFILE' | 'CV_CONTACTS_OPEN', locale: 'af' | 'ak' | 'am' | 'ar' | 'as' | 'az' | 'be' | 'bg' | 'bm' | 'bn' | 'bo' | 'br' | 'bs' | 'ca' | 'ce' | 'co' | 'cs' | 'cu' | 'cy' | 'da' | 'de' | 'de_AT' | 'de_CH' | 'dz' | 'ee' | 'el' | 'en' | 'en_AU' | 'en_CA' | 'en_GB' | 'en_US' | 'eo' | 'es' | 'es_ES' | 'es_MX' | 'et' | 'eu' | 'fa' | 'fa_AF' | 'ff' | 'fi' | 'fo' | 'fr' | 'fr_CA' | 'fr_CH' | 'fy' | 'ga' | 'gd' | 'gl' | 'gu' | 'gv' | 'ha' | 'he' | 'hi' | 'hr' | 'ht' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'ii' | 'is' | 'it' | 'ja' | 'jv' | 'ka' | 'ki' | 'kk' | 'kl' | 'km' | 'kn' | 'ko' | 'ks' | 'ku' | 'kw' | 'ky' | 'la' | 'lb' | 'lg' | 'ln' | 'lo' | 'lt' | 'lu' | 'lv' | 'mg' | 'mi' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'mt' | 'my' | 'nb' | 'nd' | 'ne' | 'nl' | 'nl_BE' | 'nn' | 'ny' | 'om' | 'or' | 'os' | 'pa' | 'pl' | 'ps' | 'pt' | 'pt_BR' | 'pt_PT' | 'qu' | 'rm' | 'rn' | 'ro' | 'ro_MD' | 'ru' | 'rw' | 'sa' | 'sd' | 'se' | 'sg' | 'si' | 'sk' | 'sl' | 'sm' | 'sn' | 'so' | 'sq' | 'sr' | 'st' | 'su' | 'sv' | 'sw' | 'sw_CD' | 'ta' | 'te' | 'tg' | 'th' | 'ti' | 'tk' | 'to' | 'tr' | 'tt' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'vo' | 'wo' | 'xh' | 'yi' | 'yo' | 'zh' | 'zh_Hans' | 'zh_Hant' | 'zu', _options?: ConfigurationOptions): Observable<Array<ProductEntity>> {
        return this.findAll0WithHttpInfo(type, locale, _options).pipe(map((apiResponse: HttpInfo<Array<ProductEntity>>) => apiResponse.data));
    }

    /**
     * Returns a product that can buy current user
     * @param id
     * @param [promoCode]
     */
    public findById0WithHttpInfo(id: number, promoCode?: string, _options?: ConfigurationOptions): Observable<HttpInfo<ProductEntity>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findById0(id, promoCode, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findById0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns a product that can buy current user
     * @param id
     * @param [promoCode]
     */
    public findById0(id: number, promoCode?: string, _options?: ConfigurationOptions): Observable<ProductEntity> {
        return this.findById0WithHttpInfo(id, promoCode, _options).pipe(map((apiResponse: HttpInfo<ProductEntity>) => apiResponse.data));
    }

    /**
     * Returns localization for requested product types
     * @param language
     */
    public findLocalization0WithHttpInfo(language: string, _options?: ConfigurationOptions): Observable<HttpInfo<Array<ProductLocalizationDTO>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findLocalization0(language, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findLocalization0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns localization for requested product types
     * @param language
     */
    public findLocalization0(language: string, _options?: ConfigurationOptions): Observable<Array<ProductLocalizationDTO>> {
        return this.findLocalization0WithHttpInfo(language, _options).pipe(map((apiResponse: HttpInfo<Array<ProductLocalizationDTO>>) => apiResponse.data));
    }

    /**
     * Returns the availability of gift promotion for the current user
     */
    public getGiftPromotionAvailability0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<GiftPromotionAvailabilityDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getGiftPromotionAvailability0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getGiftPromotionAvailability0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns the availability of gift promotion for the current user
     */
    public getGiftPromotionAvailability0(_options?: ConfigurationOptions): Observable<GiftPromotionAvailabilityDTO> {
        return this.getGiftPromotionAvailability0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<GiftPromotionAvailabilityDTO>) => apiResponse.data));
    }

}

import { ProfilePromoCodesApiRequestFactory, ProfilePromoCodesApiResponseProcessor} from "../apis/ProfilePromoCodesApi";
export class ObservableProfilePromoCodesApi {
    private requestFactory: ProfilePromoCodesApiRequestFactory;
    private responseProcessor: ProfilePromoCodesApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ProfilePromoCodesApiRequestFactory,
        responseProcessor?: ProfilePromoCodesApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ProfilePromoCodesApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ProfilePromoCodesApiResponseProcessor();
    }

    /**
     * Cancel a promo code
     * @param code
     */
    public cancelPromoCode0WithHttpInfo(code: string, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.cancelPromoCode0(code, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.cancelPromoCode0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Cancel a promo code
     * @param code
     */
    public cancelPromoCode0(code: string, _options?: ConfigurationOptions): Observable<void> {
        return this.cancelPromoCode0WithHttpInfo(code, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Get available promo codes for the user
     * @param [limit]
     * @param [page]
     * @param [query]
     */
    public getAvailablePromoCodes0WithHttpInfo(limit?: number, page?: number, query?: PromoCodeListQueryPaginationDTO, _options?: ConfigurationOptions): Observable<HttpInfo<PromoCodeListResponseDto>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getAvailablePromoCodes0(limit, page, query, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getAvailablePromoCodes0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Get available promo codes for the user
     * @param [limit]
     * @param [page]
     * @param [query]
     */
    public getAvailablePromoCodes0(limit?: number, page?: number, query?: PromoCodeListQueryPaginationDTO, _options?: ConfigurationOptions): Observable<PromoCodeListResponseDto> {
        return this.getAvailablePromoCodes0WithHttpInfo(limit, page, query, _options).pipe(map((apiResponse: HttpInfo<PromoCodeListResponseDto>) => apiResponse.data));
    }

    /**
     * Get promo code
     * @param code
     */
    public getPromoCode0WithHttpInfo(code: string, _options?: ConfigurationOptions): Observable<HttpInfo<PromoCodeResponseDto>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getPromoCode0(code, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getPromoCode0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Get promo code
     * @param code
     */
    public getPromoCode0(code: string, _options?: ConfigurationOptions): Observable<PromoCodeResponseDto> {
        return this.getPromoCode0WithHttpInfo(code, _options).pipe(map((apiResponse: HttpInfo<PromoCodeResponseDto>) => apiResponse.data));
    }

}

import { ProfileStatsApiRequestFactory, ProfileStatsApiResponseProcessor} from "../apis/ProfileStatsApi";
export class ObservableProfileStatsApi {
    private requestFactory: ProfileStatsApiRequestFactory;
    private responseProcessor: ProfileStatsApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ProfileStatsApiRequestFactory,
        responseProcessor?: ProfileStatsApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ProfileStatsApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ProfileStatsApiResponseProcessor();
    }

    /**
     */
    public getProfileStats0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<ProfileStatsDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getProfileStats0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getProfileStats0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public getProfileStats0(_options?: ConfigurationOptions): Observable<ProfileStatsDTO> {
        return this.getProfileStats0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<ProfileStatsDTO>) => apiResponse.data));
    }

}

import { ProfilesManagingApiRequestFactory, ProfilesManagingApiResponseProcessor} from "../apis/ProfilesManagingApi";
export class ObservableProfilesManagingApi {
    private requestFactory: ProfilesManagingApiRequestFactory;
    private responseProcessor: ProfilesManagingApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ProfilesManagingApiRequestFactory,
        responseProcessor?: ProfilesManagingApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ProfilesManagingApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ProfilesManagingApiResponseProcessor();
    }

    /**
     * Returns an existing profile.
     * @param profileId Unique identifier of profile to process.
     * @param [lang] Specific language code for query.
     */
    public findOne0WithHttpInfo(profileId: number, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<HttpInfo<ProfileResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findOne0(profileId, lang, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findOne0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Returns an existing profile.
     * @param profileId Unique identifier of profile to process.
     * @param [lang] Specific language code for query.
     */
    public findOne0(profileId: number, lang?: 'en' | 'ru' | 'uk', _options?: ConfigurationOptions): Observable<ProfileResponseDTO> {
        return this.findOne0WithHttpInfo(profileId, lang, _options).pipe(map((apiResponse: HttpInfo<ProfileResponseDTO>) => apiResponse.data));
    }

    /**
     * Updates an existing profile.
     * @param profileId Unique identifier of profile to process.
     * @param profileUpdateDTO
     */
    public updateOne0WithHttpInfo(profileId: number, profileUpdateDTO: ProfileUpdateDTO, _options?: ConfigurationOptions): Observable<HttpInfo<ProfileResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOne0(profileId, profileUpdateDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOne0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Updates an existing profile.
     * @param profileId Unique identifier of profile to process.
     * @param profileUpdateDTO
     */
    public updateOne0(profileId: number, profileUpdateDTO: ProfileUpdateDTO, _options?: ConfigurationOptions): Observable<ProfileResponseDTO> {
        return this.updateOne0WithHttpInfo(profileId, profileUpdateDTO, _options).pipe(map((apiResponse: HttpInfo<ProfileResponseDTO>) => apiResponse.data));
    }

    /**
     * Updates an existing profile.
     * @param profileId Unique identifier of profile to process.
     * @param [file] File to upload
     */
    public updateOneAvatar0WithHttpInfo(profileId: number, file?: HttpFile, _options?: ConfigurationOptions): Observable<HttpInfo<ProfileResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneAvatar0(profileId, file, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneAvatar0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Updates an existing profile.
     * @param profileId Unique identifier of profile to process.
     * @param [file] File to upload
     */
    public updateOneAvatar0(profileId: number, file?: HttpFile, _options?: ConfigurationOptions): Observable<ProfileResponseDTO> {
        return this.updateOneAvatar0WithHttpInfo(profileId, file, _options).pipe(map((apiResponse: HttpInfo<ProfileResponseDTO>) => apiResponse.data));
    }

    /**
     * Updates an existing profile.
     * @param profileId Unique identifier of profile to process.
     * @param [file] File to upload
     */
    public updateOneAvatar0_1WithHttpInfo(profileId: number, file?: HttpFile, _options?: ConfigurationOptions): Observable<HttpInfo<ProfileResponseDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneAvatar0_1(profileId, file, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneAvatar0_1WithHttpInfo(rsp)));
            }));
    }

    /**
     * Updates an existing profile.
     * @param profileId Unique identifier of profile to process.
     * @param [file] File to upload
     */
    public updateOneAvatar0_1(profileId: number, file?: HttpFile, _options?: ConfigurationOptions): Observable<ProfileResponseDTO> {
        return this.updateOneAvatar0_1WithHttpInfo(profileId, file, _options).pipe(map((apiResponse: HttpInfo<ProfileResponseDTO>) => apiResponse.data));
    }

}

import { ProposalApiRequestFactory, ProposalApiResponseProcessor} from "../apis/ProposalApi";
export class ObservableProposalApi {
    private requestFactory: ProposalApiRequestFactory;
    private responseProcessor: ProposalApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ProposalApiRequestFactory,
        responseProcessor?: ProposalApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ProposalApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ProposalApiResponseProcessor();
    }

    /**
     * Create a single Proposal
     * @param body
     */
    public createOneBaseProposalControllerProposalWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseProposalControllerProposal(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseProposalControllerProposalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Proposal
     * @param body
     */
    public createOneBaseProposalControllerProposal(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseProposalControllerProposalWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single Proposal
     * @param id
     */
    public deleteOneBaseProposalControllerProposalWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseProposalControllerProposal(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseProposalControllerProposalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single Proposal
     * @param id
     */
    public deleteOneBaseProposalControllerProposal(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.deleteOneBaseProposalControllerProposalWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Proposals
     * @param lang
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseProposalControllerProposalWithHttpInfo(lang: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseProposalControllerProposal(lang, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseProposalControllerProposalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Proposals
     * @param lang
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseProposalControllerProposal(lang: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.getManyBaseProposalControllerProposalWithHttpInfo(lang, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Retrieve a single Proposal
     * @param lang
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseProposalControllerProposalWithHttpInfo(lang: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseProposalControllerProposal(lang, id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseProposalControllerProposalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Proposal
     * @param lang
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseProposalControllerProposal(lang: string, id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseProposalControllerProposalWithHttpInfo(lang, id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single Proposal
     * @param id
     * @param body
     */
    public updateOneBaseProposalControllerProposalWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseProposalControllerProposal(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseProposalControllerProposalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single Proposal
     * @param id
     * @param body
     */
    public updateOneBaseProposalControllerProposal(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseProposalControllerProposalWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { ServiceCategoryApiRequestFactory, ServiceCategoryApiResponseProcessor} from "../apis/ServiceCategoryApi";
export class ObservableServiceCategoryApi {
    private requestFactory: ServiceCategoryApiRequestFactory;
    private responseProcessor: ServiceCategoryApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ServiceCategoryApiRequestFactory,
        responseProcessor?: ServiceCategoryApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ServiceCategoryApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ServiceCategoryApiResponseProcessor();
    }

    /**
     * @param id
     * @param lang
     */
    public findById0WithHttpInfo(id: number, lang: string, _options?: ConfigurationOptions): Observable<HttpInfo<ServiceCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findById0(id, lang, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findById0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     * @param lang
     */
    public findById0(id: number, lang: string, _options?: ConfigurationOptions): Observable<ServiceCategory> {
        return this.findById0WithHttpInfo(id, lang, _options).pipe(map((apiResponse: HttpInfo<ServiceCategory>) => apiResponse.data));
    }

    /**
     */
    public list0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.list0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.list0WithHttpInfo(rsp)));
            }));
    }

    /**
     */
    public list0(_options?: ConfigurationOptions): Observable<Array<any>> {
        return this.list0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

}

import { ServiceCategoryAdminApiRequestFactory, ServiceCategoryAdminApiResponseProcessor} from "../apis/ServiceCategoryAdminApi";
export class ObservableServiceCategoryAdminApi {
    private requestFactory: ServiceCategoryAdminApiRequestFactory;
    private responseProcessor: ServiceCategoryAdminApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: ServiceCategoryAdminApiRequestFactory,
        responseProcessor?: ServiceCategoryAdminApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new ServiceCategoryAdminApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new ServiceCategoryAdminApiResponseProcessor();
    }

    /**
     * Create multiple ServiceCategories
     * @param createManyServiceCategoryDto
     */
    public createManyBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(createManyServiceCategoryDto: CreateManyServiceCategoryDto, _options?: ConfigurationOptions): Observable<HttpInfo<Array<ServiceCategory>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createManyBaseServiceCategoryAdminControllerServiceCategory(createManyServiceCategoryDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createManyBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create multiple ServiceCategories
     * @param createManyServiceCategoryDto
     */
    public createManyBaseServiceCategoryAdminControllerServiceCategory(createManyServiceCategoryDto: CreateManyServiceCategoryDto, _options?: ConfigurationOptions): Observable<Array<ServiceCategory>> {
        return this.createManyBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(createManyServiceCategoryDto, _options).pipe(map((apiResponse: HttpInfo<Array<ServiceCategory>>) => apiResponse.data));
    }

    /**
     * Create a single ServiceCategory
     * @param serviceCategory
     */
    public createOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(serviceCategory: ServiceCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ServiceCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseServiceCategoryAdminControllerServiceCategory(serviceCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single ServiceCategory
     * @param serviceCategory
     */
    public createOneBaseServiceCategoryAdminControllerServiceCategory(serviceCategory: ServiceCategory, _options?: ConfigurationOptions): Observable<ServiceCategory> {
        return this.createOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(serviceCategory, _options).pipe(map((apiResponse: HttpInfo<ServiceCategory>) => apiResponse.data));
    }

    /**
     * Delete a single ServiceCategory
     * @param id
     */
    public deleteOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseServiceCategoryAdminControllerServiceCategory(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single ServiceCategory
     * @param id
     */
    public deleteOneBaseServiceCategoryAdminControllerServiceCategory(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple ServiceCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseServiceCategoryAdminControllerServiceCategory200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseServiceCategoryAdminControllerServiceCategory(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple ServiceCategories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseServiceCategoryAdminControllerServiceCategory(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseServiceCategoryAdminControllerServiceCategory200Response> {
        return this.getManyBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseServiceCategoryAdminControllerServiceCategory200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single ServiceCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<ServiceCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseServiceCategoryAdminControllerServiceCategory(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single ServiceCategory
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseServiceCategoryAdminControllerServiceCategory(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<ServiceCategory> {
        return this.getOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<ServiceCategory>) => apiResponse.data));
    }

    /**
     * Replace a single ServiceCategory
     * @param id
     * @param serviceCategory
     */
    public replaceOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(id: number, serviceCategory: ServiceCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ServiceCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseServiceCategoryAdminControllerServiceCategory(id, serviceCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single ServiceCategory
     * @param id
     * @param serviceCategory
     */
    public replaceOneBaseServiceCategoryAdminControllerServiceCategory(id: number, serviceCategory: ServiceCategory, _options?: ConfigurationOptions): Observable<ServiceCategory> {
        return this.replaceOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(id, serviceCategory, _options).pipe(map((apiResponse: HttpInfo<ServiceCategory>) => apiResponse.data));
    }

    /**
     * Update a single ServiceCategory
     * @param id
     * @param serviceCategory
     */
    public updateOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(id: number, serviceCategory: ServiceCategory, _options?: ConfigurationOptions): Observable<HttpInfo<ServiceCategory>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseServiceCategoryAdminControllerServiceCategory(id, serviceCategory, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single ServiceCategory
     * @param id
     * @param serviceCategory
     */
    public updateOneBaseServiceCategoryAdminControllerServiceCategory(id: number, serviceCategory: ServiceCategory, _options?: ConfigurationOptions): Observable<ServiceCategory> {
        return this.updateOneBaseServiceCategoryAdminControllerServiceCategoryWithHttpInfo(id, serviceCategory, _options).pipe(map((apiResponse: HttpInfo<ServiceCategory>) => apiResponse.data));
    }

}

import { SkillApiRequestFactory, SkillApiResponseProcessor} from "../apis/SkillApi";
export class ObservableSkillApi {
    private requestFactory: SkillApiRequestFactory;
    private responseProcessor: SkillApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: SkillApiRequestFactory,
        responseProcessor?: SkillApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new SkillApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new SkillApiResponseProcessor();
    }

    /**
     * Create a single Skill
     * @param body
     */
    public createOneBaseSkillControllerSkillWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseSkillControllerSkill(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseSkillControllerSkillWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single Skill
     * @param body
     */
    public createOneBaseSkillControllerSkill(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseSkillControllerSkillWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve multiple Skills
     * @param categories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseSkillControllerSkillWithHttpInfo(categories: Array<string>, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseSkillControllerSkill(categories, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseSkillControllerSkillWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Skills
     * @param categories
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseSkillControllerSkill(categories: Array<string>, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseSkillControllerSkillWithHttpInfo(categories, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single Skill
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseSkillControllerSkillWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseSkillControllerSkill(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseSkillControllerSkillWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Skill
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseSkillControllerSkill(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseSkillControllerSkillWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { SourceApiRequestFactory, SourceApiResponseProcessor} from "../apis/SourceApi";
export class ObservableSourceApi {
    private requestFactory: SourceApiRequestFactory;
    private responseProcessor: SourceApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: SourceApiRequestFactory,
        responseProcessor?: SourceApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new SourceApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new SourceApiResponseProcessor();
    }

    /**
     * Retrieve multiple Sources
     * @param search
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseSourceControllerSourceWithHttpInfo(search: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseSourceControllerSource(search, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseSourceControllerSourceWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Sources
     * @param search
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseSourceControllerSource(search: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseSourceControllerSourceWithHttpInfo(search, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single Source
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseSourceControllerSourceWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseSourceControllerSource(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseSourceControllerSourceWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Source
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseSourceControllerSource(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseSourceControllerSourceWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { StoryApiRequestFactory, StoryApiResponseProcessor} from "../apis/StoryApi";
export class ObservableStoryApi {
    private requestFactory: StoryApiRequestFactory;
    private responseProcessor: StoryApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: StoryApiRequestFactory,
        responseProcessor?: StoryApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new StoryApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new StoryApiResponseProcessor();
    }

    /**
     * @param id
     */
    public findById0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findById0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findById0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public findById0(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.findById0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * @param limit
     * @param page
     */
    public listByProfile0WithHttpInfo(limit: number, page: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.listByProfile0(limit, page, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.listByProfile0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param limit
     * @param page
     */
    public listByProfile0(limit: number, page: number, _options?: ConfigurationOptions): Observable<void> {
        return this.listByProfile0WithHttpInfo(limit, page, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

}

import { StoryBlockAdminApiRequestFactory, StoryBlockAdminApiResponseProcessor} from "../apis/StoryBlockAdminApi";
export class ObservableStoryBlockAdminApi {
    private requestFactory: StoryBlockAdminApiRequestFactory;
    private responseProcessor: StoryBlockAdminApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: StoryBlockAdminApiRequestFactory,
        responseProcessor?: StoryBlockAdminApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new StoryBlockAdminApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new StoryBlockAdminApiResponseProcessor();
    }

    /**
     * Create a single StoryBlock
     * @param body
     */
    public createOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOneBaseStoryBlockAdminControllerStoryBlock(body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a single StoryBlock
     * @param body
     */
    public createOneBaseStoryBlockAdminControllerStoryBlock(body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.createOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a single StoryBlock
     * @param id
     */
    public deleteOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.deleteOneBaseStoryBlockAdminControllerStoryBlock(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.deleteOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a single StoryBlock
     * @param id
     */
    public deleteOneBaseStoryBlockAdminControllerStoryBlock(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.deleteOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Retrieve multiple StoryBlocks
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<GetManyBaseStoryBlockAdminControllerStoryBlock200Response>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseStoryBlockAdminControllerStoryBlock(fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple StoryBlocks
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseStoryBlockAdminControllerStoryBlock(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<GetManyBaseStoryBlockAdminControllerStoryBlock200Response> {
        return this.getManyBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<GetManyBaseStoryBlockAdminControllerStoryBlock200Response>) => apiResponse.data));
    }

    /**
     * Retrieve a single StoryBlock
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseStoryBlockAdminControllerStoryBlock(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single StoryBlock
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseStoryBlockAdminControllerStoryBlock(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Replace a single StoryBlock
     * @param id
     * @param body
     */
    public replaceOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.replaceOneBaseStoryBlockAdminControllerStoryBlock(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.replaceOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Replace a single StoryBlock
     * @param id
     * @param body
     */
    public replaceOneBaseStoryBlockAdminControllerStoryBlock(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.replaceOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Update a single StoryBlock
     * @param id
     * @param body
     */
    public updateOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(id: number, body: any, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.updateOneBaseStoryBlockAdminControllerStoryBlock(id, body, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.updateOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a single StoryBlock
     * @param id
     * @param body
     */
    public updateOneBaseStoryBlockAdminControllerStoryBlock(id: number, body: any, _options?: ConfigurationOptions): Observable<any> {
        return this.updateOneBaseStoryBlockAdminControllerStoryBlockWithHttpInfo(id, body, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { TransactionGetTotalAmountApiRequestFactory, TransactionGetTotalAmountApiResponseProcessor} from "../apis/TransactionGetTotalAmountApi";
export class ObservableTransactionGetTotalAmountApi {
    private requestFactory: TransactionGetTotalAmountApiRequestFactory;
    private responseProcessor: TransactionGetTotalAmountApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: TransactionGetTotalAmountApiRequestFactory,
        responseProcessor?: TransactionGetTotalAmountApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new TransactionGetTotalAmountApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new TransactionGetTotalAmountApiResponseProcessor();
    }

    /**
     * @param getTransactionTotalAmountRequestDto
     */
    public getTransactionGetTotalAmount0WithHttpInfo(getTransactionTotalAmountRequestDto: GetTransactionTotalAmountRequestDto, _options?: ConfigurationOptions): Observable<HttpInfo<GetTransactionTotalAmountResponseDto>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getTransactionGetTotalAmount0(getTransactionTotalAmountRequestDto, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getTransactionGetTotalAmount0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param getTransactionTotalAmountRequestDto
     */
    public getTransactionGetTotalAmount0(getTransactionTotalAmountRequestDto: GetTransactionTotalAmountRequestDto, _options?: ConfigurationOptions): Observable<GetTransactionTotalAmountResponseDto> {
        return this.getTransactionGetTotalAmount0WithHttpInfo(getTransactionTotalAmountRequestDto, _options).pipe(map((apiResponse: HttpInfo<GetTransactionTotalAmountResponseDto>) => apiResponse.data));
    }

}

import { UtilsProfileApiRequestFactory, UtilsProfileApiResponseProcessor} from "../apis/UtilsProfileApi";
export class ObservableUtilsProfileApi {
    private requestFactory: UtilsProfileApiRequestFactory;
    private responseProcessor: UtilsProfileApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: UtilsProfileApiRequestFactory,
        responseProcessor?: UtilsProfileApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new UtilsProfileApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new UtilsProfileApiResponseProcessor();
    }

    /**
     * @param email Profile email.
     */
    public get0WithHttpInfo(email: string, _options?: ConfigurationOptions): Observable<HttpInfo<UtilsProfileCompletedDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.get0(email, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.get0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param email Profile email.
     */
    public get0(email: string, _options?: ConfigurationOptions): Observable<UtilsProfileCompletedDTO> {
        return this.get0WithHttpInfo(email, _options).pipe(map((apiResponse: HttpInfo<UtilsProfileCompletedDTO>) => apiResponse.data));
    }

}

import { VacancyApiRequestFactory, VacancyApiResponseProcessor} from "../apis/VacancyApi";
export class ObservableVacancyApi {
    private requestFactory: VacancyApiRequestFactory;
    private responseProcessor: VacancyApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: VacancyApiRequestFactory,
        responseProcessor?: VacancyApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new VacancyApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new VacancyApiResponseProcessor();
    }

    /**
     * Add a vacancy to blacklist
     * @param id Vacancy ID
     */
    public addToBlacklist0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.addToBlacklist0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.addToBlacklist0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Add a vacancy to blacklist
     * @param id Vacancy ID
     */
    public addToBlacklist0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.addToBlacklist0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Save a vacancy
     * @param id Vacancy ID
     */
    public addToSaved0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.addToSaved0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.addToSaved0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Save a vacancy
     * @param id Vacancy ID
     */
    public addToSaved0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.addToSaved0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Create a new vacancy
     * @param vacancyBodyDTO
     */
    public createOne0WithHttpInfo(vacancyBodyDTO: VacancyBodyDTO, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.createOne0(vacancyBodyDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.createOne0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Create a new vacancy
     * @param vacancyBodyDTO
     */
    public createOne0(vacancyBodyDTO: VacancyBodyDTO, _options?: ConfigurationOptions): Observable<any> {
        return this.createOne0WithHttpInfo(vacancyBodyDTO, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Delete a vacancy
     * @param id Vacancy ID
     */
    public delete0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.delete0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.delete0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Delete a vacancy
     * @param id Vacancy ID
     */
    public delete0(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.delete0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Get all vacancies
     * @param [ids]
     * @param [sort]
     * @param [savedByCurrentProfile]
     * @param [categories]
     * @param [skills]
     * @param [verticals]
     * @param [geos]
     * @param [sources]
     * @param [countries]
     * @param [cities]
     * @param [search]
     * @param [searchCompany]
     * @param [exclude]
     * @param [currency]
     * @param [employment]
     * @param [schedule]
     * @param [experience]
     * @param [compensation]
     * @param [gybridCurrency]
     * @param [pieceworkCurrency]
     * @param [searchIn]
     * @param [salaryMin]
     * @param [salaryMax]
     * @param [pieceworkSalaryMin]
     * @param [pieceworkSalaryMax]
     * @param [commissionMin]
     * @param [commissionMax]
     * @param [gybridSalaryMin]
     * @param [gybridSalaryMax]
     * @param [gybridCommissionMin]
     * @param [gybridCommissionMax]
     * @param [forLastNumberOfDays]
     * @param [isRemote]
     * @param [s]
     * @param [limit]
     * @param [page]
     * @param [query]
     */
    public findAll0WithHttpInfo(ids?: Array<number>, sort?: string, savedByCurrentProfile?: any, categories?: Array<number>, skills?: Array<number>, verticals?: Array<number>, geos?: Array<number>, sources?: Array<number>, countries?: Array<number>, cities?: Array<number>, search?: string, searchCompany?: string, exclude?: string, currency?: string, employment?: Array<'fullTime' | 'partTime' | 'project'>, schedule?: Array<'fullDay' | 'flexible' | 'remote'>, experience?: Array<'noExperience' | 'from1to3' | 'from3to6' | 'from6'>, compensation?: Array<'salary' | 'commission' | 'gybrid' | 'piecework' | 'contract'>, gybridCurrency?: string, pieceworkCurrency?: string, searchIn?: any, salaryMin?: number, salaryMax?: number, pieceworkSalaryMin?: number, pieceworkSalaryMax?: number, commissionMin?: number, commissionMax?: number, gybridSalaryMin?: number, gybridSalaryMax?: number, gybridCommissionMin?: number, gybridCommissionMax?: number, forLastNumberOfDays?: number, isRemote?: boolean, s?: any, limit?: number, page?: number, query?: VacancyQueryManyDTO, _options?: ConfigurationOptions): Observable<HttpInfo<VacancyPaginationDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findAll0(ids, sort, savedByCurrentProfile, categories, skills, verticals, geos, sources, countries, cities, search, searchCompany, exclude, currency, employment, schedule, experience, compensation, gybridCurrency, pieceworkCurrency, searchIn, salaryMin, salaryMax, pieceworkSalaryMin, pieceworkSalaryMax, commissionMin, commissionMax, gybridSalaryMin, gybridSalaryMax, gybridCommissionMin, gybridCommissionMax, forLastNumberOfDays, isRemote, s, limit, page, query, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findAll0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Get all vacancies
     * @param [ids]
     * @param [sort]
     * @param [savedByCurrentProfile]
     * @param [categories]
     * @param [skills]
     * @param [verticals]
     * @param [geos]
     * @param [sources]
     * @param [countries]
     * @param [cities]
     * @param [search]
     * @param [searchCompany]
     * @param [exclude]
     * @param [currency]
     * @param [employment]
     * @param [schedule]
     * @param [experience]
     * @param [compensation]
     * @param [gybridCurrency]
     * @param [pieceworkCurrency]
     * @param [searchIn]
     * @param [salaryMin]
     * @param [salaryMax]
     * @param [pieceworkSalaryMin]
     * @param [pieceworkSalaryMax]
     * @param [commissionMin]
     * @param [commissionMax]
     * @param [gybridSalaryMin]
     * @param [gybridSalaryMax]
     * @param [gybridCommissionMin]
     * @param [gybridCommissionMax]
     * @param [forLastNumberOfDays]
     * @param [isRemote]
     * @param [s]
     * @param [limit]
     * @param [page]
     * @param [query]
     */
    public findAll0(ids?: Array<number>, sort?: string, savedByCurrentProfile?: any, categories?: Array<number>, skills?: Array<number>, verticals?: Array<number>, geos?: Array<number>, sources?: Array<number>, countries?: Array<number>, cities?: Array<number>, search?: string, searchCompany?: string, exclude?: string, currency?: string, employment?: Array<'fullTime' | 'partTime' | 'project'>, schedule?: Array<'fullDay' | 'flexible' | 'remote'>, experience?: Array<'noExperience' | 'from1to3' | 'from3to6' | 'from6'>, compensation?: Array<'salary' | 'commission' | 'gybrid' | 'piecework' | 'contract'>, gybridCurrency?: string, pieceworkCurrency?: string, searchIn?: any, salaryMin?: number, salaryMax?: number, pieceworkSalaryMin?: number, pieceworkSalaryMax?: number, commissionMin?: number, commissionMax?: number, gybridSalaryMin?: number, gybridSalaryMax?: number, gybridCommissionMin?: number, gybridCommissionMax?: number, forLastNumberOfDays?: number, isRemote?: boolean, s?: any, limit?: number, page?: number, query?: VacancyQueryManyDTO, _options?: ConfigurationOptions): Observable<VacancyPaginationDTO> {
        return this.findAll0WithHttpInfo(ids, sort, savedByCurrentProfile, categories, skills, verticals, geos, sources, countries, cities, search, searchCompany, exclude, currency, employment, schedule, experience, compensation, gybridCurrency, pieceworkCurrency, searchIn, salaryMin, salaryMax, pieceworkSalaryMin, pieceworkSalaryMax, commissionMin, commissionMax, gybridSalaryMin, gybridSalaryMax, gybridCommissionMin, gybridCommissionMax, forLastNumberOfDays, isRemote, s, limit, page, query, _options).pipe(map((apiResponse: HttpInfo<VacancyPaginationDTO>) => apiResponse.data));
    }

    /**
     * Get vacancies for current user
     */
    public findAllByCurrentProfile0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findAllByCurrentProfile0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findAllByCurrentProfile0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Get vacancies for current user
     */
    public findAllByCurrentProfile0(_options?: ConfigurationOptions): Observable<Array<any>> {
        return this.findAllByCurrentProfile0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Get a vacancy by ID
     * @param id Vacancy ID
     */
    public findOne0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.findOne0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.findOne0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Get a vacancy by ID
     * @param id Vacancy ID
     */
    public findOne0(id: number, _options?: ConfigurationOptions): Observable<any> {
        return this.findOne0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Remove a vacancy from saved
     * @param id Vacancy ID
     */
    public getFromSaved0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getFromSaved0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getFromSaved0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Remove a vacancy from saved
     * @param id Vacancy ID
     */
    public getFromSaved0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.getFromSaved0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Get views for a vacancy
     * @param id Vacancy ID
     * @param [data]
     */
    public getViews0WithHttpInfo(id: number, data?: any, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getViews0(id, data, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getViews0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Get views for a vacancy
     * @param id Vacancy ID
     * @param [data]
     */
    public getViews0(id: number, data?: any, _options?: ConfigurationOptions): Observable<void> {
        return this.getViews0WithHttpInfo(id, data, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Publish a vacancy
     * @param id Vacancy ID
     * @param productId Product id
     * @param [schedulePublishAt] date auto publication
     */
    public publish0WithHttpInfo(id: number, productId: number, schedulePublishAt?: Date, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.publish0(id, productId, schedulePublishAt, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.publish0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Publish a vacancy
     * @param id Vacancy ID
     * @param productId Product id
     * @param [schedulePublishAt] date auto publication
     */
    public publish0(id: number, productId: number, schedulePublishAt?: Date, _options?: ConfigurationOptions): Observable<any> {
        return this.publish0WithHttpInfo(id, productId, schedulePublishAt, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Remove a vacancy from blacklist
     * @param id Vacancy ID
     */
    public removeFromBlacklist0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.removeFromBlacklist0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.removeFromBlacklist0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Remove a vacancy from blacklist
     * @param id Vacancy ID
     */
    public removeFromBlacklist0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.removeFromBlacklist0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Remove a vacancy from saved
     * @param id Vacancy ID
     */
    public removeFromSaved0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.removeFromSaved0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.removeFromSaved0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Remove a vacancy from saved
     * @param id Vacancy ID
     */
    public removeFromSaved0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.removeFromSaved0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * @param id
     */
    public removePublish0WithHttpInfo(id: number, _options?: ConfigurationOptions): Observable<HttpInfo<void>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.removePublish0(id, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.removePublish0WithHttpInfo(rsp)));
            }));
    }

    /**
     * @param id
     */
    public removePublish0(id: number, _options?: ConfigurationOptions): Observable<void> {
        return this.removePublish0WithHttpInfo(id, _options).pipe(map((apiResponse: HttpInfo<void>) => apiResponse.data));
    }

    /**
     * Get salary statistics
     * @param [categories]
     * @param [skills]
     * @param [countries]
     * @param [cities]
     * @param [employment]
     * @param [schedule]
     * @param [compensation]
     * @param [experience]
     * @param [search]
     * @param [currency]
     * @param [isRemote]
     * @param [s]
     * @param [query]
     */
    public salaryStats0WithHttpInfo(categories?: Array<string>, skills?: Array<string>, countries?: Array<string>, cities?: Array<string>, employment?: Array<'fullTime' | 'partTime' | 'project'>, schedule?: Array<'fullDay' | 'flexible' | 'remote'>, compensation?: Array<'salary' | 'commission' | 'gybrid' | 'piecework' | 'contract'>, experience?: Array<'noExperience' | 'from1to3' | 'from3to6' | 'from6'>, search?: string, currency?: string, isRemote?: boolean, s?: any, query?: VacancyQueryStatsDTO, _options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.salaryStats0(categories, skills, countries, cities, employment, schedule, compensation, experience, search, currency, isRemote, s, query, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.salaryStats0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Get salary statistics
     * @param [categories]
     * @param [skills]
     * @param [countries]
     * @param [cities]
     * @param [employment]
     * @param [schedule]
     * @param [compensation]
     * @param [experience]
     * @param [search]
     * @param [currency]
     * @param [isRemote]
     * @param [s]
     * @param [query]
     */
    public salaryStats0(categories?: Array<string>, skills?: Array<string>, countries?: Array<string>, cities?: Array<string>, employment?: Array<'fullTime' | 'partTime' | 'project'>, schedule?: Array<'fullDay' | 'flexible' | 'remote'>, compensation?: Array<'salary' | 'commission' | 'gybrid' | 'piecework' | 'contract'>, experience?: Array<'noExperience' | 'from1to3' | 'from3to6' | 'from6'>, search?: string, currency?: string, isRemote?: boolean, s?: any, query?: VacancyQueryStatsDTO, _options?: ConfigurationOptions): Observable<Array<any>> {
        return this.salaryStats0WithHttpInfo(categories, skills, countries, cities, employment, schedule, compensation, experience, search, currency, isRemote, s, query, _options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Get stats for current user
     */
    public statsByCurrentProfile0WithHttpInfo(_options?: ConfigurationOptions): Observable<HttpInfo<Array<any>>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.statsByCurrentProfile0(_config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.statsByCurrentProfile0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Get stats for current user
     */
    public statsByCurrentProfile0(_options?: ConfigurationOptions): Observable<Array<any>> {
        return this.statsByCurrentProfile0WithHttpInfo(_options).pipe(map((apiResponse: HttpInfo<Array<any>>) => apiResponse.data));
    }

    /**
     * Get vacancy suggestions
     * @param search Search query
     */
    public suggest0WithHttpInfo(search: string, _options?: ConfigurationOptions): Observable<HttpInfo<VacancyPaginationDTO>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.suggest0(search, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.suggest0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Get vacancy suggestions
     * @param search Search query
     */
    public suggest0(search: string, _options?: ConfigurationOptions): Observable<VacancyPaginationDTO> {
        return this.suggest0WithHttpInfo(search, _options).pipe(map((apiResponse: HttpInfo<VacancyPaginationDTO>) => apiResponse.data));
    }

    /**
     * Update a vacancy
     * @param id Vacancy ID
     * @param vacancyBodyDTO
     */
    public update0WithHttpInfo(id: number, vacancyBodyDTO: VacancyBodyDTO, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.update0(id, vacancyBodyDTO, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.update0WithHttpInfo(rsp)));
            }));
    }

    /**
     * Update a vacancy
     * @param id Vacancy ID
     * @param vacancyBodyDTO
     */
    public update0(id: number, vacancyBodyDTO: VacancyBodyDTO, _options?: ConfigurationOptions): Observable<any> {
        return this.update0WithHttpInfo(id, vacancyBodyDTO, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}

import { VerticalApiRequestFactory, VerticalApiResponseProcessor} from "../apis/VerticalApi";
export class ObservableVerticalApi {
    private requestFactory: VerticalApiRequestFactory;
    private responseProcessor: VerticalApiResponseProcessor;
    private configuration: Configuration;

    public constructor(
        configuration: Configuration,
        requestFactory?: VerticalApiRequestFactory,
        responseProcessor?: VerticalApiResponseProcessor
    ) {
        this.configuration = configuration;
        this.requestFactory = requestFactory || new VerticalApiRequestFactory(configuration);
        this.responseProcessor = responseProcessor || new VerticalApiResponseProcessor();
    }

    /**
     * Retrieve multiple Verticals
     * @param search
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseVerticalControllerVerticalWithHttpInfo(search: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getManyBaseVerticalControllerVertical(search, fields, s, filter, or, sort, join, limit, offset, page, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getManyBaseVerticalControllerVerticalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve multiple Verticals
     * @param search
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getManyBaseVerticalControllerVertical(search: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getManyBaseVerticalControllerVerticalWithHttpInfo(search, fields, s, filter, or, sort, join, limit, offset, page, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

    /**
     * Retrieve a single Vertical
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseVerticalControllerVerticalWithHttpInfo(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<HttpInfo<any>> {
        const _config = mergeConfiguration(this.configuration, _options);

        const requestContextPromise = this.requestFactory.getOneBaseVerticalControllerVertical(id, fields, join, cache, _config);
        // build promise chain
        let middlewarePreObservable = from<RequestContext>(requestContextPromise);
        for (const middleware of _config.middleware) {
            middlewarePreObservable = middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => middleware.pre(ctx)));
        }

        return middlewarePreObservable.pipe(mergeMap((ctx: RequestContext) => _config.httpApi.send(ctx))).
            pipe(mergeMap((response: ResponseContext) => {
                let middlewarePostObservable = of(response);
                for (const middleware of _config.middleware.reverse()) {
                    middlewarePostObservable = middlewarePostObservable.pipe(mergeMap((rsp: ResponseContext) => middleware.post(rsp)));
                }
                return middlewarePostObservable.pipe(map((rsp: ResponseContext) => this.responseProcessor.getOneBaseVerticalControllerVerticalWithHttpInfo(rsp)));
            }));
    }

    /**
     * Retrieve a single Vertical
     * @param id
     * @param [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     */
    public getOneBaseVerticalControllerVertical(id: number, fields?: Array<string>, join?: Array<string>, cache?: number, _options?: ConfigurationOptions): Observable<any> {
        return this.getOneBaseVerticalControllerVerticalWithHttpInfo(id, fields, join, cache, _options).pipe(map((apiResponse: HttpInfo<any>) => apiResponse.data));
    }

}
